
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3663"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3663"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ih19M", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kyM0p"));

});
parcelRegister("kyM0p", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ef7c3885563104b0$export$ffb0004e005737fa; }, function (v) { return $ef7c3885563104b0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ef7c3885563104b0$export$34b9dba7ce09269b; }, function (v) { return $ef7c3885563104b0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ef7c3885563104b0$export$25062201e9e25d76; }, function (v) { return $ef7c3885563104b0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef7c3885563104b0$export$ffb0004e005737fa;
var $ef7c3885563104b0$export$34b9dba7ce09269b;
var $ef7c3885563104b0$export$25062201e9e25d76;
"use strict";
var $ef7c3885563104b0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $ef7c3885563104b0$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $ef7c3885563104b0$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$ef7c3885563104b0$export$ffb0004e005737fa = $ef7c3885563104b0$var$REACT_FRAGMENT_TYPE;
$ef7c3885563104b0$export$34b9dba7ce09269b = $ef7c3885563104b0$var$jsxProd;
$ef7c3885563104b0$export$25062201e9e25d76 = $ef7c3885563104b0$var$jsxProd;

});


parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bjR3q"));

});
parcelRegister("bjR3q", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $83da9f8ce41d3d63$export$9c16c1426311996d; }, function (v) { return $83da9f8ce41d3d63$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $83da9f8ce41d3d63$export$dca3b0875bd9a954; }, function (v) { return $83da9f8ce41d3d63$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $83da9f8ce41d3d63$export$16fa2f45be04daa8; }, function (v) { return $83da9f8ce41d3d63$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $83da9f8ce41d3d63$export$ffb0004e005737fa; }, function (v) { return $83da9f8ce41d3d63$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $83da9f8ce41d3d63$export$e2c29f18771995cb; }, function (v) { return $83da9f8ce41d3d63$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd; }, function (v) { return $83da9f8ce41d3d63$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $83da9f8ce41d3d63$export$5f8d39834fd61797; }, function (v) { return $83da9f8ce41d3d63$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5; }, function (v) { return $83da9f8ce41d3d63$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "ViewTransition", function () { return $83da9f8ce41d3d63$export$8cdaa4703948c5e9; }, function (v) { return $83da9f8ce41d3d63$export$8cdaa4703948c5e9 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce; }, function (v) { return $83da9f8ce41d3d63$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $83da9f8ce41d3d63$export$abd8e32b826d7ea7; }, function (v) { return $83da9f8ce41d3d63$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "addTransitionType", function () { return $83da9f8ce41d3d63$export$87c99536b1b8cdd8; }, function (v) { return $83da9f8ce41d3d63$export$87c99536b1b8cdd8 = v; });
$parcel$export(module.exports, "cache", function () { return $83da9f8ce41d3d63$export$69a3209f1a06c04d; }, function (v) { return $83da9f8ce41d3d63$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $83da9f8ce41d3d63$export$8c538325882c7eec; }, function (v) { return $83da9f8ce41d3d63$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $83da9f8ce41d3d63$export$e530037191fcd5d7; }, function (v) { return $83da9f8ce41d3d63$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109; }, function (v) { return $83da9f8ce41d3d63$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d; }, function (v) { return $83da9f8ce41d3d63$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43; }, function (v) { return $83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $83da9f8ce41d3d63$export$257a8862b851cb5b; }, function (v) { return $83da9f8ce41d3d63$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $83da9f8ce41d3d63$export$a8257692ac88316c; }, function (v) { return $83da9f8ce41d3d63$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $83da9f8ce41d3d63$export$488013bae63b21da; }, function (v) { return $83da9f8ce41d3d63$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $83da9f8ce41d3d63$export$7c73462e0d25e514; }, function (v) { return $83da9f8ce41d3d63$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $83da9f8ce41d3d63$export$7568632d0d33d16d; }, function (v) { return $83da9f8ce41d3d63$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8; }, function (v) { return $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $83da9f8ce41d3d63$export$1f96ae73734a86cc; }, function (v) { return $83da9f8ce41d3d63$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $83da9f8ce41d3d63$export$9a47ced3238df325; }, function (v) { return $83da9f8ce41d3d63$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $83da9f8ce41d3d63$export$35808ee640e87ca7; }, function (v) { return $83da9f8ce41d3d63$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $83da9f8ce41d3d63$export$fae74005e78b1a27; }, function (v) { return $83da9f8ce41d3d63$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e; }, function (v) { return $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf; }, function (v) { return $83da9f8ce41d3d63$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $83da9f8ce41d3d63$export$6d9c69b0de29b591; }, function (v) { return $83da9f8ce41d3d63$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $83da9f8ce41d3d63$export$7f54fc3180508a52; }, function (v) { return $83da9f8ce41d3d63$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $83da9f8ce41d3d63$export$f680877a34711e37; }, function (v) { return $83da9f8ce41d3d63$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $83da9f8ce41d3d63$export$d5a552a76deda3c2; }, function (v) { return $83da9f8ce41d3d63$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969; }, function (v) { return $83da9f8ce41d3d63$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c; }, function (v) { return $83da9f8ce41d3d63$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $83da9f8ce41d3d63$export$1538c33de8887b59; }, function (v) { return $83da9f8ce41d3d63$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $83da9f8ce41d3d63$export$fca7f784ae7a249a; }, function (v) { return $83da9f8ce41d3d63$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $83da9f8ce41d3d63$export$13e3392192263954; }, function (v) { return $83da9f8ce41d3d63$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca; }, function (v) { return $83da9f8ce41d3d63$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $83da9f8ce41d3d63$export$60241385465d0a34; }, function (v) { return $83da9f8ce41d3d63$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16; }, function (v) { return $83da9f8ce41d3d63$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf; }, function (v) { return $83da9f8ce41d3d63$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $83da9f8ce41d3d63$export$83d89fbfd8236492; }, function (v) { return $83da9f8ce41d3d63$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $83da9f8ce41d3d63$export$9c16c1426311996d;
var $83da9f8ce41d3d63$export$dca3b0875bd9a954;
var $83da9f8ce41d3d63$export$16fa2f45be04daa8;
var $83da9f8ce41d3d63$export$ffb0004e005737fa;
var $83da9f8ce41d3d63$export$e2c29f18771995cb;
var $83da9f8ce41d3d63$export$221d75b3f55bb0bd;
var $83da9f8ce41d3d63$export$5f8d39834fd61797;
var $83da9f8ce41d3d63$export$74bf444e3cd11ea5;
var $83da9f8ce41d3d63$export$8cdaa4703948c5e9;
var $83da9f8ce41d3d63$export$1ced07cd6b1985ce;
var $83da9f8ce41d3d63$export$abd8e32b826d7ea7;
var $83da9f8ce41d3d63$export$87c99536b1b8cdd8;
var $83da9f8ce41d3d63$export$69a3209f1a06c04d;
var $83da9f8ce41d3d63$export$8c538325882c7eec;
var $83da9f8ce41d3d63$export$e530037191fcd5d7;
var $83da9f8ce41d3d63$export$fd42f52fd3ae1109;
var $83da9f8ce41d3d63$export$c8a8987d4410bf2d;
var $83da9f8ce41d3d63$export$7d1e3a5e95ceca43;
var $83da9f8ce41d3d63$export$257a8862b851cb5b;
var $83da9f8ce41d3d63$export$a8257692ac88316c;
var $83da9f8ce41d3d63$export$488013bae63b21da;
var $83da9f8ce41d3d63$export$7c73462e0d25e514;
var $83da9f8ce41d3d63$export$7568632d0d33d16d;
var $83da9f8ce41d3d63$export$f93f40ac0ca7e3a8;
var $83da9f8ce41d3d63$export$1f96ae73734a86cc;
var $83da9f8ce41d3d63$export$9a47ced3238df325;
var $83da9f8ce41d3d63$export$35808ee640e87ca7;
var $83da9f8ce41d3d63$export$fae74005e78b1a27;
var $83da9f8ce41d3d63$export$dc8fbce3eb94dc1e;
var $83da9f8ce41d3d63$export$6a7bc4e911dc01cf;
var $83da9f8ce41d3d63$export$6d9c69b0de29b591;
var $83da9f8ce41d3d63$export$7f54fc3180508a52;
var $83da9f8ce41d3d63$export$f680877a34711e37;
var $83da9f8ce41d3d63$export$d5a552a76deda3c2;
var $83da9f8ce41d3d63$export$aaabe4eda9ed9969;
var $83da9f8ce41d3d63$export$e5c5a5f917a5871c;
var $83da9f8ce41d3d63$export$1538c33de8887b59;
var $83da9f8ce41d3d63$export$fca7f784ae7a249a;
var $83da9f8ce41d3d63$export$13e3392192263954;
var $83da9f8ce41d3d63$export$b8f5890fc79d6aca;
var $83da9f8ce41d3d63$export$60241385465d0a34;
var $83da9f8ce41d3d63$export$306c0aa65ff9ec16;
var $83da9f8ce41d3d63$export$7b286972b8d8ccbf;
var $83da9f8ce41d3d63$export$83d89fbfd8236492;
"use strict";
var $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $83da9f8ce41d3d63$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $83da9f8ce41d3d63$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $83da9f8ce41d3d63$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $83da9f8ce41d3d63$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $83da9f8ce41d3d63$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$83da9f8ce41d3d63$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $83da9f8ce41d3d63$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $83da9f8ce41d3d63$var$assign = Object.assign, $83da9f8ce41d3d63$var$emptyObject = {};
function $83da9f8ce41d3d63$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
$83da9f8ce41d3d63$var$Component.prototype.isReactComponent = {};
$83da9f8ce41d3d63$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$83da9f8ce41d3d63$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $83da9f8ce41d3d63$var$ComponentDummy() {}
$83da9f8ce41d3d63$var$ComponentDummy.prototype = $83da9f8ce41d3d63$var$Component.prototype;
function $83da9f8ce41d3d63$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $83da9f8ce41d3d63$var$emptyObject;
    this.updater = updater || $83da9f8ce41d3d63$var$ReactNoopUpdateQueue;
}
var $83da9f8ce41d3d63$var$pureComponentPrototype = $83da9f8ce41d3d63$var$PureComponent.prototype = new $83da9f8ce41d3d63$var$ComponentDummy();
$83da9f8ce41d3d63$var$pureComponentPrototype.constructor = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$var$assign($83da9f8ce41d3d63$var$pureComponentPrototype, $83da9f8ce41d3d63$var$Component.prototype);
$83da9f8ce41d3d63$var$pureComponentPrototype.isPureReactComponent = !0;
var $83da9f8ce41d3d63$var$isArrayImpl = Array.isArray;
function $83da9f8ce41d3d63$var$noop() {}
var $83da9f8ce41d3d63$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $83da9f8ce41d3d63$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $83da9f8ce41d3d63$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $83da9f8ce41d3d63$var$cloneAndReplaceKey(oldElement, newKey) {
    return $83da9f8ce41d3d63$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $83da9f8ce41d3d63$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE;
}
function $83da9f8ce41d3d63$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex = /\/+/g;
function $83da9f8ce41d3d63$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $83da9f8ce41d3d63$var$escape("" + element.key) : index.toString(36);
}
function $83da9f8ce41d3d63$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($83da9f8ce41d3d63$var$noop, $83da9f8ce41d3d63$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $83da9f8ce41d3d63$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $83da9f8ce41d3d63$var$REACT_ELEMENT_TYPE:
                case $83da9f8ce41d3d63$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $83da9f8ce41d3d63$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $83da9f8ce41d3d63$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $83da9f8ce41d3d63$var$getElementKey(children, 0) : nameSoFar, $83da9f8ce41d3d63$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $83da9f8ce41d3d63$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($83da9f8ce41d3d63$var$isValidElement(callback) && (callback = $83da9f8ce41d3d63$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($83da9f8ce41d3d63$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($83da9f8ce41d3d63$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $83da9f8ce41d3d63$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $83da9f8ce41d3d63$var$getElementKey(nameSoFar, i++), invokeCallback += $83da9f8ce41d3d63$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $83da9f8ce41d3d63$var$mapIntoArray($83da9f8ce41d3d63$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $83da9f8ce41d3d63$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $83da9f8ce41d3d63$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $83da9f8ce41d3d63$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $83da9f8ce41d3d63$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $83da9f8ce41d3d63$var$startTransition(scope) {
    var prevTransition = $83da9f8ce41d3d63$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $83da9f8ce41d3d63$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $83da9f8ce41d3d63$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($83da9f8ce41d3d63$var$noop, $83da9f8ce41d3d63$var$reportGlobalError);
    } catch (error) {
        $83da9f8ce41d3d63$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $83da9f8ce41d3d63$var$ReactSharedInternals.T = prevTransition;
    }
}
function $83da9f8ce41d3d63$var$addTransitionType(type) {
    var transition = $83da9f8ce41d3d63$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $83da9f8ce41d3d63$var$startTransition($83da9f8ce41d3d63$var$addTransitionType.bind(null, type));
}
var $83da9f8ce41d3d63$var$Children = {
    map: $83da9f8ce41d3d63$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $83da9f8ce41d3d63$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $83da9f8ce41d3d63$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$83da9f8ce41d3d63$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$83da9f8ce41d3d63$export$9c16c1426311996d = $83da9f8ce41d3d63$var$REACT_ACTIVITY_TYPE;
$83da9f8ce41d3d63$export$dca3b0875bd9a954 = $83da9f8ce41d3d63$var$Children;
$83da9f8ce41d3d63$export$16fa2f45be04daa8 = $83da9f8ce41d3d63$var$Component;
$83da9f8ce41d3d63$export$ffb0004e005737fa = $83da9f8ce41d3d63$var$REACT_FRAGMENT_TYPE;
$83da9f8ce41d3d63$export$e2c29f18771995cb = $83da9f8ce41d3d63$var$REACT_PROFILER_TYPE;
$83da9f8ce41d3d63$export$221d75b3f55bb0bd = $83da9f8ce41d3d63$var$PureComponent;
$83da9f8ce41d3d63$export$5f8d39834fd61797 = $83da9f8ce41d3d63$var$REACT_STRICT_MODE_TYPE;
$83da9f8ce41d3d63$export$74bf444e3cd11ea5 = $83da9f8ce41d3d63$var$REACT_SUSPENSE_TYPE;
$83da9f8ce41d3d63$export$8cdaa4703948c5e9 = $83da9f8ce41d3d63$var$REACT_VIEW_TRANSITION_TYPE;
$83da9f8ce41d3d63$export$1ced07cd6b1985ce = $83da9f8ce41d3d63$var$ReactSharedInternals;
$83da9f8ce41d3d63$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$83da9f8ce41d3d63$export$87c99536b1b8cdd8 = $83da9f8ce41d3d63$var$addTransitionType;
$83da9f8ce41d3d63$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$83da9f8ce41d3d63$export$8c538325882c7eec = function() {
    return null;
};
$83da9f8ce41d3d63$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $83da9f8ce41d3d63$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $83da9f8ce41d3d63$var$ReactElement(element.type, key, props);
};
$83da9f8ce41d3d63$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $83da9f8ce41d3d63$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$83da9f8ce41d3d63$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$83da9f8ce41d3d63$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $83da9f8ce41d3d63$var$ReactElement(type, key, props);
};
$83da9f8ce41d3d63$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$83da9f8ce41d3d63$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$83da9f8ce41d3d63$export$a8257692ac88316c = $83da9f8ce41d3d63$var$isValidElement;
$83da9f8ce41d3d63$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $83da9f8ce41d3d63$var$lazyInitializer
    };
};
$83da9f8ce41d3d63$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $83da9f8ce41d3d63$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$83da9f8ce41d3d63$export$7568632d0d33d16d = $83da9f8ce41d3d63$var$startTransition;
$83da9f8ce41d3d63$export$f93f40ac0ca7e3a8 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCacheRefresh();
};
$83da9f8ce41d3d63$export$1f96ae73734a86cc = function(usable) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.use(usable);
};
$83da9f8ce41d3d63$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$83da9f8ce41d3d63$export$35808ee640e87ca7 = function(callback, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$83da9f8ce41d3d63$export$fae74005e78b1a27 = function(Context) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useContext(Context);
};
$83da9f8ce41d3d63$export$dc8fbce3eb94dc1e = function() {};
$83da9f8ce41d3d63$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$83da9f8ce41d3d63$export$6d9c69b0de29b591 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useEffect(create, deps);
};
$83da9f8ce41d3d63$export$7f54fc3180508a52 = function(callback) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$83da9f8ce41d3d63$export$f680877a34711e37 = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useId();
};
$83da9f8ce41d3d63$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$83da9f8ce41d3d63$export$aaabe4eda9ed9969 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$83da9f8ce41d3d63$export$e5c5a5f917a5871c = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$83da9f8ce41d3d63$export$1538c33de8887b59 = function(create, deps) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useMemo(create, deps);
};
$83da9f8ce41d3d63$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$83da9f8ce41d3d63$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$83da9f8ce41d3d63$export$b8f5890fc79d6aca = function(initialValue) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useRef(initialValue);
};
$83da9f8ce41d3d63$export$60241385465d0a34 = function(initialState) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useState(initialState);
};
$83da9f8ce41d3d63$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$83da9f8ce41d3d63$export$7b286972b8d8ccbf = function() {
    return $83da9f8ce41d3d63$var$ReactSharedInternals.H.useTransition();
};
$83da9f8ce41d3d63$export$83d89fbfd8236492 = "19.3.0";

});


parcelRegister("jpRqs", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $e229cb5c8b2cd629$export$882461b6382ed46c; }, function (v) { return $e229cb5c8b2cd629$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e229cb5c8b2cd629$export$757ceba2d55c277e; }, function (v) { return $e229cb5c8b2cd629$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $e229cb5c8b2cd629$export$83d89fbfd8236492; }, function (v) { return $e229cb5c8b2cd629$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e229cb5c8b2cd629$export$882461b6382ed46c;
var $e229cb5c8b2cd629$export$757ceba2d55c277e;
var $e229cb5c8b2cd629$export$83d89fbfd8236492;
"use strict";

var $4LCdk = parcelRequire("4LCdk");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
function $e229cb5c8b2cd629$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e229cb5c8b2cd629$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $e229cb5c8b2cd629$var$assertIsMounted(fiber) {
    if ($e229cb5c8b2cd629$var$getNearestMountedFiber(fiber) !== fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
}
function $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $e229cb5c8b2cd629$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $e229cb5c8b2cd629$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $e229cb5c8b2cd629$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $e229cb5c8b2cd629$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $e229cb5c8b2cd629$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $e229cb5c8b2cd629$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $e229cb5c8b2cd629$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(559));
    }
}
var $e229cb5c8b2cd629$var$searchTarget = null, $e229cb5c8b2cd629$var$searchBoundary = null;
function $e229cb5c8b2cd629$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($e229cb5c8b2cd629$var$searchTarget = child, !0) : !1;
}
function $e229cb5c8b2cd629$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($e229cb5c8b2cd629$var$searchBoundary = child, !1) : child === target ? (null !== $e229cb5c8b2cd629$var$searchBoundary && ($e229cb5c8b2cd629$var$searchTarget = child), !0) : !1;
}
function $e229cb5c8b2cd629$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $e229cb5c8b2cd629$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $e229cb5c8b2cd629$var$assign = Object.assign, $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $e229cb5c8b2cd629$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e229cb5c8b2cd629$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $e229cb5c8b2cd629$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $e229cb5c8b2cd629$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $e229cb5c8b2cd629$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e229cb5c8b2cd629$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e229cb5c8b2cd629$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $e229cb5c8b2cd629$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $e229cb5c8b2cd629$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $e229cb5c8b2cd629$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $e229cb5c8b2cd629$var$getComponentNameFromType(type.type) || "Memo";
        case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $e229cb5c8b2cd629$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $e229cb5c8b2cd629$var$isArrayImpl = Array.isArray, $e229cb5c8b2cd629$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$ReactDOMSharedInternals = $6afFj.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $e229cb5c8b2cd629$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $e229cb5c8b2cd629$var$valueStack = [], $e229cb5c8b2cd629$var$index = -1;
function $e229cb5c8b2cd629$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $e229cb5c8b2cd629$var$pop(cursor) {
    0 > $e229cb5c8b2cd629$var$index || (cursor.current = $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index], $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = null, $e229cb5c8b2cd629$var$index--);
}
function $e229cb5c8b2cd629$var$push(cursor, value) {
    $e229cb5c8b2cd629$var$index++;
    $e229cb5c8b2cd629$var$valueStack[$e229cb5c8b2cd629$var$index] = cursor.current;
    cursor.current = value;
}
var $e229cb5c8b2cd629$var$contextStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$contextFiberStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$rootInstanceStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$hostTransitionProviderCursor = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$pushHostContainer(fiber, nextRootInstance) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$rootInstanceStackCursor, nextRootInstance);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $e229cb5c8b2cd629$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $e229cb5c8b2cd629$var$getOwnHostContext(nextRootInstance), fiber = $e229cb5c8b2cd629$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, fiber);
}
function $e229cb5c8b2cd629$var$popHostContainer() {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$rootInstanceStackCursor);
}
function $e229cb5c8b2cd629$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($e229cb5c8b2cd629$var$HostTransitionContext._currentValue = stateHook.memoizedState, $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$hostTransitionProviderCursor, fiber));
    stateHook = $e229cb5c8b2cd629$var$contextStackCursor.current;
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextFiberStackCursor, fiber), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$contextStackCursor, JSCompiler_inline_result));
}
function $e229cb5c8b2cd629$var$popHostContext(fiber) {
    $e229cb5c8b2cd629$var$contextFiberStackCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextStackCursor), $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$contextFiberStackCursor));
    $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current === fiber && ($e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$hostTransitionProviderCursor), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = $e229cb5c8b2cd629$var$sharedNotPendingObject);
}
var $e229cb5c8b2cd629$var$prefix, $e229cb5c8b2cd629$var$suffix;
function $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $e229cb5c8b2cd629$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $e229cb5c8b2cd629$var$prefix = match && match[1] || "";
        $e229cb5c8b2cd629$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $e229cb5c8b2cd629$var$prefix + name + $e229cb5c8b2cd629$var$suffix;
}
var $e229cb5c8b2cd629$var$reentry = !1;
function $e229cb5c8b2cd629$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $e229cb5c8b2cd629$var$reentry) return "";
    $e229cb5c8b2cd629$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $e229cb5c8b2cd629$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $e229cb5c8b2cd629$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Suspense Fallback") : $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $e229cb5c8b2cd629$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $e229cb5c8b2cd629$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $e229cb5c8b2cd629$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $e229cb5c8b2cd629$var$hasOwnProperty = Object.prototype.hasOwnProperty, $e229cb5c8b2cd629$var$scheduleCallback$3 = $4LCdk.unstable_scheduleCallback, $e229cb5c8b2cd629$var$cancelCallback$1 = $4LCdk.unstable_cancelCallback, $e229cb5c8b2cd629$var$shouldYield = $4LCdk.unstable_shouldYield, $e229cb5c8b2cd629$var$requestPaint = $4LCdk.unstable_requestPaint, $e229cb5c8b2cd629$var$now = $4LCdk.unstable_now, $e229cb5c8b2cd629$var$getCurrentPriorityLevel = $4LCdk.unstable_getCurrentPriorityLevel, $e229cb5c8b2cd629$var$ImmediatePriority = $4LCdk.unstable_ImmediatePriority, $e229cb5c8b2cd629$var$UserBlockingPriority = $4LCdk.unstable_UserBlockingPriority, $e229cb5c8b2cd629$var$NormalPriority$1 = $4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$LowPriority = $4LCdk.unstable_LowPriority, $e229cb5c8b2cd629$var$IdlePriority = $4LCdk.unstable_IdlePriority, $e229cb5c8b2cd629$var$log$1 = $4LCdk.log, $e229cb5c8b2cd629$var$unstable_setDisableYieldValue = $4LCdk.unstable_setDisableYieldValue, $e229cb5c8b2cd629$var$rendererID = null, $e229cb5c8b2cd629$var$injectedHook = null;
function $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $e229cb5c8b2cd629$var$log$1 && $e229cb5c8b2cd629$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.setStrictMode) try {
        $e229cb5c8b2cd629$var$injectedHook.setStrictMode($e229cb5c8b2cd629$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $e229cb5c8b2cd629$var$clz32 = Math.clz32 ? Math.clz32 : $e229cb5c8b2cd629$var$clz32Fallback, $e229cb5c8b2cd629$var$log = Math.log, $e229cb5c8b2cd629$var$LN2 = Math.LN2;
function $e229cb5c8b2cd629$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($e229cb5c8b2cd629$var$log(x) / $e229cb5c8b2cd629$var$LN2 | 0) | 0;
}
var $e229cb5c8b2cd629$var$nextTransitionUpdateLane = 256, $e229cb5c8b2cd629$var$nextTransitionDeferredLane = 262144, $e229cb5c8b2cd629$var$nextRetryLane = 4194304;
function $e229cb5c8b2cd629$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $e229cb5c8b2cd629$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $e229cb5c8b2cd629$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $e229cb5c8b2cd629$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e229cb5c8b2cd629$var$claimNextRetryLane() {
    var lane = $e229cb5c8b2cd629$var$nextRetryLane;
    $e229cb5c8b2cd629$var$nextRetryLane <<= 1;
    0 === ($e229cb5c8b2cd629$var$nextRetryLane & 62914560) && ($e229cb5c8b2cd629$var$nextRetryLane = 4194304);
    return lane;
}
function $e229cb5c8b2cd629$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $e229cb5c8b2cd629$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $e229cb5c8b2cd629$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $e229cb5c8b2cd629$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $e229cb5c8b2cd629$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $e229cb5c8b2cd629$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $e229cb5c8b2cd629$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $e229cb5c8b2cd629$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $e229cb5c8b2cd629$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $e229cb5c8b2cd629$var$resolveUpdatePriority() {
    var updatePriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $e229cb5c8b2cd629$var$getEventPriority(updatePriority.type);
}
function $e229cb5c8b2cd629$var$runWithPriority(priority, fn) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        return $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $e229cb5c8b2cd629$var$randomKey = Math.random().toString(36).slice(2), $e229cb5c8b2cd629$var$internalInstanceKey = "__reactFiber$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalPropsKey = "__reactProps$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalContainerInstanceKey = "__reactContainer$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlersKey = "__reactEvents$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlerListenersKey = "__reactListeners$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalEventHandlesSetKey = "__reactHandles$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalRootNodeResourcesKey = "__reactResources$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalHoistableMarker = "__reactMarker$" + $e229cb5c8b2cd629$var$randomKey, $e229cb5c8b2cd629$var$internalLoadPendingKey = "__reactLoad$" + $e229cb5c8b2cd629$var$randomKey;
function $e229cb5c8b2cd629$var$detachDeletedInstance(node) {
    delete node[$e229cb5c8b2cd629$var$internalInstanceKey];
    delete node[$e229cb5c8b2cd629$var$internalPropsKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlerListenersKey];
    delete node[$e229cb5c8b2cd629$var$internalEventHandlesSetKey];
}
function $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$e229cb5c8b2cd629$var$internalContainerInstanceKey] || parentNode[$e229cb5c8b2cd629$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$e229cb5c8b2cd629$var$internalInstanceKey]) return parentNode;
                targetNode = $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getInstanceFromNode(node) {
    if (node = node[$e229cb5c8b2cd629$var$internalInstanceKey] || node[$e229cb5c8b2cd629$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(33));
}
function $e229cb5c8b2cd629$var$getResourcesFromRoot(root) {
    var resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey];
    resources || (resources = root[$e229cb5c8b2cd629$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $e229cb5c8b2cd629$var$markNodeAsHoistable(node) {
    node[$e229cb5c8b2cd629$var$internalHoistableMarker] = !0;
}
function $e229cb5c8b2cd629$var$clearPendingLoadOnNode(node) {
    node[$e229cb5c8b2cd629$var$internalLoadPendingKey] = void 0;
}
var $e229cb5c8b2cd629$var$allNativeEvents = new Set(), $e229cb5c8b2cd629$var$registrationNameDependencies = {};
function $e229cb5c8b2cd629$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies);
    $e229cb5c8b2cd629$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $e229cb5c8b2cd629$var$registerDirectEvent(registrationName, dependencies) {
    $e229cb5c8b2cd629$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$e229cb5c8b2cd629$var$allNativeEvents.add(dependencies[registrationName]);
}
var $e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $e229cb5c8b2cd629$var$illegalAttributeNameCache = {}, $e229cb5c8b2cd629$var$validatedAttributeNameCache = {};
function $e229cb5c8b2cd629$var$isAttributeNameSafe(attributeName) {
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($e229cb5c8b2cd629$var$hasOwnProperty.call($e229cb5c8b2cd629$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($e229cb5c8b2cd629$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $e229cb5c8b2cd629$var$validatedAttributeNameCache[attributeName] = !0;
    $e229cb5c8b2cd629$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $e229cb5c8b2cd629$var$viewTransitionMutationContext = !1;
function $e229cb5c8b2cd629$var$pushMutationContext() {
    var prev = $e229cb5c8b2cd629$var$viewTransitionMutationContext;
    $e229cb5c8b2cd629$var$viewTransitionMutationContext = !1;
    return prev;
}
function $e229cb5c8b2cd629$var$setValueForAttribute(node, name, value) {
    if ($e229cb5c8b2cd629$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $e229cb5c8b2cd629$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $e229cb5c8b2cd629$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $e229cb5c8b2cd629$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $e229cb5c8b2cd629$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $e229cb5c8b2cd629$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $e229cb5c8b2cd629$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $e229cb5c8b2cd629$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $e229cb5c8b2cd629$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $e229cb5c8b2cd629$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $e229cb5c8b2cd629$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value);
        } else element.value !== "" + $e229cb5c8b2cd629$var$getToStringValue(value) && (element.value = "" + $e229cb5c8b2cd629$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $e229cb5c8b2cd629$var$setDefaultValue(element, $e229cb5c8b2cd629$var$getToStringValue(element.value)) : $e229cb5c8b2cd629$var$setDefaultValue(element, $e229cb5c8b2cd629$var$getToStringValue(value)) : null != defaultValue ? $e229cb5c8b2cd629$var$setDefaultValue(element, $e229cb5c8b2cd629$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $e229cb5c8b2cd629$var$getToStringValue(name) : element.removeAttribute("name");
}
function $e229cb5c8b2cd629$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $e229cb5c8b2cd629$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $e229cb5c8b2cd629$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $e229cb5c8b2cd629$var$track(element);
}
function $e229cb5c8b2cd629$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $e229cb5c8b2cd629$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $e229cb5c8b2cd629$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $e229cb5c8b2cd629$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $e229cb5c8b2cd629$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $e229cb5c8b2cd629$var$getToStringValue(defaultValue) : "";
}
function $e229cb5c8b2cd629$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(92));
            if ($e229cb5c8b2cd629$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $e229cb5c8b2cd629$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $e229cb5c8b2cd629$var$track(element);
}
function $e229cb5c8b2cd629$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $e229cb5c8b2cd629$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $e229cb5c8b2cd629$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $e229cb5c8b2cd629$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $e229cb5c8b2cd629$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($e229cb5c8b2cd629$var$setValueForStyle(node, styleName$16, styleName), $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $e229cb5c8b2cd629$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $e229cb5c8b2cd629$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e229cb5c8b2cd629$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $e229cb5c8b2cd629$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $e229cb5c8b2cd629$var$sanitizeURL(url) {
    return $e229cb5c8b2cd629$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $e229cb5c8b2cd629$var$noop$1() {}
var $e229cb5c8b2cd629$var$currentReplayingEvent = null;
function $e229cb5c8b2cd629$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreQueue = null;
function $e229cb5c8b2cd629$var$restoreStateOfTarget(target) {
    var internalInstance = $e229cb5c8b2cd629$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $e229cb5c8b2cd629$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(90));
                            $e229cb5c8b2cd629$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $e229cb5c8b2cd629$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $e229cb5c8b2cd629$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $e229cb5c8b2cd629$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $e229cb5c8b2cd629$var$isInsideEventHandler = !1;
function $e229cb5c8b2cd629$var$batchedUpdates$1(fn, a, b) {
    if ($e229cb5c8b2cd629$var$isInsideEventHandler) return fn(a, b);
    $e229cb5c8b2cd629$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($e229cb5c8b2cd629$var$isInsideEventHandler = !1, null !== $e229cb5c8b2cd629$var$restoreTarget || null !== $e229cb5c8b2cd629$var$restoreQueue) {
            if ($e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$restoreTarget && (a = $e229cb5c8b2cd629$var$restoreTarget, fn = $e229cb5c8b2cd629$var$restoreQueue, $e229cb5c8b2cd629$var$restoreQueue = $e229cb5c8b2cd629$var$restoreTarget = null, $e229cb5c8b2cd629$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$e229cb5c8b2cd629$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $e229cb5c8b2cd629$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$e229cb5c8b2cd629$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $e229cb5c8b2cd629$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) try {
    var $e229cb5c8b2cd629$var$options = {};
    Object.defineProperty($e229cb5c8b2cd629$var$options, "passive", {
        get: function() {
            $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
    window.removeEventListener("test", $e229cb5c8b2cd629$var$options, $e229cb5c8b2cd629$var$options);
} catch (e) {
    $e229cb5c8b2cd629$var$passiveBrowserEventsSupported = !1;
}
var $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$startText = null, $e229cb5c8b2cd629$var$fallbackText = null;
function $e229cb5c8b2cd629$var$getData() {
    if ($e229cb5c8b2cd629$var$fallbackText) return $e229cb5c8b2cd629$var$fallbackText;
    var start, startValue = $e229cb5c8b2cd629$var$startText, startLength = startValue.length, end, endValue = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $e229cb5c8b2cd629$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsTrue() {
    return !0;
}
function $e229cb5c8b2cd629$var$functionThatReturnsFalse() {
    return !1;
}
function $e229cb5c8b2cd629$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $e229cb5c8b2cd629$var$functionThatReturnsTrue : $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsFalse;
        return this;
    }
    $e229cb5c8b2cd629$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $e229cb5c8b2cd629$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $e229cb5c8b2cd629$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $e229cb5c8b2cd629$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e229cb5c8b2cd629$var$SyntheticEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$EventInterface), $e229cb5c8b2cd629$var$UIEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    view: 0,
    detail: 0
}), $e229cb5c8b2cd629$var$SyntheticUIEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$UIEventInterface), $e229cb5c8b2cd629$var$lastMovementX, $e229cb5c8b2cd629$var$lastMovementY, $e229cb5c8b2cd629$var$lastMouseEvent, $e229cb5c8b2cd629$var$MouseEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $e229cb5c8b2cd629$var$lastMouseEvent && ($e229cb5c8b2cd629$var$lastMouseEvent && "mousemove" === event.type ? ($e229cb5c8b2cd629$var$lastMovementX = event.screenX - $e229cb5c8b2cd629$var$lastMouseEvent.screenX, $e229cb5c8b2cd629$var$lastMovementY = event.screenY - $e229cb5c8b2cd629$var$lastMouseEvent.screenY) : $e229cb5c8b2cd629$var$lastMovementY = $e229cb5c8b2cd629$var$lastMovementX = 0, $e229cb5c8b2cd629$var$lastMouseEvent = event);
        return $e229cb5c8b2cd629$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $e229cb5c8b2cd629$var$lastMovementY;
    }
}), $e229cb5c8b2cd629$var$SyntheticMouseEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$MouseEventInterface), $e229cb5c8b2cd629$var$DragEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    dataTransfer: 0
}), $e229cb5c8b2cd629$var$SyntheticDragEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$DragEventInterface), $e229cb5c8b2cd629$var$FocusEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    relatedTarget: 0
}), $e229cb5c8b2cd629$var$SyntheticFocusEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$FocusEventInterface), $e229cb5c8b2cd629$var$AnimationEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticAnimationEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$AnimationEventInterface), $e229cb5c8b2cd629$var$ClipboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $e229cb5c8b2cd629$var$SyntheticClipboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ClipboardEventInterface), $e229cb5c8b2cd629$var$CompositionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    data: 0
}), $e229cb5c8b2cd629$var$SyntheticCompositionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$CompositionEventInterface), $e229cb5c8b2cd629$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e229cb5c8b2cd629$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e229cb5c8b2cd629$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e229cb5c8b2cd629$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $e229cb5c8b2cd629$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $e229cb5c8b2cd629$var$getEventModifierState() {
    return $e229cb5c8b2cd629$var$modifierStateGetter;
}
var $e229cb5c8b2cd629$var$KeyboardEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $e229cb5c8b2cd629$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $e229cb5c8b2cd629$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $e229cb5c8b2cd629$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $e229cb5c8b2cd629$var$SyntheticKeyboardEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$KeyboardEventInterface), $e229cb5c8b2cd629$var$PointerEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e229cb5c8b2cd629$var$SyntheticPointerEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$PointerEventInterface), $e229cb5c8b2cd629$var$SubmitEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    submitter: 0
}), $e229cb5c8b2cd629$var$SyntheticSubmitEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$SubmitEventInterface), $e229cb5c8b2cd629$var$TouchEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e229cb5c8b2cd629$var$getEventModifierState
}), $e229cb5c8b2cd629$var$SyntheticTouchEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TouchEventInterface), $e229cb5c8b2cd629$var$TransitionEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e229cb5c8b2cd629$var$SyntheticTransitionEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$TransitionEventInterface), $e229cb5c8b2cd629$var$WheelEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e229cb5c8b2cd629$var$SyntheticWheelEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$WheelEventInterface), $e229cb5c8b2cd629$var$ToggleEventInterface = $e229cb5c8b2cd629$var$assign({}, $e229cb5c8b2cd629$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $e229cb5c8b2cd629$var$SyntheticToggleEvent = $e229cb5c8b2cd629$var$createSyntheticEvent($e229cb5c8b2cd629$var$ToggleEventInterface), $e229cb5c8b2cd629$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $e229cb5c8b2cd629$var$canUseCompositionEvent = $e229cb5c8b2cd629$var$canUseDOM && "CompositionEvent" in window, $e229cb5c8b2cd629$var$documentMode = null;
$e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && ($e229cb5c8b2cd629$var$documentMode = document.documentMode);
var $e229cb5c8b2cd629$var$canUseTextInputEvent = $e229cb5c8b2cd629$var$canUseDOM && "TextEvent" in window && !$e229cb5c8b2cd629$var$documentMode, $e229cb5c8b2cd629$var$useFallbackCompositionData = $e229cb5c8b2cd629$var$canUseDOM && (!$e229cb5c8b2cd629$var$canUseCompositionEvent || $e229cb5c8b2cd629$var$documentMode && 8 < $e229cb5c8b2cd629$var$documentMode && 11 >= $e229cb5c8b2cd629$var$documentMode), $e229cb5c8b2cd629$var$SPACEBAR_CHAR = String.fromCharCode(32), $e229cb5c8b2cd629$var$hasSpaceKeypress = !1;
function $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $e229cb5c8b2cd629$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $e229cb5c8b2cd629$var$isComposing = !1;
function $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $e229cb5c8b2cd629$var$hasSpaceKeypress = !0;
            return $e229cb5c8b2cd629$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $e229cb5c8b2cd629$var$SPACEBAR_CHAR && $e229cb5c8b2cd629$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($e229cb5c8b2cd629$var$isComposing) return "compositionend" === domEventName || !$e229cb5c8b2cd629$var$canUseCompositionEvent && $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $e229cb5c8b2cd629$var$getData(), $e229cb5c8b2cd629$var$fallbackText = $e229cb5c8b2cd629$var$startText = $e229cb5c8b2cd629$var$root = null, $e229cb5c8b2cd629$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $e229cb5c8b2cd629$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e229cb5c8b2cd629$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$e229cb5c8b2cd629$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $e229cb5c8b2cd629$var$restoreTarget ? $e229cb5c8b2cd629$var$restoreQueue ? $e229cb5c8b2cd629$var$restoreQueue.push(target) : $e229cb5c8b2cd629$var$restoreQueue = [
        target
    ] : $e229cb5c8b2cd629$var$restoreTarget = target;
    inst = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $e229cb5c8b2cd629$var$activeElement$1 = null, $e229cb5c8b2cd629$var$activeElementInst$1 = null;
function $e229cb5c8b2cd629$var$runEventInBatch(dispatchQueue) {
    $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, 0);
}
function $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst) {
    var targetNode = $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst);
    if ($e229cb5c8b2cd629$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $e229cb5c8b2cd629$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $e229cb5c8b2cd629$var$isInputEventSupported = !1;
if ($e229cb5c8b2cd629$var$canUseDOM) {
    var $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$318;
    if ($e229cb5c8b2cd629$var$canUseDOM) {
        var $e229cb5c8b2cd629$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$e229cb5c8b2cd629$var$isSupported$jscomp$inline_474) {
            var $e229cb5c8b2cd629$var$element$jscomp$inline_475 = document.createElement("div");
            $e229cb5c8b2cd629$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $e229cb5c8b2cd629$var$isSupported$jscomp$inline_474 = "function" === typeof $e229cb5c8b2cd629$var$element$jscomp$inline_475.oninput;
        }
        $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$318 = $e229cb5c8b2cd629$var$isSupported$jscomp$inline_474;
    } else $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$318 = !1;
    $e229cb5c8b2cd629$var$isInputEventSupported = $e229cb5c8b2cd629$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $e229cb5c8b2cd629$var$stopWatchingForValueChange() {
    $e229cb5c8b2cd629$var$activeElement$1 && ($e229cb5c8b2cd629$var$activeElement$1.detachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange), $e229cb5c8b2cd629$var$activeElementInst$1 = $e229cb5c8b2cd629$var$activeElement$1 = null);
}
function $e229cb5c8b2cd629$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, $e229cb5c8b2cd629$var$activeElementInst$1, nativeEvent, $e229cb5c8b2cd629$var$getEventTarget(nativeEvent));
        $e229cb5c8b2cd629$var$batchedUpdates$1($e229cb5c8b2cd629$var$runEventInBatch, dispatchQueue);
    }
}
function $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($e229cb5c8b2cd629$var$stopWatchingForValueChange(), $e229cb5c8b2cd629$var$activeElement$1 = target, $e229cb5c8b2cd629$var$activeElementInst$1 = targetInst, $e229cb5c8b2cd629$var$activeElement$1.attachEvent("onpropertychange", $e229cb5c8b2cd629$var$handlePropertyChange)) : "focusout" === domEventName && $e229cb5c8b2cd629$var$stopWatchingForValueChange();
}
function $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged($e229cb5c8b2cd629$var$activeElementInst$1);
}
function $e229cb5c8b2cd629$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $e229cb5c8b2cd629$var$getInstIfValueChanged(targetInst);
}
function $e229cb5c8b2cd629$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e229cb5c8b2cd629$var$objectIs = "function" === typeof Object.is ? Object.is : $e229cb5c8b2cd629$var$is;
function $e229cb5c8b2cd629$var$shallowEqual(objA, objB) {
    if ($e229cb5c8b2cd629$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$e229cb5c8b2cd629$var$hasOwnProperty.call(objB, currentKey) || !$e229cb5c8b2cd629$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $e229cb5c8b2cd629$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $e229cb5c8b2cd629$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $e229cb5c8b2cd629$var$getNodeForCharacterOffset(root, offset) {
    var node = $e229cb5c8b2cd629$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $e229cb5c8b2cd629$var$getLeafNode(node);
    }
}
function $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $e229cb5c8b2cd629$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $e229cb5c8b2cd629$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $e229cb5c8b2cd629$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $e229cb5c8b2cd629$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $e229cb5c8b2cd629$var$skipSelectionChangeEvent = $e229cb5c8b2cd629$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $e229cb5c8b2cd629$var$activeElement = null, $e229cb5c8b2cd629$var$activeElementInst = null, $e229cb5c8b2cd629$var$lastSelection = null, $e229cb5c8b2cd629$var$mouseDown = !1;
function $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $e229cb5c8b2cd629$var$mouseDown || null == $e229cb5c8b2cd629$var$activeElement || $e229cb5c8b2cd629$var$activeElement !== $e229cb5c8b2cd629$var$getActiveElement(doc) || (doc = $e229cb5c8b2cd629$var$activeElement, "selectionStart" in doc && $e229cb5c8b2cd629$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $e229cb5c8b2cd629$var$lastSelection && $e229cb5c8b2cd629$var$shallowEqual($e229cb5c8b2cd629$var$lastSelection, doc) || ($e229cb5c8b2cd629$var$lastSelection = doc, doc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners($e229cb5c8b2cd629$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $e229cb5c8b2cd629$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $e229cb5c8b2cd629$var$activeElement)));
}
function $e229cb5c8b2cd629$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $e229cb5c8b2cd629$var$vendorPrefixes = {
    animationend: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $e229cb5c8b2cd629$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $e229cb5c8b2cd629$var$makePrefixMap("Transition", "TransitionEnd")
}, $e229cb5c8b2cd629$var$prefixedEventNames = {}, $e229cb5c8b2cd629$var$style = {};
$e229cb5c8b2cd629$var$canUseDOM && ($e229cb5c8b2cd629$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $e229cb5c8b2cd629$var$vendorPrefixes.animationend.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationiteration.animation, delete $e229cb5c8b2cd629$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $e229cb5c8b2cd629$var$vendorPrefixes.transitionend.transition);
function $e229cb5c8b2cd629$var$getVendorPrefixedEventName(eventName) {
    if ($e229cb5c8b2cd629$var$prefixedEventNames[eventName]) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName];
    if (!$e229cb5c8b2cd629$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $e229cb5c8b2cd629$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $e229cb5c8b2cd629$var$style) return $e229cb5c8b2cd629$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $e229cb5c8b2cd629$var$ANIMATION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationend"), $e229cb5c8b2cd629$var$ANIMATION_ITERATION = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationiteration"), $e229cb5c8b2cd629$var$ANIMATION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("animationstart"), $e229cb5c8b2cd629$var$TRANSITION_RUN = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionrun"), $e229cb5c8b2cd629$var$TRANSITION_START = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionstart"), $e229cb5c8b2cd629$var$TRANSITION_CANCEL = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitioncancel"), $e229cb5c8b2cd629$var$TRANSITION_END = $e229cb5c8b2cd629$var$getVendorPrefixedEventName("transitionend"), $e229cb5c8b2cd629$var$topLevelEventsToReactNames = new Map(), $e229cb5c8b2cd629$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$e229cb5c8b2cd629$var$simpleEventPluginEvents.push("scrollEnd");
function $e229cb5c8b2cd629$var$registerSimpleEvent(domEventName, reactName) {
    $e229cb5c8b2cd629$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $e229cb5c8b2cd629$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $e229cb5c8b2cd629$var$globalClientIdCounter$1 = 0;
function $e229cb5c8b2cd629$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $e229cb5c8b2cd629$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $e229cb5c8b2cd629$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $e229cb5c8b2cd629$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $e229cb5c8b2cd629$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $e229cb5c8b2cd629$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $e229cb5c8b2cd629$var$getClassNameByType(defaultClass);
    eventClass = $e229cb5c8b2cd629$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $e229cb5c8b2cd629$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $e229cb5c8b2cd629$var$concurrentQueues = [], $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0, $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = 0;
function $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $e229cb5c8b2cd629$var$concurrentQueuesIndex, i = $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes = $e229cb5c8b2cd629$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var queue = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var update = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        var lane = $e229cb5c8b2cd629$var$concurrentQueues[i];
        $e229cb5c8b2cd629$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = fiber;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = queue;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = update;
    $e229cb5c8b2cd629$var$concurrentQueues[$e229cb5c8b2cd629$var$concurrentQueuesIndex++] = lane;
    $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, null, null, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $e229cb5c8b2cd629$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $e229cb5c8b2cd629$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $e229cb5c8b2cd629$var$nestedUpdateCount) throw $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null, Error($e229cb5c8b2cd629$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $e229cb5c8b2cd629$var$emptyContextObject = {};
function $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e229cb5c8b2cd629$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $e229cb5c8b2cd629$var$FiberNode(tag, pendingProps, key, mode);
}
function $e229cb5c8b2cd629$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $e229cb5c8b2cd629$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $e229cb5c8b2cd629$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $e229cb5c8b2cd629$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $e229cb5c8b2cd629$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $e229cb5c8b2cd629$var$isHostHoistableType(type, pendingProps, $e229cb5c8b2cd629$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE:
            return $e229cb5c8b2cd629$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $e229cb5c8b2cd629$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $e229cb5c8b2cd629$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $e229cb5c8b2cd629$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $e229cb5c8b2cd629$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $e229cb5c8b2cd629$var$REACT_LEGACY_HIDDEN_TYPE:
        case $e229cb5c8b2cd629$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $e229cb5c8b2cd629$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $e229cb5c8b2cd629$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $e229cb5c8b2cd629$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $e229cb5c8b2cd629$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $e229cb5c8b2cd629$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $e229cb5c8b2cd629$var$createFiberFromText(content, mode, lanes) {
    content = $e229cb5c8b2cd629$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $e229cb5c8b2cd629$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $e229cb5c8b2cd629$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $e229cb5c8b2cd629$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $e229cb5c8b2cd629$var$CapturedStacks = new WeakMap();
function $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $e229cb5c8b2cd629$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
        };
        $e229cb5c8b2cd629$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $e229cb5c8b2cd629$var$getStackByFiberInDevAndProd(source)
    };
}
var $e229cb5c8b2cd629$var$forkStack = [], $e229cb5c8b2cd629$var$forkStackIndex = 0, $e229cb5c8b2cd629$var$treeForkProvider = null, $e229cb5c8b2cd629$var$treeForkCount = 0, $e229cb5c8b2cd629$var$idStack = [], $e229cb5c8b2cd629$var$idStackIndex = 0, $e229cb5c8b2cd629$var$treeContextProvider = null, $e229cb5c8b2cd629$var$treeContextId = 1, $e229cb5c8b2cd629$var$treeContextOverflow = "";
function $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, totalChildren) {
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkCount;
    $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex++] = $e229cb5c8b2cd629$var$treeForkProvider;
    $e229cb5c8b2cd629$var$treeForkProvider = workInProgress;
    $e229cb5c8b2cd629$var$treeForkCount = totalChildren;
}
function $e229cb5c8b2cd629$var$pushTreeId(workInProgress, totalChildren, index) {
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider;
    $e229cb5c8b2cd629$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
    workInProgress = $e229cb5c8b2cd629$var$treeContextOverflow;
    var baseLength = 32 - $e229cb5c8b2cd629$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $e229cb5c8b2cd629$var$treeContextId = 1 << 32 - $e229cb5c8b2cd629$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $e229cb5c8b2cd629$var$treeContextOverflow = length + workInProgress;
    } else $e229cb5c8b2cd629$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $e229cb5c8b2cd629$var$treeContextOverflow = workInProgress;
}
function $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($e229cb5c8b2cd629$var$pushTreeFork(workInProgress, 1), $e229cb5c8b2cd629$var$pushTreeId(workInProgress, 1, 0));
}
function $e229cb5c8b2cd629$var$popTreeContext(workInProgress) {
    for(; workInProgress === $e229cb5c8b2cd629$var$treeForkProvider;)$e229cb5c8b2cd629$var$treeForkProvider = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null, $e229cb5c8b2cd629$var$treeForkCount = $e229cb5c8b2cd629$var$forkStack[--$e229cb5c8b2cd629$var$forkStackIndex], $e229cb5c8b2cd629$var$forkStack[$e229cb5c8b2cd629$var$forkStackIndex] = null;
    for(; workInProgress === $e229cb5c8b2cd629$var$treeContextProvider;)$e229cb5c8b2cd629$var$treeContextProvider = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextOverflow = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null, $e229cb5c8b2cd629$var$treeContextId = $e229cb5c8b2cd629$var$idStack[--$e229cb5c8b2cd629$var$idStackIndex], $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex] = null;
}
function $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextId;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextOverflow;
    $e229cb5c8b2cd629$var$idStack[$e229cb5c8b2cd629$var$idStackIndex++] = $e229cb5c8b2cd629$var$treeContextProvider;
    $e229cb5c8b2cd629$var$treeContextId = suspendedContext.id;
    $e229cb5c8b2cd629$var$treeContextOverflow = suspendedContext.overflow;
    $e229cb5c8b2cd629$var$treeContextProvider = workInProgress;
}
var $e229cb5c8b2cd629$var$hydrationParentFiber = null, $e229cb5c8b2cd629$var$nextHydratableInstance = null, $e229cb5c8b2cd629$var$isHydrating = !1, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, $e229cb5c8b2cd629$var$HydrationMismatchException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(519));
function $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber) {
    var error = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, fiber));
    throw $e229cb5c8b2cd629$var$HydrationMismatchException;
}
function $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$e229cb5c8b2cd629$var$internalInstanceKey] = fiber;
    instance[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $e229cb5c8b2cd629$var$mediaEventTypes.length; type++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", instance);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            $e229cb5c8b2cd629$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", instance), $e229cb5c8b2cd629$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", instance), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $e229cb5c8b2cd629$var$noop$1), instance = !0) : instance = !1;
    instance || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber, !0);
}
function $e229cb5c8b2cd629$var$popToNextHostParent(fiber) {
    for($e229cb5c8b2cd629$var$hydrationParentFiber = fiber.return; $e229cb5c8b2cd629$var$hydrationParentFiber;)switch($e229cb5c8b2cd629$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $e229cb5c8b2cd629$var$rootOrSingletonContext = !0;
            return;
        default:
            $e229cb5c8b2cd629$var$hydrationParentFiber = $e229cb5c8b2cd629$var$hydrationParentFiber.return;
    }
}
function $e229cb5c8b2cd629$var$popHydrationState(fiber) {
    if (fiber !== $e229cb5c8b2cd629$var$hydrationParentFiber) return !1;
    if (!$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$popToNextHostParent(fiber), $e229cb5c8b2cd629$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $e229cb5c8b2cd629$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $e229cb5c8b2cd629$var$nextHydratableInstance && $e229cb5c8b2cd629$var$throwOnHydrationMismatch(fiber);
    $e229cb5c8b2cd629$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $e229cb5c8b2cd629$var$nextHydratableInstance, $e229cb5c8b2cd629$var$isSingletonScope(fiber.type) ? (fiber = $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton, $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = null, $e229cb5c8b2cd629$var$nextHydratableInstance = fiber) : $e229cb5c8b2cd629$var$nextHydratableInstance = tag) : $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber ? $e229cb5c8b2cd629$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $e229cb5c8b2cd629$var$resetHydrationState() {
    $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$hydrationParentFiber = null;
    $e229cb5c8b2cd629$var$isHydrating = !1;
}
function $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $e229cb5c8b2cd629$var$hydrationErrors;
    null !== queuedErrors && (null === $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors ? $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = queuedErrors : $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors.push.apply($e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, queuedErrors), $e229cb5c8b2cd629$var$hydrationErrors = null);
    return queuedErrors;
}
function $e229cb5c8b2cd629$var$queueHydrationError(error) {
    null === $e229cb5c8b2cd629$var$hydrationErrors ? $e229cb5c8b2cd629$var$hydrationErrors = [
        error
    ] : $e229cb5c8b2cd629$var$hydrationErrors.push(error);
}
var $e229cb5c8b2cd629$var$valueCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null, $e229cb5c8b2cd629$var$lastContextDependency = null;
function $e229cb5c8b2cd629$var$pushProvider(providerFiber, context, nextValue) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $e229cb5c8b2cd629$var$popProvider(context) {
    context._currentValue = $e229cb5c8b2cd629$var$valueCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$valueCursor);
}
function $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $e229cb5c8b2cd629$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $e229cb5c8b2cd629$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($e229cb5c8b2cd629$var$HostTransitionContext) : current = [
                $e229cb5c8b2cd629$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $e229cb5c8b2cd629$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$e229cb5c8b2cd629$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = workInProgress;
    $e229cb5c8b2cd629$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $e229cb5c8b2cd629$var$readContext(context) {
    return $e229cb5c8b2cd629$var$readContextForConsumer($e229cb5c8b2cd629$var$currentlyRenderingFiber$1, context);
}
function $e229cb5c8b2cd629$var$readContextDuringReconciliation(consumer, context) {
    null === $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 && $e229cb5c8b2cd629$var$prepareToReadContext(consumer);
    return $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context);
}
function $e229cb5c8b2cd629$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $e229cb5c8b2cd629$var$lastContextDependency) {
        if (null === consumer) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(308));
        $e229cb5c8b2cd629$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$lastContextDependency.next = context;
    return value;
}
var $e229cb5c8b2cd629$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $e229cb5c8b2cd629$var$scheduleCallback$2 = $4LCdk.unstable_scheduleCallback, $e229cb5c8b2cd629$var$NormalPriority = $4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$CacheContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$createCache() {
    return {
        controller: new $e229cb5c8b2cd629$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $e229cb5c8b2cd629$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $e229cb5c8b2cd629$var$scheduleCallback$2($e229cb5c8b2cd629$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $e229cb5c8b2cd629$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $e229cb5c8b2cd629$var$entangledTransitionTypes = null;
function $e229cb5c8b2cd629$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $e229cb5c8b2cd629$var$currentEntangledListeners = null, $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0, $e229cb5c8b2cd629$var$currentEntangledLane = 0, $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
function $e229cb5c8b2cd629$var$entangleAsyncAction(transition, thenable) {
    if (null === $e229cb5c8b2cd629$var$currentEntangledListeners) {
        var entangledListeners = $e229cb5c8b2cd629$var$currentEntangledListeners = [];
        $e229cb5c8b2cd629$var$currentEntangledPendingCount = 0;
        $e229cb5c8b2cd629$var$currentEntangledLane = $e229cb5c8b2cd629$var$requestTransitionLane();
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $e229cb5c8b2cd629$var$currentEntangledPendingCount++;
    thenable.then($e229cb5c8b2cd629$var$pingEngtangledActionScope, $e229cb5c8b2cd629$var$pingEngtangledActionScope);
    return thenable;
}
function $e229cb5c8b2cd629$var$pingEngtangledActionScope() {
    if (0 === --$e229cb5c8b2cd629$var$currentEntangledPendingCount && ($e229cb5c8b2cd629$var$entangledTransitionTypes = null, null !== $e229cb5c8b2cd629$var$currentEntangledListeners)) {
        null !== $e229cb5c8b2cd629$var$currentEntangledActionThenable && ($e229cb5c8b2cd629$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $e229cb5c8b2cd629$var$currentEntangledListeners;
        $e229cb5c8b2cd629$var$currentEntangledListeners = null;
        $e229cb5c8b2cd629$var$currentEntangledLane = 0;
        $e229cb5c8b2cd629$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $e229cb5c8b2cd629$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $e229cb5c8b2cd629$var$prevOnStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
$e229cb5c8b2cd629$var$ReactSharedInternals.S = function(transition, returnValue) {
    $e229cb5c8b2cd629$var$globalMostRecentTransitionTime = $e229cb5c8b2cd629$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $e229cb5c8b2cd629$var$entangleAsyncAction(transition, returnValue);
    if (null !== $e229cb5c8b2cd629$var$entangledTransitionTypes) for(var root$28 = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root$28;)$e229cb5c8b2cd629$var$queueTransitionTypes(root$28, $e229cb5c8b2cd629$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root$29;)$e229cb5c8b2cd629$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $e229cb5c8b2cd629$var$currentEntangledLane) {
            root$29 = $e229cb5c8b2cd629$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $e229cb5c8b2cd629$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $e229cb5c8b2cd629$var$prevOnStartTransitionFinish && $e229cb5c8b2cd629$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $e229cb5c8b2cd629$var$resumedCache = $e229cb5c8b2cd629$var$createCursor(null);
function $e229cb5c8b2cd629$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $e229cb5c8b2cd629$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $e229cb5c8b2cd629$var$workInProgressRoot.pooledCache;
}
function $e229cb5c8b2cd629$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, $e229cb5c8b2cd629$var$resumedCache.current) : $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$resumedCache, prevCachePool.pool);
}
function $e229cb5c8b2cd629$var$getSuspendedCache() {
    var cacheFromPool = $e229cb5c8b2cd629$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $e229cb5c8b2cd629$var$SuspenseException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(460)), $e229cb5c8b2cd629$var$SuspenseyCommitException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(474)), $e229cb5c8b2cd629$var$SuspenseActionException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(542)), $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $e229cb5c8b2cd629$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $e229cb5c8b2cd629$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($e229cb5c8b2cd629$var$noop$1, $e229cb5c8b2cd629$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($e229cb5c8b2cd629$var$noop$1, $e229cb5c8b2cd629$var$noop$1);
            else {
                thenableState = $e229cb5c8b2cd629$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $e229cb5c8b2cd629$var$suspendedThenable = thenable;
            throw $e229cb5c8b2cd629$var$SuspenseException;
    }
}
function $e229cb5c8b2cd629$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $e229cb5c8b2cd629$var$suspendedThenable = x, $e229cb5c8b2cd629$var$SuspenseException;
        throw x;
    }
}
var $e229cb5c8b2cd629$var$suspendedThenable = null;
function $e229cb5c8b2cd629$var$getSuspendedThenable() {
    if (null === $e229cb5c8b2cd629$var$suspendedThenable) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(459));
    var thenable = $e229cb5c8b2cd629$var$suspendedThenable;
    $e229cb5c8b2cd629$var$suspendedThenable = null;
    return thenable;
}
function $e229cb5c8b2cd629$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $e229cb5c8b2cd629$var$SuspenseException || rejectedReason === $e229cb5c8b2cd629$var$SuspenseActionException) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(483));
}
var $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
function $e229cb5c8b2cd629$var$unwrapThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter$1;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 += 1;
    null === $e229cb5c8b2cd629$var$thenableState$1 && ($e229cb5c8b2cd629$var$thenableState$1 = []);
    return $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState$1, thenable, index);
}
function $e229cb5c8b2cd629$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $e229cb5c8b2cd629$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $e229cb5c8b2cd629$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $e229cb5c8b2cd629$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $e229cb5c8b2cd629$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $e229cb5c8b2cd629$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $e229cb5c8b2cd629$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $e229cb5c8b2cd629$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $e229cb5c8b2cd629$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return newChild = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild) || $e229cb5c8b2cd629$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $e229cb5c8b2cd629$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $e229cb5c8b2cd629$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $e229cb5c8b2cd629$var$REACT_LAZY_TYPE && $e229cb5c8b2cd629$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $e229cb5c8b2cd629$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $e229cb5c8b2cd629$var$REACT_FRAGMENT_TYPE ? (lanes = $e229cb5c8b2cd629$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $e229cb5c8b2cd629$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $e229cb5c8b2cd629$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $e229cb5c8b2cd629$var$REACT_LAZY_TYPE:
                    return newChild = $e229cb5c8b2cd629$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($e229cb5c8b2cd629$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($e229cb5c8b2cd629$var$getIteratorFn(newChild)) {
                key = $e229cb5c8b2cd629$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $e229cb5c8b2cd629$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $e229cb5c8b2cd629$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $e229cb5c8b2cd629$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $e229cb5c8b2cd629$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $e229cb5c8b2cd629$var$SuspenseException || x === $e229cb5c8b2cd629$var$SuspenseActionException) throw x;
            var fiber = $e229cb5c8b2cd629$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $e229cb5c8b2cd629$var$reconcileChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!0), $e229cb5c8b2cd629$var$mountChildFibers = $e229cb5c8b2cd629$var$createChildReconciler(!1), $e229cb5c8b2cd629$var$hasForceUpdate = !1;
function $e229cb5c8b2cd629$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $e229cb5c8b2cd629$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e229cb5c8b2cd629$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
        $e229cb5c8b2cd629$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $e229cb5c8b2cd629$var$getRootForUpdatedFiber(fiber);
}
function $e229cb5c8b2cd629$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
function $e229cb5c8b2cd629$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
function $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $e229cb5c8b2cd629$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $e229cb5c8b2cd629$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && ($e229cb5c8b2cd629$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $e229cb5c8b2cd629$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $e229cb5c8b2cd629$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $e229cb5c8b2cd629$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$e229cb5c8b2cd629$var$callCallback(callbacks[updateQueue], context);
}
var $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$pushHiddenContext(fiber, context) {
    fiber = $e229cb5c8b2cd629$var$entangledRenderLanes;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, fiber);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, context);
    $e229cb5c8b2cd629$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $e229cb5c8b2cd629$var$reuseHiddenContextOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor, $e229cb5c8b2cd629$var$entangledRenderLanes);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor, $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current);
}
function $e229cb5c8b2cd629$var$popHiddenContext() {
    $e229cb5c8b2cd629$var$entangledRenderLanes = $e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor.current;
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$currentTreeHiddenStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$prevEntangledRenderLanesCursor);
}
var $e229cb5c8b2cd629$var$suspenseHandlerStackCursor = $e229cb5c8b2cd629$var$createCursor(null), $e229cb5c8b2cd629$var$shellBoundary = null;
function $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, handler);
    null === $e229cb5c8b2cd629$var$shellBoundary && (null === current || null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current ? $e229cb5c8b2cd629$var$shellBoundary = handler : null !== current.memoizedState && ($e229cb5c8b2cd629$var$shellBoundary = handler));
}
function $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, fiber);
    null === $e229cb5c8b2cd629$var$shellBoundary && ($e229cb5c8b2cd629$var$shellBoundary = fiber);
}
function $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, fiber), null === $e229cb5c8b2cd629$var$shellBoundary && ($e229cb5c8b2cd629$var$shellBoundary = fiber)) : $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack();
}
function $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack() {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current);
}
function $e229cb5c8b2cd629$var$popSuspenseHandler(fiber) {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseHandlerStackCursor);
    $e229cb5c8b2cd629$var$shellBoundary === fiber && ($e229cb5c8b2cd629$var$shellBoundary = null);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
}
var $e229cb5c8b2cd629$var$suspenseStackCursor = $e229cb5c8b2cd629$var$createCursor(0);
function $e229cb5c8b2cd629$var$pushSuspenseListContext(fiber, newContext) {
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current);
    $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, newContext);
}
function $e229cb5c8b2cd629$var$popSuspenseListContext(fiber) {
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseStackCursor);
    $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$suspenseHandlerStackCursor);
    $e229cb5c8b2cd629$var$shellBoundary === fiber && ($e229cb5c8b2cd629$var$shellBoundary = null);
}
function $e229cb5c8b2cd629$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $e229cb5c8b2cd629$var$isSuspenseInstancePending(state) || $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $e229cb5c8b2cd629$var$renderLanes = 0, $e229cb5c8b2cd629$var$currentlyRenderingFiber = null, $e229cb5c8b2cd629$var$currentHook = null, $e229cb5c8b2cd629$var$workInProgressHook = null, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1, $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $e229cb5c8b2cd629$var$localIdCounter = 0, $e229cb5c8b2cd629$var$thenableIndexCounter = 0, $e229cb5c8b2cd629$var$thenableState = null, $e229cb5c8b2cd629$var$globalClientIdCounter = 0;
function $e229cb5c8b2cd629$var$throwInvalidHookError() {
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(321));
}
function $e229cb5c8b2cd629$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$e229cb5c8b2cd629$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $e229cb5c8b2cd629$var$renderLanes = nextRenderLanes;
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate;
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $e229cb5c8b2cd629$var$finishRenderingHooks(current) {
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $e229cb5c8b2cd629$var$currentHook && null !== $e229cb5c8b2cd629$var$currentHook.next;
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(300));
    null === current || $e229cb5c8b2cd629$var$didReceiveUpdate || (current = current.dependencies, null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0));
}
function $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass && ($e229cb5c8b2cd629$var$thenableState = null);
        $e229cb5c8b2cd629$var$thenableIndexCounter = 0;
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $e229cb5c8b2cd629$var$TransitionAwareHostComponent() {
    var dispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $e229cb5c8b2cd629$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$currentHook.memoizedState : null) !== dispatcher && ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $e229cb5c8b2cd629$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $e229cb5c8b2cd629$var$localIdCounter;
    $e229cb5c8b2cd629$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $e229cb5c8b2cd629$var$resetHooksOnUnwind(workInProgress) {
    if ($e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !1;
    }
    $e229cb5c8b2cd629$var$renderLanes = 0;
    $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$currentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $e229cb5c8b2cd629$var$thenableIndexCounter = $e229cb5c8b2cd629$var$localIdCounter = 0;
    $e229cb5c8b2cd629$var$thenableState = null;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = hook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = hook;
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
function $e229cb5c8b2cd629$var$updateWorkInProgressHook() {
    if (null === $e229cb5c8b2cd629$var$currentHook) {
        var nextCurrentHook = $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $e229cb5c8b2cd629$var$currentHook.next;
    var nextWorkInProgressHook = null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $e229cb5c8b2cd629$var$workInProgressHook = nextWorkInProgressHook, $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(467));
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(310));
        }
        $e229cb5c8b2cd629$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $e229cb5c8b2cd629$var$currentHook.memoizedState,
            baseState: $e229cb5c8b2cd629$var$currentHook.baseState,
            baseQueue: $e229cb5c8b2cd629$var$currentHook.baseQueue,
            queue: $e229cb5c8b2cd629$var$currentHook.queue,
            next: null
        };
        null === $e229cb5c8b2cd629$var$workInProgressHook ? $e229cb5c8b2cd629$var$currentlyRenderingFiber.memoizedState = $e229cb5c8b2cd629$var$workInProgressHook = nextCurrentHook : $e229cb5c8b2cd629$var$workInProgressHook = $e229cb5c8b2cd629$var$workInProgressHook.next = nextCurrentHook;
    }
    return $e229cb5c8b2cd629$var$workInProgressHook;
}
function $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $e229cb5c8b2cd629$var$useThenable(thenable) {
    var index = $e229cb5c8b2cd629$var$thenableIndexCounter;
    $e229cb5c8b2cd629$var$thenableIndexCounter += 1;
    null === $e229cb5c8b2cd629$var$thenableState && ($e229cb5c8b2cd629$var$thenableState = []);
    thenable = $e229cb5c8b2cd629$var$trackUsedThenable($e229cb5c8b2cd629$var$thenableState, thenable, index);
    index = $e229cb5c8b2cd629$var$currentlyRenderingFiber;
    null === (null === $e229cb5c8b2cd629$var$workInProgressHook ? index.memoizedState : $e229cb5c8b2cd629$var$workInProgressHook.next) && (index = index.alternate, $e229cb5c8b2cd629$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $e229cb5c8b2cd629$var$HooksDispatcherOnMount : $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $e229cb5c8b2cd629$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $e229cb5c8b2cd629$var$useThenable(usable);
        if (usable.$$typeof === $e229cb5c8b2cd629$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) return $e229cb5c8b2cd629$var$readContext(usable);
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(438, String(usable)));
}
function $e229cb5c8b2cd629$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $e229cb5c8b2cd629$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $e229cb5c8b2cd629$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $e229cb5c8b2cd629$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $e229cb5c8b2cd629$var$updateReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, reducer);
}
function $e229cb5c8b2cd629$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($e229cb5c8b2cd629$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($e229cb5c8b2cd629$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $e229cb5c8b2cd629$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= revertLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= updateLane, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$e229cb5c8b2cd629$var$objectIs(pendingQueue, hook.memoizedState) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $e229cb5c8b2cd629$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $e229cb5c8b2cd629$var$rerenderReducer(reducer) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $e229cb5c8b2cd629$var$objectIs(newState, hook.memoizedState) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $e229cb5c8b2cd629$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber, hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $e229cb5c8b2cd629$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$e229cb5c8b2cd629$var$objectIs(($e229cb5c8b2cd629$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $e229cb5c8b2cd629$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $e229cb5c8b2cd629$var$updateEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $e229cb5c8b2cd629$var$workInProgressHook && 0 !== ($e229cb5c8b2cd629$var$workInProgressHook.memoizedState.tag & 1);
    $e229cb5c8b2cd629$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 127) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $e229cb5c8b2cd629$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
}
function $e229cb5c8b2cd629$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) && $e229cb5c8b2cd629$var$forceStoreRerender(fiber);
    });
}
function $e229cb5c8b2cd629$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$e229cb5c8b2cd629$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $e229cb5c8b2cd629$var$forceStoreRerender(fiber) {
    var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $e229cb5c8b2cd629$var$mountStateImpl(initialState) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $e229cb5c8b2cd629$var$updateReducerImpl(hook, $e229cb5c8b2cd629$var$currentHook, "function" === typeof reducer ? reducer : $e229cb5c8b2cd629$var$basicStateReducer);
}
function $e229cb5c8b2cd629$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error$70);
    }
}
function $e229cb5c8b2cd629$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $e229cb5c8b2cd629$var$onActionError(actionQueue, node, error);
    }) : $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, node, returnValue);
}
function $e229cb5c8b2cd629$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $e229cb5c8b2cd629$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $e229cb5c8b2cd629$var$runActionStateAction(actionQueue, nextState)));
}
function $e229cb5c8b2cd629$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $e229cb5c8b2cd629$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $e229cb5c8b2cd629$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $e229cb5c8b2cd629$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $e229cb5c8b2cd629$var$mountActionState(action, initialStateProp) {
    if ($e229cb5c8b2cd629$var$isHydrating) {
        var ssrFormState = $e229cb5c8b2cd629$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $e229cb5c8b2cd629$var$currentlyRenderingFiber;
                if ($e229cb5c8b2cd629$var$isHydrating) {
                    if ($e229cb5c8b2cd629$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $e229cb5c8b2cd629$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $e229cb5c8b2cd629$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e229cb5c8b2cd629$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountStateImpl(!1);
    inRootOrSingleton = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $e229cb5c8b2cd629$var$dispatchActionState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $e229cb5c8b2cd629$var$updateActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, $e229cb5c8b2cd629$var$currentHook, action);
}
function $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $e229cb5c8b2cd629$var$updateReducerImpl(stateHook, currentStateHook, $e229cb5c8b2cd629$var$actionStateReducer)[0];
    stateHook = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $e229cb5c8b2cd629$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $e229cb5c8b2cd629$var$SuspenseException) throw $e229cb5c8b2cd629$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 2048, $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $e229cb5c8b2cd629$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $e229cb5c8b2cd629$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $e229cb5c8b2cd629$var$rerenderActionState(action) {
    var stateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook(), currentStateHook = $e229cb5c8b2cd629$var$currentHook;
    if (null !== currentStateHook) return $e229cb5c8b2cd629$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $e229cb5c8b2cd629$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $e229cb5c8b2cd629$var$updateRef() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $e229cb5c8b2cd629$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $e229cb5c8b2cd629$var$currentHook && null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, $e229cb5c8b2cd629$var$currentHook.memoizedState.deps) ? hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $e229cb5c8b2cd629$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $e229cb5c8b2cd629$var$mountEffect(create, deps) {
    $e229cb5c8b2cd629$var$mountEffectImpl(8390656, 8, create, deps);
}
function $e229cb5c8b2cd629$var$updateEffect(create, deps) {
    $e229cb5c8b2cd629$var$updateEffectImpl(2048, 8, create, deps);
}
function $e229cb5c8b2cd629$var$useEffectEventImpl(payload) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $e229cb5c8b2cd629$var$createFunctionComponentUpdateQueue(), $e229cb5c8b2cd629$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $e229cb5c8b2cd629$var$updateEvent(callback) {
    var ref = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
    $e229cb5c8b2cd629$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $e229cb5c8b2cd629$var$updateInsertionEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 2, create, deps);
}
function $e229cb5c8b2cd629$var$updateLayoutEffect(create, deps) {
    return $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, create, deps);
}
function $e229cb5c8b2cd629$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $e229cb5c8b2cd629$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $e229cb5c8b2cd629$var$updateEffectImpl(4, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $e229cb5c8b2cd629$var$mountDebugValue() {}
function $e229cb5c8b2cd629$var$updateCallback(callback, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $e229cb5c8b2cd629$var$updateMemo(nextCreate, deps) {
    var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $e229cb5c8b2cd629$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 1073741824) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($e229cb5c8b2cd629$var$objectIs(value, prevValue)) return value;
    if (null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current) return hook = $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue), $e229cb5c8b2cd629$var$objectIs(hook, prevValue) || ($e229cb5c8b2cd629$var$didReceiveUpdate = !0), hook;
    if (0 === ($e229cb5c8b2cd629$var$renderLanes & 106) || 0 !== ($e229cb5c8b2cd629$var$renderLanes & 1073741824) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 261930)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $e229cb5c8b2cd629$var$requestDeferredLane();
    $e229cb5c8b2cd629$var$currentlyRenderingFiber.lanes |= hook;
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $e229cb5c8b2cd629$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = currentTransition;
    $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $e229cb5c8b2cd629$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $e229cb5c8b2cd629$var$chainThenableValue(returnValue, finishedState);
            $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
        } else $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, finishedState, $e229cb5c8b2cd629$var$requestUpdateLane(fiber));
    } catch (error) {
        $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $e229cb5c8b2cd629$var$requestUpdateLane());
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$noop() {}
function $e229cb5c8b2cd629$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(476));
    var queue = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber).queue;
    $e229cb5c8b2cd629$var$startTransition(formFiber, queue, pendingState, $e229cb5c8b2cd629$var$sharedNotPendingObject, null === action ? $e229cb5c8b2cd629$var$noop : function() {
        $e229cb5c8b2cd629$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseState: $e229cb5c8b2cd629$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: $e229cb5c8b2cd629$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $e229cb5c8b2cd629$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $e229cb5c8b2cd629$var$requestFormReset$1(formFiber) {
    var stateHook = $e229cb5c8b2cd629$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $e229cb5c8b2cd629$var$requestUpdateLane());
}
function $e229cb5c8b2cd629$var$useHostTransitionStatus() {
    return $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$HostTransitionContext);
}
function $e229cb5c8b2cd629$var$updateId() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$updateRefresh() {
    return $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
}
function $e229cb5c8b2cd629$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
                fiber = $e229cb5c8b2cd629$var$createUpdate(lane);
                var root$73 = $e229cb5c8b2cd629$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root$73, provider, lane), $e229cb5c8b2cd629$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $e229cb5c8b2cd629$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $e229cb5c8b2cd629$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) ? $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, action) : (action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane)));
}
function $e229cb5c8b2cd629$var$dispatchSetState(fiber, queue, action) {
    var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $e229cb5c8b2cd629$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($e229cb5c8b2cd629$var$objectIs(eagerState, currentState)) return $e229cb5c8b2cd629$var$enqueueUpdate$1(fiber, queue, update, 0), null === $e229cb5c8b2cd629$var$workInProgressRoot && $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(action, fiber, lane), $e229cb5c8b2cd629$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $e229cb5c8b2cd629$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $e229cb5c8b2cd629$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $e229cb5c8b2cd629$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $e229cb5c8b2cd629$var$currentlyRenderingFiber || null !== alternate && alternate === $e229cb5c8b2cd629$var$currentlyRenderingFiber;
}
function $e229cb5c8b2cd629$var$enqueueRenderPhaseUpdate(queue, update) {
    $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdateDuringThisPass = $e229cb5c8b2cd629$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $e229cb5c8b2cd629$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $e229cb5c8b2cd629$var$markRootEntangled(root, lane);
    }
}
var $e229cb5c8b2cd629$var$ContextOnlyDispatcher = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useContext: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useImperativeHandle: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useLayoutEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useInsertionEffect: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useMemo: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useReducer: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useRef: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDebugValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useDeferredValue: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useTransition: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useSyncExternalStore: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useId: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useFormState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useActionState: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useOptimistic: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useMemoCache: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useCacheRefresh: $e229cb5c8b2cd629$var$throwInvalidHookError,
    useEffectEvent: $e229cb5c8b2cd629$var$throwInvalidHookError
}, $e229cb5c8b2cd629$var$HooksDispatcherOnMount = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: function(callback, deps) {
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, $e229cb5c8b2cd629$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $e229cb5c8b2cd629$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $e229cb5c8b2cd629$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($e229cb5c8b2cd629$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $e229cb5c8b2cd629$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $e229cb5c8b2cd629$var$dispatchReducerAction.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $e229cb5c8b2cd629$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $e229cb5c8b2cd629$var$dispatchSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        return $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $e229cb5c8b2cd629$var$mountStateImpl(!1);
        stateHook = $e229cb5c8b2cd629$var$startTransition.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $e229cb5c8b2cd629$var$currentlyRenderingFiber, hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        if ($e229cb5c8b2cd629$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $e229cb5c8b2cd629$var$workInProgressRoot) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(349));
            0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 127) || $e229cb5c8b2cd629$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $e229cb5c8b2cd629$var$mountEffect($e229cb5c8b2cd629$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $e229cb5c8b2cd629$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $e229cb5c8b2cd629$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook(), identifierPrefix = $e229cb5c8b2cd629$var$workInProgressRoot.identifierPrefix;
        if ($e229cb5c8b2cd629$var$isHydrating) {
            var JSCompiler_inline_result = $e229cb5c8b2cd629$var$treeContextOverflow;
            var idWithLeadingBit = $e229cb5c8b2cd629$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $e229cb5c8b2cd629$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $e229cb5c8b2cd629$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$mountActionState,
    useActionState: $e229cb5c8b2cd629$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $e229cb5c8b2cd629$var$dispatchOptimisticSetState.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: function() {
        return $e229cb5c8b2cd629$var$mountWorkInProgressHook().memoizedState = $e229cb5c8b2cd629$var$refreshCache.bind(null, $e229cb5c8b2cd629$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $e229cb5c8b2cd629$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($e229cb5c8b2cd629$var$executionContext & 2)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $e229cb5c8b2cd629$var$HooksDispatcherOnUpdate = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$updateReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$updateReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$updateActionState,
    useActionState: $e229cb5c8b2cd629$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: $e229cb5c8b2cd629$var$updateRefresh,
    useEffectEvent: $e229cb5c8b2cd629$var$updateEvent
}, $e229cb5c8b2cd629$var$HooksDispatcherOnRerender = {
    readContext: $e229cb5c8b2cd629$var$readContext,
    use: $e229cb5c8b2cd629$var$use,
    useCallback: $e229cb5c8b2cd629$var$updateCallback,
    useContext: $e229cb5c8b2cd629$var$readContext,
    useEffect: $e229cb5c8b2cd629$var$updateEffect,
    useImperativeHandle: $e229cb5c8b2cd629$var$updateImperativeHandle,
    useInsertionEffect: $e229cb5c8b2cd629$var$updateInsertionEffect,
    useLayoutEffect: $e229cb5c8b2cd629$var$updateLayoutEffect,
    useMemo: $e229cb5c8b2cd629$var$updateMemo,
    useReducer: $e229cb5c8b2cd629$var$rerenderReducer,
    useRef: $e229cb5c8b2cd629$var$updateRef,
    useState: function() {
        return $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer);
    },
    useDebugValue: $e229cb5c8b2cd629$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        return null === $e229cb5c8b2cd629$var$currentHook ? $e229cb5c8b2cd629$var$mountDeferredValueImpl(hook, value, initialValue) : $e229cb5c8b2cd629$var$updateDeferredValueImpl(hook, $e229cb5c8b2cd629$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $e229cb5c8b2cd629$var$rerenderReducer($e229cb5c8b2cd629$var$basicStateReducer)[0], start = $e229cb5c8b2cd629$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $e229cb5c8b2cd629$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $e229cb5c8b2cd629$var$updateSyncExternalStore,
    useId: $e229cb5c8b2cd629$var$updateId,
    useHostTransitionStatus: $e229cb5c8b2cd629$var$useHostTransitionStatus,
    useFormState: $e229cb5c8b2cd629$var$rerenderActionState,
    useActionState: $e229cb5c8b2cd629$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $e229cb5c8b2cd629$var$updateWorkInProgressHook();
        if (null !== $e229cb5c8b2cd629$var$currentHook) return $e229cb5c8b2cd629$var$updateOptimisticImpl(hook, $e229cb5c8b2cd629$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $e229cb5c8b2cd629$var$useMemoCache,
    useCacheRefresh: $e229cb5c8b2cd629$var$updateRefresh,
    useEffectEvent: $e229cb5c8b2cd629$var$updateEvent
};
function $e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $e229cb5c8b2cd629$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $e229cb5c8b2cd629$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(payload, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane(), update = $e229cb5c8b2cd629$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $e229cb5c8b2cd629$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(callback, inst, lane), $e229cb5c8b2cd629$var$entangleTransitions(callback, inst, lane));
    }
};
function $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$e229cb5c8b2cd629$var$shallowEqual(oldProps, newProps) || !$e229cb5c8b2cd629$var$shallowEqual(oldState, newState) : !0;
}
function $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $e229cb5c8b2cd629$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $e229cb5c8b2cd629$var$defaultOnUncaughtError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $e229cb5c8b2cd629$var$defaultOnRecoverableError(error) {
    $e229cb5c8b2cd629$var$reportGlobalError(error);
}
function $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $e229cb5c8b2cd629$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $e229cb5c8b2cd629$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $e229cb5c8b2cd629$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $e229cb5c8b2cd629$var$createClassErrorUpdate(lane) {
    lane = $e229cb5c8b2cd629$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $e229cb5c8b2cd629$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $e229cb5c8b2cd629$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed ? $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $e229cb5c8b2cd629$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $e229cb5c8b2cd629$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $e229cb5c8b2cd629$var$shellBoundary ? $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $e229cb5c8b2cd629$var$attachPingListener(root, value, rootRenderLanes);
        $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($e229cb5c8b2cd629$var$isHydrating) return returnFiber = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (root = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(422), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $e229cb5c8b2cd629$var$HydrationMismatchException && (returnFiber = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(423), {
        cause: value
    }), $e229cb5c8b2cd629$var$queueHydrationError($e229cb5c8b2cd629$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $e229cb5c8b2cd629$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors ? $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $e229cb5c8b2cd629$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $e229cb5c8b2cd629$var$createClassErrorUpdate(rootRenderLanes), $e229cb5c8b2cd629$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $e229cb5c8b2cd629$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $e229cb5c8b2cd629$var$SelectiveHydrationException = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(461)), $e229cb5c8b2cd629$var$didReceiveUpdate = !1;
function $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    nextProps = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && key && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$e229cb5c8b2cd629$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $e229cb5c8b2cd629$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $e229cb5c8b2cd629$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $e229cb5c8b2cd629$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($e229cb5c8b2cd629$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($e229cb5c8b2cd629$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($e229cb5c8b2cd629$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState) : $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($e229cb5c8b2cd629$var$pushTransition(workInProgress, prevState.cachePool), $e229cb5c8b2cd629$var$pushHiddenContext(workInProgress, prevState), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null), $e229cb5c8b2cd629$var$reuseHiddenContextOnStack(), $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack());
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $e229cb5c8b2cd629$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $e229cb5c8b2cd629$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $e229cb5c8b2cd629$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $e229cb5c8b2cd629$var$pushTransition(workInProgress, null);
    $e229cb5c8b2cd629$var$reuseHiddenContextOnStack();
    $e229cb5c8b2cd629$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $e229cb5c8b2cd629$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($e229cb5c8b2cd629$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, current);
            $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $e229cb5c8b2cd629$var$nextHydratableInstance) ? (current = $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(current, $e229cb5c8b2cd629$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $e229cb5c8b2cd629$var$treeContextProvider ? {
                    id: $e229cb5c8b2cd629$var$treeContextId,
                    overflow: $e229cb5c8b2cd629$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(558));
        } else if ($e229cb5c8b2cd629$var$didReceiveUpdate || $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $e229cb5c8b2cd629$var$didReceiveUpdate || didSuspend) {
            if (null === $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current) {
                nextProps = $e229cb5c8b2cd629$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $e229cb5c8b2cd629$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(current, dehydrated), $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $e229cb5c8b2cd629$var$SelectiveHydrationException;
                $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $e229cb5c8b2cd629$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(dehydrated.nextSibling), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$isHydrating = !0, $e229cb5c8b2cd629$var$hydrationErrors = null, $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, null !== current && $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $e229cb5c8b2cd629$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $e229cb5c8b2cd629$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $e229cb5c8b2cd629$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    Component = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && nextProps && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $e229cb5c8b2cd629$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $e229cb5c8b2cd629$var$finishRenderingHooks(current);
    Component = $e229cb5c8b2cd629$var$checkDidRenderIdHook();
    if (null !== current && !$e229cb5c8b2cd629$var$didReceiveUpdate) return $e229cb5c8b2cd629$var$bailoutHooks(current, workInProgress, renderLanes), $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $e229cb5c8b2cd629$var$isHydrating && Component && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $e229cb5c8b2cd629$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $e229cb5c8b2cd629$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $e229cb5c8b2cd629$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $e229cb5c8b2cd629$var$readContext(contextType) : $e229cb5c8b2cd629$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $e229cb5c8b2cd629$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $e229cb5c8b2cd629$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $e229cb5c8b2cd629$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $e229cb5c8b2cd629$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $e229cb5c8b2cd629$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $e229cb5c8b2cd629$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $e229cb5c8b2cd629$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $e229cb5c8b2cd629$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $e229cb5c8b2cd629$var$hasForceUpdate || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($e229cb5c8b2cd629$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $e229cb5c8b2cd629$var$hasForceUpdate || $e229cb5c8b2cd629$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $e229cb5c8b2cd629$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $e229cb5c8b2cd629$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $e229cb5c8b2cd629$var$resetHydrationState();
    workInProgress.flags |= 256;
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $e229cb5c8b2cd629$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $e229cb5c8b2cd629$var$getSuspendedCache()
    };
}
function $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $e229cb5c8b2cd629$var$workInProgressDeferredLane);
    return current;
}
function $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($e229cb5c8b2cd629$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($e229cb5c8b2cd629$var$isHydrating) {
            showFallback ? $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack();
            (current = $e229cb5c8b2cd629$var$nextHydratableInstance) ? (current = $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(current, $e229cb5c8b2cd629$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $e229cb5c8b2cd629$var$treeContextProvider ? {
                    id: $e229cb5c8b2cd629$var$treeContextId,
                    overflow: $e229cb5c8b2cd629$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $e229cb5c8b2cd629$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $e229cb5c8b2cd629$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps);
        $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $e229cb5c8b2cd629$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $e229cb5c8b2cd629$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $e229cb5c8b2cd629$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $e229cb5c8b2cd629$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $e229cb5c8b2cd629$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $e229cb5c8b2cd629$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER, $e229cb5c8b2cd629$var$bailoutOffscreenComponent(current.child, nextProps);
    $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $e229cb5c8b2cd629$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $e229cb5c8b2cd629$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $e229cb5c8b2cd629$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $e229cb5c8b2cd629$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $e229cb5c8b2cd629$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $e229cb5c8b2cd629$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $e229cb5c8b2cd629$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $e229cb5c8b2cd629$var$SUSPENDED_MARKER;
        return $e229cb5c8b2cd629$var$bailoutOffscreenComponent(null, nextProps);
    }
    $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($e229cb5c8b2cd629$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($e229cb5c8b2cd629$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $e229cb5c8b2cd629$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $e229cb5c8b2cd629$var$didReceiveUpdate || $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($e229cb5c8b2cd629$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $e229cb5c8b2cd629$var$currentTreeHiddenStackCursor.current) return $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $e229cb5c8b2cd629$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $e229cb5c8b2cd629$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(current, nextProps), $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $e229cb5c8b2cd629$var$SelectiveHydrationException;
        $e229cb5c8b2cd629$var$isSuspenseInstancePending(suspenseInstance) || $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible();
        return $e229cb5c8b2cd629$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($e229cb5c8b2cd629$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(suspenseInstance.nextSibling);
    $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress;
    $e229cb5c8b2cd629$var$isHydrating = !0;
    $e229cb5c8b2cd629$var$hydrationErrors = null;
    $e229cb5c8b2cd629$var$rootOrSingletonContext = !1;
    null !== current && $e229cb5c8b2cd629$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $e229cb5c8b2cd629$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $e229cb5c8b2cd629$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $e229cb5c8b2cd629$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $e229cb5c8b2cd629$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $e229cb5c8b2cd629$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $e229cb5c8b2cd629$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $e229cb5c8b2cd629$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $e229cb5c8b2cd629$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($e229cb5c8b2cd629$var$reverseChildren(current), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $e229cb5c8b2cd629$var$reverseChildren(current)) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $e229cb5c8b2cd629$var$isHydrating ? $e229cb5c8b2cd629$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $e229cb5c8b2cd629$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $e229cb5c8b2cd629$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $e229cb5c8b2cd629$var$reverseChildren(workInProgress));
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $e229cb5c8b2cd629$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $e229cb5c8b2cd629$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $e229cb5c8b2cd629$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $e229cb5c8b2cd629$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $e229cb5c8b2cd629$var$checkIfContextChanged(current) ? !0 : !1;
}
function $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
            $e229cb5c8b2cd629$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            break;
        case 4:
            $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $e229cb5c8b2cd629$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $e229cb5c8b2cd629$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($e229cb5c8b2cd629$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $e229cb5c8b2cd629$var$pushSuspenseListContext(workInProgress, $e229cb5c8b2cd629$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, current.memoizedState.cache);
    }
    return $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $e229cb5c8b2cd629$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $e229cb5c8b2cd629$var$didReceiveUpdate = !0;
        else {
            if (!$e229cb5c8b2cd629$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $e229cb5c8b2cd629$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $e229cb5c8b2cd629$var$didReceiveUpdate = !1, $e229cb5c8b2cd629$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $e229cb5c8b2cd629$var$pushTreeId(workInProgress, $e229cb5c8b2cd629$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $e229cb5c8b2cd629$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $e229cb5c8b2cd629$var$shouldConstruct(current) ? (props = $e229cb5c8b2cd629$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $e229cb5c8b2cd629$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $e229cb5c8b2cd629$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $e229cb5c8b2cd629$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $e229cb5c8b2cd629$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $e229cb5c8b2cd629$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $e229cb5c8b2cd629$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $e229cb5c8b2cd629$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $e229cb5c8b2cd629$var$getComponentNameFromType(current) || current;
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $e229cb5c8b2cd629$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $e229cb5c8b2cd629$var$resolveClassComponentProps(props, workInProgress.pendingProps), $e229cb5c8b2cd629$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress);
                $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props);
                props !== prevState.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                    $e229cb5c8b2cd629$var$CacheContext
                ], renderLanes, !0);
                $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(Error($e229cb5c8b2cd629$var$formatProdErrorMessage(424)), workInProgress);
                        $e229cb5c8b2cd629$var$queueHydrationError($$typeof);
                        workInProgress = $e229cb5c8b2cd629$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(current.firstChild);
                        $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress;
                        $e229cb5c8b2cd629$var$isHydrating = !0;
                        $e229cb5c8b2cd629$var$hydrationErrors = null;
                        $e229cb5c8b2cd629$var$rootOrSingletonContext = !0;
                        renderLanes = $e229cb5c8b2cd629$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $e229cb5c8b2cd629$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $e229cb5c8b2cd629$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $e229cb5c8b2cd629$var$markRef(current, workInProgress), null === current ? (renderLanes = $e229cb5c8b2cd629$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $e229cb5c8b2cd629$var$isHydrating || (workInProgress.stateNode = $e229cb5c8b2cd629$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $e229cb5c8b2cd629$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $e229cb5c8b2cd629$var$pushHostContext(workInProgress), null === current && $e229cb5c8b2cd629$var$isHydrating && (props = workInProgress.stateNode = $e229cb5c8b2cd629$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootInstanceStackCursor.current), $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$rootOrSingletonContext = !0, $$typeof = $e229cb5c8b2cd629$var$nextHydratableInstance, $e229cb5c8b2cd629$var$isSingletonScope(workInProgress.type) ? ($e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(props.firstChild)) : $e229cb5c8b2cd629$var$nextHydratableInstance = $$typeof), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $e229cb5c8b2cd629$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if ($$typeof = props = $e229cb5c8b2cd629$var$nextHydratableInstance) props = $e229cb5c8b2cd629$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = $e229cb5c8b2cd629$var$getNextHydratable(props.firstChild), $e229cb5c8b2cd629$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            $e229cb5c8b2cd629$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $e229cb5c8b2cd629$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $e229cb5c8b2cd629$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $e229cb5c8b2cd629$var$renderWithHooks(current, workInProgress, $e229cb5c8b2cd629$var$TransitionAwareHostComponent, null, null, renderLanes), $e229cb5c8b2cd629$var$HostTransitionContext._currentValue = $$typeof);
            $e229cb5c8b2cd629$var$markRef(current, workInProgress);
            $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $e229cb5c8b2cd629$var$isHydrating) {
                if (current = renderLanes = $e229cb5c8b2cd629$var$nextHydratableInstance) renderLanes = $e229cb5c8b2cd629$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $e229cb5c8b2cd629$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $e229cb5c8b2cd629$var$hydrationParentFiber = workInProgress, $e229cb5c8b2cd629$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $e229cb5c8b2cd629$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $e229cb5c8b2cd629$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $e229cb5c8b2cd629$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $e229cb5c8b2cd629$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $e229cb5c8b2cd629$var$markRef(current, workInProgress), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $e229cb5c8b2cd629$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), $$typeof = $e229cb5c8b2cd629$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $e229cb5c8b2cd629$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $e229cb5c8b2cd629$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $e229cb5c8b2cd629$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $e229cb5c8b2cd629$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $e229cb5c8b2cd629$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $e229cb5c8b2cd629$var$prepareToReadContext(workInProgress), props = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), null === current ? ($$typeof = $e229cb5c8b2cd629$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $e229cb5c8b2cd629$var$workInProgressRoot, prevState = $e229cb5c8b2cd629$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $e229cb5c8b2cd629$var$initializeUpdateQueue(workInProgress), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($e229cb5c8b2cd629$var$cloneUpdateQueue(current, workInProgress), $e229cb5c8b2cd629$var$processUpdateQueue(workInProgress, null, null, renderLanes), $e229cb5c8b2cd629$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props)) : (props = prevState.cache, $e229cb5c8b2cd629$var$pushProvider(workInProgress, $e229cb5c8b2cd629$var$CacheContext, props), props !== $$typeof.cache && $e229cb5c8b2cd629$var$propagateContextChanges(workInProgress, [
                $e229cb5c8b2cd629$var$CacheContext
            ], renderLanes, !0))), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $e229cb5c8b2cd629$var$markRef(current, workInProgress), $e229cb5c8b2cd629$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e229cb5c8b2cd629$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $e229cb5c8b2cd629$var$maySuspendCommit(type, newProps) : $e229cb5c8b2cd629$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $e229cb5c8b2cd629$var$suspendedThenable = $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable, $e229cb5c8b2cd629$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$e229cb5c8b2cd629$var$preloadResource(resource)) {
        if ($e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $e229cb5c8b2cd629$var$suspendedThenable = $e229cb5c8b2cd629$var$noopSuspenseyCommitThenable, $e229cb5c8b2cd629$var$SuspenseyCommitException;
    }
}
function $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $e229cb5c8b2cd629$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $e229cb5c8b2cd629$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$e229cb5c8b2cd629$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $e229cb5c8b2cd629$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $e229cb5c8b2cd629$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 1:
            return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable());
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), null !== nextResource ? ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            renderLanes = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $e229cb5c8b2cd629$var$contextStackCursor.current;
                $e229cb5c8b2cd629$var$popHydrationState(workInProgress) ? $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $e229cb5c8b2cd629$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $e229cb5c8b2cd629$var$markUpdate(workInProgress));
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $e229cb5c8b2cd629$var$contextStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) $e229cb5c8b2cd629$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer($e229cb5c8b2cd629$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    nextResource[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($e229cb5c8b2cd629$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
                }
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $e229cb5c8b2cd629$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $e229cb5c8b2cd629$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(166));
                current = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current;
                if ($e229cb5c8b2cd629$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $e229cb5c8b2cd629$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $e229cb5c8b2cd629$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $e229cb5c8b2cd629$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $e229cb5c8b2cd629$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(557));
                        current[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    } else $e229cb5c8b2cd629$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(558));
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $e229cb5c8b2cd629$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(317));
                        type[$e229cb5c8b2cd629$var$internalInstanceKey] = workInProgress;
                    } else $e229cb5c8b2cd629$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $e229cb5c8b2cd629$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), workInProgress;
                    $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null === current && $e229cb5c8b2cd629$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 19:
            $e229cb5c8b2cd629$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $e229cb5c8b2cd629$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $e229cb5c8b2cd629$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$e229cb5c8b2cd629$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $e229cb5c8b2cd629$var$pushSuspenseListContext(workInProgress, $e229cb5c8b2cd629$var$suspenseStackCursor.current & 1 | 2);
                            $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $e229cb5c8b2cd629$var$now() > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $e229cb5c8b2cd629$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, current), $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$e229cb5c8b2cd629$var$isHydrating) return $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
                    } else 2 * $e229cb5c8b2cd629$var$now() - newProps.renderingStartTime > $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $e229cb5c8b2cd629$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $e229cb5c8b2cd629$var$now();
                current.sibling = null;
                nextResource = $e229cb5c8b2cd629$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $e229cb5c8b2cd629$var$isHydrating ? $e229cb5c8b2cd629$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseHandlerStackCursor, workInProgress), $e229cb5c8b2cd629$var$push($e229cb5c8b2cd629$var$suspenseStackCursor, renderLanes), null === $e229cb5c8b2cd629$var$shellBoundary && ($e229cb5c8b2cd629$var$shellBoundary = workInProgress));
                $e229cb5c8b2cd629$var$isHydrating && $e229cb5c8b2cd629$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $e229cb5c8b2cd629$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($e229cb5c8b2cd629$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $e229cb5c8b2cd629$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $e229cb5c8b2cd629$var$bubbleProperties(workInProgress), null;
    }
    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $e229cb5c8b2cd629$var$unwindWork(current, workInProgress) {
    $e229cb5c8b2cd629$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), $e229cb5c8b2cd629$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $e229cb5c8b2cd629$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(340));
                $e229cb5c8b2cd629$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(340));
                $e229cb5c8b2cd629$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $e229cb5c8b2cd629$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $e229cb5c8b2cd629$var$popHostContainer(), null;
        case 10:
            return $e229cb5c8b2cd629$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $e229cb5c8b2cd629$var$popSuspenseHandler(workInProgress), $e229cb5c8b2cd629$var$popHiddenContext(), null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $e229cb5c8b2cd629$var$unwindInterruptedWork(current, interruptedWork) {
    $e229cb5c8b2cd629$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $e229cb5c8b2cd629$var$popHostContext(interruptedWork);
            break;
        case 4:
            $e229cb5c8b2cd629$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $e229cb5c8b2cd629$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $e229cb5c8b2cd629$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $e229cb5c8b2cd629$var$popSuspenseHandler(interruptedWork);
            $e229cb5c8b2cd629$var$popHiddenContext();
            null !== current && $e229cb5c8b2cd629$var$pop($e229cb5c8b2cd629$var$resumedCache);
            break;
        case 24:
            $e229cb5c8b2cd629$var$popProvider($e229cb5c8b2cd629$var$CacheContext);
    }
}
function $e229cb5c8b2cd629$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $e229cb5c8b2cd629$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $e229cb5c8b2cd629$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $e229cb5c8b2cd629$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $e229cb5c8b2cd629$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $e229cb5c8b2cd629$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $e229cb5c8b2cd629$var$FragmentInstance(current);
                        $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $e229cb5c8b2cd629$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $e229cb5c8b2cd629$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $e229cb5c8b2cd629$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$e229cb5c8b2cd629$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $e229cb5c8b2cd629$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $e229cb5c8b2cd629$var$isFragmentInstanceParent(parent) && $e229cb5c8b2cd629$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($e229cb5c8b2cd629$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $e229cb5c8b2cd629$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $e229cb5c8b2cd629$var$isFragmentInstanceParent(parent) && $e229cb5c8b2cd629$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($e229cb5c8b2cd629$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $e229cb5c8b2cd629$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $e229cb5c8b2cd629$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $e229cb5c8b2cd629$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $e229cb5c8b2cd629$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$e229cb5c8b2cd629$var$internalPropsKey] = newProps;
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $e229cb5c8b2cd629$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $e229cb5c8b2cd629$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $e229cb5c8b2cd629$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $e229cb5c8b2cd629$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $e229cb5c8b2cd629$var$noop$1)), $e229cb5c8b2cd629$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($e229cb5c8b2cd629$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $e229cb5c8b2cd629$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $e229cb5c8b2cd629$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($e229cb5c8b2cd629$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $e229cb5c8b2cd629$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$e229cb5c8b2cd629$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $e229cb5c8b2cd629$var$setInitialProperties(singleton, type, props);
        singleton[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
        singleton[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $e229cb5c8b2cd629$var$shouldStartViewTransition = !1, $e229cb5c8b2cd629$var$appearingViewTransitions = null;
function $e229cb5c8b2cd629$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $e229cb5c8b2cd629$var$shouldStartViewTransition = !0;
}
var $e229cb5c8b2cd629$var$viewTransitionCancelableChildren = null;
function $e229cb5c8b2cd629$var$pushViewTransitionCancelableScope() {
    var prevChildren = $e229cb5c8b2cd629$var$viewTransitionCancelableChildren;
    $e229cb5c8b2cd629$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx = 0;
function $e229cb5c8b2cd629$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx = 0;
    return $e229cb5c8b2cd629$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $e229cb5c8b2cd629$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $e229cb5c8b2cd629$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $e229cb5c8b2cd629$var$measureInstance(instance).view && (inViewport = !0);
            $e229cb5c8b2cd629$var$shouldStartViewTransition = !0;
            $e229cb5c8b2cd629$var$applyViewTransitionName(instance, 0 === $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx ? name : name + "_" + $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx, className);
            $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $e229cb5c8b2cd629$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $e229cb5c8b2cd629$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($e229cb5c8b2cd629$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $e229cb5c8b2cd629$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($e229cb5c8b2cd629$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $e229cb5c8b2cd629$var$getViewTransitionName(props, state), className = $e229cb5c8b2cd629$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $e229cb5c8b2cd629$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($e229cb5c8b2cd629$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $e229cb5c8b2cd629$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $e229cb5c8b2cd629$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$e229cb5c8b2cd629$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $e229cb5c8b2cd629$var$commitAppearingPairViewTransitions(placement);
}
function $e229cb5c8b2cd629$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $e229cb5c8b2cd629$var$appearingViewTransitions && 0 !== $e229cb5c8b2cd629$var$appearingViewTransitions.size) {
        var pairs = $e229cb5c8b2cd629$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $e229cb5c8b2cd629$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($e229cb5c8b2cd629$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $e229cb5c8b2cd629$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $e229cb5c8b2cd629$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $e229cb5c8b2cd629$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $e229cb5c8b2cd629$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $e229cb5c8b2cd629$var$appearingViewTransitions ? $e229cb5c8b2cd629$var$appearingViewTransitions.get(name) : void 0, className = $e229cb5c8b2cd629$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($e229cb5c8b2cd629$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $e229cb5c8b2cd629$var$appearingViewTransitions.delete(name), $e229cb5c8b2cd629$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $e229cb5c8b2cd629$var$scheduleViewTransitionEvent(deletion, props.onExit) : $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $e229cb5c8b2cd629$var$appearingViewTransitions && $e229cb5c8b2cd629$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$e229cb5c8b2cd629$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $e229cb5c8b2cd629$var$appearingViewTransitions && $e229cb5c8b2cd629$var$commitDeletedPairViewTransitions(deletion);
}
function $e229cb5c8b2cd629$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $e229cb5c8b2cd629$var$getViewTransitionName(props, changedParent.stateNode);
            props = $e229cb5c8b2cd629$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $e229cb5c8b2cd629$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $e229cb5c8b2cd629$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $e229cb5c8b2cd629$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $e229cb5c8b2cd629$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $e229cb5c8b2cd629$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $e229cb5c8b2cd629$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$e229cb5c8b2cd629$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $e229cb5c8b2cd629$var$restorePairedViewTransitions(fiber);
}
function $e229cb5c8b2cd629$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $e229cb5c8b2cd629$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $e229cb5c8b2cd629$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx], nextMeasurement = $e229cb5c8b2cd629$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $e229cb5c8b2cd629$var$applyViewTransitionName(instance, 0 === $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $e229cb5c8b2cd629$var$viewTransitionCancelableChildren && ($e229cb5c8b2cd629$var$viewTransitionCancelableChildren = []), $e229cb5c8b2cd629$var$viewTransitionCancelableChildren.push(instance, 0 === $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $e229cb5c8b2cd629$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $e229cb5c8b2cd629$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $e229cb5c8b2cd629$var$getViewTransitionName(props, state), className = $e229cb5c8b2cd629$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($e229cb5c8b2cd629$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx = 0;
            name = $e229cb5c8b2cd629$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $e229cb5c8b2cd629$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $e229cb5c8b2cd629$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = !1, $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = !1, $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden = !1, $e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $e229cb5c8b2cd629$var$nextEffect = null, $e229cb5c8b2cd629$var$viewTransitionContextChanged = !1, $e229cb5c8b2cd629$var$inUpdateViewTransition = !1, $e229cb5c8b2cd629$var$rootViewTransitionAffected = !1, $e229cb5c8b2cd629$var$rootViewTransitionNameCanceled = !1;
function $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $e229cb5c8b2cd629$var$eventsEnabled = $e229cb5c8b2cd629$var$_enabled;
    root = $e229cb5c8b2cd629$var$getActiveElementDeep(root);
    if ($e229cb5c8b2cd629$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $e229cb5c8b2cd629$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $e229cb5c8b2cd629$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $e229cb5c8b2cd629$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $e229cb5c8b2cd629$var$nextEffect;){
        root = $e229cb5c8b2cd629$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $e229cb5c8b2cd629$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $e229cb5c8b2cd629$var$trackEnterViewTransitions(root), $e229cb5c8b2cd629$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $e229cb5c8b2cd629$var$commitExitViewTransitions(JSCompiler_temp);
                    $e229cb5c8b2cd629$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $e229cb5c8b2cd629$var$trackEnterViewTransitions(root);
                    $e229cb5c8b2cd629$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $e229cb5c8b2cd629$var$nextEffect = JSCompiler_temp) : (committedLanes && $e229cb5c8b2cd629$var$commitNestedViewTransitions(root), $e229cb5c8b2cd629$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $e229cb5c8b2cd629$var$appearingViewTransitions = null;
}
function $e229cb5c8b2cd629$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        var fiber = $e229cb5c8b2cd629$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $e229cb5c8b2cd629$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $e229cb5c8b2cd629$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $e229cb5c8b2cd629$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $e229cb5c8b2cd629$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $e229cb5c8b2cd629$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $e229cb5c8b2cd629$var$nextEffect = current;
            break;
        }
        $e229cb5c8b2cd629$var$nextEffect = fiber.return;
    }
}
function $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $e229cb5c8b2cd629$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $e229cb5c8b2cd629$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $e229cb5c8b2cd629$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                current = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
                prevProps = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden;
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = flags;
                ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = current;
                $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $e229cb5c8b2cd629$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $e229cb5c8b2cd629$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $e229cb5c8b2cd629$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $e229cb5c8b2cd629$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $e229cb5c8b2cd629$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $e229cb5c8b2cd629$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $e229cb5c8b2cd629$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $e229cb5c8b2cd629$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $e229cb5c8b2cd629$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $e229cb5c8b2cd629$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $e229cb5c8b2cd629$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $e229cb5c8b2cd629$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $e229cb5c8b2cd629$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $e229cb5c8b2cd629$var$hostParent = null, $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
function $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount) try {
        $e229cb5c8b2cd629$var$injectedHook.onCommitFiberUnmount($e229cb5c8b2cd629$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$e229cb5c8b2cd629$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $e229cb5c8b2cd629$var$hostParent, prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$isSingletonScope(deletedFiber.type) && ($e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode, $e229cb5c8b2cd629$var$hostParentIsContainer = !1);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $e229cb5c8b2cd629$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $e229cb5c8b2cd629$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $e229cb5c8b2cd629$var$hostParent;
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = null;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $e229cb5c8b2cd629$var$hostParent) {
                if ($e229cb5c8b2cd629$var$hostParentIsContainer) try {
                    (9 === $e229cb5c8b2cd629$var$hostParent.nodeType ? $e229cb5c8b2cd629$var$hostParent.body : "HTML" === $e229cb5c8b2cd629$var$hostParent.nodeName ? $e229cb5c8b2cd629$var$hostParent.ownerDocument.body : $e229cb5c8b2cd629$var$hostParent).removeChild(deletedFiber.stateNode), $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $e229cb5c8b2cd629$var$hostParent.removeChild(deletedFiber.stateNode), $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $e229cb5c8b2cd629$var$hostParent && ($e229cb5c8b2cd629$var$hostParentIsContainer ? (finishedRoot = $e229cb5c8b2cd629$var$hostParent, $e229cb5c8b2cd629$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot)) : $e229cb5c8b2cd629$var$clearHydrationBoundary($e229cb5c8b2cd629$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $e229cb5c8b2cd629$var$hostParent;
            prevHostParentIsContainer = $e229cb5c8b2cd629$var$hostParentIsContainer;
            $e229cb5c8b2cd629$var$hostParent = deletedFiber.stateNode.containerInfo;
            $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$hostParent = prevHostParent;
            $e229cb5c8b2cd629$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $e229cb5c8b2cd629$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || ($e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = (prevHostParent = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || $e229cb5c8b2cd629$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $e229cb5c8b2cd629$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $e229cb5c8b2cd629$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $e229cb5c8b2cd629$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $e229cb5c8b2cd629$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $e229cb5c8b2cd629$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $e229cb5c8b2cd629$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($e229cb5c8b2cd629$var$isSingletonScope(parent.type)) {
                        $e229cb5c8b2cd629$var$hostParent = parent.stateNode;
                        $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $e229cb5c8b2cd629$var$hostParent = parent.stateNode.containerInfo;
                    $e229cb5c8b2cd629$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $e229cb5c8b2cd629$var$hostParent) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
        $e229cb5c8b2cd629$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $e229cb5c8b2cd629$var$hostParent = null;
        $e229cb5c8b2cd629$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $e229cb5c8b2cd629$var$currentHoistableRoot = null;
function $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($e229cb5c8b2cd629$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $e229cb5c8b2cd629$var$commitHookEffectListMount(3, finishedWork), $e229cb5c8b2cd629$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            flags & 64 && $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($e229cb5c8b2cd629$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $e229cb5c8b2cd629$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$e229cb5c8b2cd629$var$internalHoistableMarker] || current[$e229cb5c8b2cd629$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $e229cb5c8b2cd629$var$setInitialProperties(current, root, lanes);
                                            current[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                            $e229cb5c8b2cd629$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $e229cb5c8b2cd629$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $e229cb5c8b2cd629$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $e229cb5c8b2cd629$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $e229cb5c8b2cd629$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$e229cb5c8b2cd629$var$internalInstanceKey] = finishedWork;
                                    $e229cb5c8b2cd629$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden || $e229cb5c8b2cd629$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $e229cb5c8b2cd629$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden || $e229cb5c8b2cd629$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $e229cb5c8b2cd629$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden;
            $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden = !1;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden = ii;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $e229cb5c8b2cd629$var$setTextContent(root, ""), $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $e229cb5c8b2cd629$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($e229cb5c8b2cd629$var$needsFormReset = !0);
            break;
        case 6:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $e229cb5c8b2cd629$var$viewTransitionMutationContext = !1;
            $e229cb5c8b2cd629$var$tagCaches = null;
            ii = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(root.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$currentHoistableRoot = ii;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $e229cb5c8b2cd629$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $e229cb5c8b2cd629$var$needsFormReset && ($e229cb5c8b2cd629$var$needsFormReset = !1, $e229cb5c8b2cd629$var$recursivelyResetForms(finishedWork));
            $e229cb5c8b2cd629$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden;
            $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden;
            current = $e229cb5c8b2cd629$var$pushMutationContext();
            ii = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            $e229cb5c8b2cd629$var$currentHoistableRoot = ii;
            $e229cb5c8b2cd629$var$viewTransitionMutationContext && $e229cb5c8b2cd629$var$inUpdateViewTransition && ($e229cb5c8b2cd629$var$rootViewTransitionAffected = !0);
            $e229cb5c8b2cd629$var$viewTransitionMutationContext = current;
            $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($e229cb5c8b2cd629$var$globalMostRecentFallbackTime = $e229cb5c8b2cd629$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden, lanes = $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden, current = $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden, $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = ii || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden, $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = root, $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden = lanes, $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden = current), !ii && $e229cb5c8b2cd629$var$offscreenDirectParentIsHidden || $e229cb5c8b2cd629$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $e229cb5c8b2cd629$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return));
            flags = $e229cb5c8b2cd629$var$pushMutationContext();
            ii = $e229cb5c8b2cd629$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $e229cb5c8b2cd629$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $e229cb5c8b2cd629$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $e229cb5c8b2cd629$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $e229cb5c8b2cd629$var$inUpdateViewTransition = ii;
            $e229cb5c8b2cd629$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || null === current || $e229cb5c8b2cd629$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($e229cb5c8b2cd629$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($e229cb5c8b2cd629$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($e229cb5c8b2cd629$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($e229cb5c8b2cd629$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $e229cb5c8b2cd629$var$getHostSibling(finishedWork);
                    $e229cb5c8b2cd629$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $e229cb5c8b2cd629$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $e229cb5c8b2cd629$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $e229cb5c8b2cd629$var$_enabled = !0, fiber.reset(), $e229cb5c8b2cd629$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $e229cb5c8b2cd629$var$measureNestedViewTransitions(parentFiber, !1);
}
function $e229cb5c8b2cd629$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $e229cb5c8b2cd629$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $e229cb5c8b2cd629$var$rootViewTransitionNameCanceled = $e229cb5c8b2cd629$var$viewTransitionContextChanged = !1;
            $e229cb5c8b2cd629$var$pushViewTransitionCancelableScope();
            $e229cb5c8b2cd629$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$e229cb5c8b2cd629$var$viewTransitionContextChanged && !$e229cb5c8b2cd629$var$rootViewTransitionAffected) {
                finishedWork = $e229cb5c8b2cd629$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $e229cb5c8b2cd629$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $e229cb5c8b2cd629$var$rootViewTransitionNameCanceled = !0;
            }
            $e229cb5c8b2cd629$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $e229cb5c8b2cd629$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $e229cb5c8b2cd629$var$viewTransitionContextChanged;
            $e229cb5c8b2cd629$var$viewTransitionContextChanged = !1;
            $e229cb5c8b2cd629$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$viewTransitionContextChanged && ($e229cb5c8b2cd629$var$rootViewTransitionAffected = !0);
            $e229cb5c8b2cd629$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $e229cb5c8b2cd629$var$commitEnterViewTransitions(finishedWork, !1) : $e229cb5c8b2cd629$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $e229cb5c8b2cd629$var$viewTransitionContextChanged;
            oldName = $e229cb5c8b2cd629$var$pushViewTransitionCancelableScope();
            $e229cb5c8b2cd629$var$viewTransitionContextChanged = !1;
            $e229cb5c8b2cd629$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $e229cb5c8b2cd629$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $e229cb5c8b2cd629$var$getViewTransitionName(props, state);
            state = $e229cb5c8b2cd629$var$getViewTransitionName(current.memoizedProps, state);
            var className = $e229cb5c8b2cd629$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx = 0, root = $e229cb5c8b2cd629$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $e229cb5c8b2cd629$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($e229cb5c8b2cd629$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $e229cb5c8b2cd629$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $e229cb5c8b2cd629$var$viewTransitionCancelableChildren), $e229cb5c8b2cd629$var$viewTransitionCancelableChildren = oldName);
            $e229cb5c8b2cd629$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $e229cb5c8b2cd629$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $e229cb5c8b2cd629$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $e229cb5c8b2cd629$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $e229cb5c8b2cd629$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $e229cb5c8b2cd629$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $e229cb5c8b2cd629$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$e229cb5c8b2cd629$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $e229cb5c8b2cd629$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $e229cb5c8b2cd629$var$commitClassCallbacks(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $e229cb5c8b2cd629$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $e229cb5c8b2cd629$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $e229cb5c8b2cd629$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $e229cb5c8b2cd629$var$offscreenSubtreeIsHidden || $e229cb5c8b2cd629$var$mountHoistable($e229cb5c8b2cd629$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $e229cb5c8b2cd629$var$commitHostMount(finishedWork);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $e229cb5c8b2cd629$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $e229cb5c8b2cd629$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $e229cb5c8b2cd629$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $e229cb5c8b2cd629$var$releaseCache(previousCache));
}
function $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $e229cb5c8b2cd629$var$releaseCache(current));
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $e229cb5c8b2cd629$var$restoreNestedViewTransitions(parentFiber);
}
function $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $e229cb5c8b2cd629$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $e229cb5c8b2cd629$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $e229cb5c8b2cd629$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $e229cb5c8b2cd629$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $e229cb5c8b2cd629$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $e229cb5c8b2cd629$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(flags.child, !0), $e229cb5c8b2cd629$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $e229cb5c8b2cd629$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $e229cb5c8b2cd629$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $e229cb5c8b2cd629$var$suspenseyCommitFlag = 8192;
function $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $e229cb5c8b2cd629$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $e229cb5c8b2cd629$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $e229cb5c8b2cd629$var$suspendResource(suspendedState, $e229cb5c8b2cd629$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $e229cb5c8b2cd629$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $e229cb5c8b2cd629$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $e229cb5c8b2cd629$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $e229cb5c8b2cd629$var$currentHoistableRoot;
            $e229cb5c8b2cd629$var$currentHoistableRoot = $e229cb5c8b2cd629$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $e229cb5c8b2cd629$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $e229cb5c8b2cd629$var$suspenseyCommitFlag, $e229cb5c8b2cd629$var$suspenseyCommitFlag = 16777216, $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $e229cb5c8b2cd629$var$suspenseyCommitFlag = previousHoistableRoot) : $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $e229cb5c8b2cd629$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $e229cb5c8b2cd629$var$appearingViewTransitions && ($e229cb5c8b2cd629$var$appearingViewTransitions = new Map());
                $e229cb5c8b2cd629$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $e229cb5c8b2cd629$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $e229cb5c8b2cd629$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $e229cb5c8b2cd629$var$nextEffect = childToDelete;
            $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $e229cb5c8b2cd629$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $e229cb5c8b2cd629$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $e229cb5c8b2cd629$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $e229cb5c8b2cd629$var$nextEffect;){
        var fiber = $e229cb5c8b2cd629$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $e229cb5c8b2cd629$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $e229cb5c8b2cd629$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $e229cb5c8b2cd629$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $e229cb5c8b2cd629$var$nextEffect;){
            cache = $e229cb5c8b2cd629$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $e229cb5c8b2cd629$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $e229cb5c8b2cd629$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $e229cb5c8b2cd629$var$nextEffect = sibling;
                break a;
            }
            $e229cb5c8b2cd629$var$nextEffect = returnFiber;
        }
    }
}
var $e229cb5c8b2cd629$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $e229cb5c8b2cd629$var$readContext($e229cb5c8b2cd629$var$CacheContext).controller.signal;
    }
}, $e229cb5c8b2cd629$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $e229cb5c8b2cd629$var$executionContext = 0, $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgress = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1, $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !1, $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1, $e229cb5c8b2cd629$var$entangledRenderLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0, $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = 0, $e229cb5c8b2cd629$var$workInProgressDeferredLane = 0, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0, $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $e229cb5c8b2cd629$var$globalMostRecentFallbackTime = 0, $e229cb5c8b2cd629$var$globalMostRecentTransitionTime = 0, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = Infinity, $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null, $e229cb5c8b2cd629$var$pendingEffectsStatus = 0, $e229cb5c8b2cd629$var$pendingEffectsRoot = null, $e229cb5c8b2cd629$var$pendingFinishedWork = null, $e229cb5c8b2cd629$var$pendingEffectsLanes = 0, $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = 0, $e229cb5c8b2cd629$var$pendingPassiveTransitions = null, $e229cb5c8b2cd629$var$pendingRecoverableErrors = null, $e229cb5c8b2cd629$var$pendingViewTransition = null, $e229cb5c8b2cd629$var$pendingViewTransitionEvents = null, $e229cb5c8b2cd629$var$pendingTransitionTypes = null, $e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null;
function $e229cb5c8b2cd629$var$requestUpdateLane() {
    return 0 !== ($e229cb5c8b2cd629$var$executionContext & 2) && 0 !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes ? $e229cb5c8b2cd629$var$workInProgressRootRenderLanes & -$e229cb5c8b2cd629$var$workInProgressRootRenderLanes : null !== $e229cb5c8b2cd629$var$ReactSharedInternals.T ? $e229cb5c8b2cd629$var$requestTransitionLane() : $e229cb5c8b2cd629$var$resolveUpdatePriority();
}
function $e229cb5c8b2cd629$var$requestDeferredLane() {
    if (0 === $e229cb5c8b2cd629$var$workInProgressDeferredLane) {
        if (0 === ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) || $e229cb5c8b2cd629$var$isHydrating) {
            var lane = $e229cb5c8b2cd629$var$nextTransitionDeferredLane;
            $e229cb5c8b2cd629$var$nextTransitionDeferredLane <<= 1;
            0 === ($e229cb5c8b2cd629$var$nextTransitionDeferredLane & 3932160) && ($e229cb5c8b2cd629$var$nextTransitionDeferredLane = 262144);
            $e229cb5c8b2cd629$var$workInProgressDeferredLane = lane;
        } else $e229cb5c8b2cd629$var$workInProgressDeferredLane = 536870912;
    }
    lane = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $e229cb5c8b2cd629$var$workInProgressDeferredLane;
}
function $e229cb5c8b2cd629$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $e229cb5c8b2cd629$var$createViewTransitionInstance($e229cb5c8b2cd629$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $e229cb5c8b2cd629$var$pendingViewTransitionEvents && ($e229cb5c8b2cd629$var$pendingViewTransitionEvents = []);
        $e229cb5c8b2cd629$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $e229cb5c8b2cd629$var$workInProgressRoot && (2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || 9 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $e229cb5c8b2cd629$var$prepareFreshStack(root, 0), $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
    $e229cb5c8b2cd629$var$markRootUpdated$1(root, lane);
    if (0 === ($e229cb5c8b2cd629$var$executionContext & 2) || root !== $e229cb5c8b2cd629$var$workInProgressRoot) root === $e229cb5c8b2cd629$var$workInProgressRoot && (0 === ($e229cb5c8b2cd629$var$executionContext & 2) && ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && $e229cb5c8b2cd629$var$markRootSuspended(root, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1)), $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $e229cb5c8b2cd629$var$renderRootConcurrent(root$jscomp$0, lanes) : $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $e229cb5c8b2cd629$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($e229cb5c8b2cd629$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $e229cb5c8b2cd629$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors;
                            $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors ? $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors.push.apply($e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $e229cb5c8b2cd629$var$prepareFreshStack(root$jscomp$0, 0);
                $e229cb5c8b2cd629$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $e229cb5c8b2cd629$var$globalMostRecentFallbackTime + 300 - $e229cb5c8b2cd629$var$now(), 10 < exitStatus)) {
                    $e229cb5c8b2cd629$var$markRootSuspended(shouldTimeSlice, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !$e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $e229cb5c8b2cd629$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $e229cb5c8b2cd629$var$scheduleTimeout($e229cb5c8b2cd629$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $e229cb5c8b2cd629$var$completeRootWhenReady(shouldTimeSlice, forceSync, $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors, $e229cb5c8b2cd629$var$workInProgressTransitions, $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root$jscomp$0);
}
function $e229cb5c8b2cd629$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $e229cb5c8b2cd629$var$noop$1
        }, $e229cb5c8b2cd629$var$appearingViewTransitions = null, $e229cb5c8b2cd629$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $e229cb5c8b2cd629$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $e229cb5c8b2cd629$var$globalMostRecentFallbackTime - $e229cb5c8b2cd629$var$now() : (lanes & 4194048) === lanes ? $e229cb5c8b2cd629$var$globalMostRecentTransitionTime - $e229cb5c8b2cd629$var$now() : 0, subtreeFlags = $e229cb5c8b2cd629$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($e229cb5c8b2cd629$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $e229cb5c8b2cd629$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $e229cb5c8b2cd629$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $e229cb5c8b2cd629$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$e229cb5c8b2cd629$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $e229cb5c8b2cd629$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $e229cb5c8b2cd629$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $e229cb5c8b2cd629$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $e229cb5c8b2cd629$var$flushSyncWork$1() {
    return 0 === ($e229cb5c8b2cd629$var$executionContext & 6) ? ($e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $e229cb5c8b2cd629$var$resetWorkInProgressStack() {
    if (null !== $e229cb5c8b2cd629$var$workInProgress) {
        if (0 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) var interruptedWork = $e229cb5c8b2cd629$var$workInProgress.return;
        else interruptedWork = $e229cb5c8b2cd629$var$workInProgress, $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null, $e229cb5c8b2cd629$var$resetHooksOnUnwind(interruptedWork), $e229cb5c8b2cd629$var$thenableState$1 = null, $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0, interruptedWork = $e229cb5c8b2cd629$var$workInProgress;
        for(; null !== interruptedWork;)$e229cb5c8b2cd629$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $e229cb5c8b2cd629$var$workInProgress = null;
    }
}
function $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $e229cb5c8b2cd629$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $e229cb5c8b2cd629$var$pendingEffectsLanes = 0;
    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
    $e229cb5c8b2cd629$var$workInProgressRoot = root;
    $e229cb5c8b2cd629$var$workInProgress = timeoutHandle = $e229cb5c8b2cd629$var$createWorkInProgress(root.current, null);
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = lanes;
    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    $e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !1;
    $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = $e229cb5c8b2cd629$var$workInProgressDeferredLane = $e229cb5c8b2cd629$var$workInProgressRootPingedLanes = $e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes = $e229cb5c8b2cd629$var$workInProgressRootSkippedLanes = $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 0;
    $e229cb5c8b2cd629$var$workInProgressRootRecoverableErrors = $e229cb5c8b2cd629$var$workInProgressRootConcurrentErrors = null;
    $e229cb5c8b2cd629$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $e229cb5c8b2cd629$var$entangledRenderLanes = $e229cb5c8b2cd629$var$getEntangledLanes(root, lanes);
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $e229cb5c8b2cd629$var$handleThrow(root, thrownValue) {
    $e229cb5c8b2cd629$var$currentlyRenderingFiber = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    thrownValue === $e229cb5c8b2cd629$var$SuspenseException || thrownValue === $e229cb5c8b2cd629$var$SuspenseActionException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 3) : thrownValue === $e229cb5c8b2cd629$var$SuspenseyCommitException ? (thrownValue = $e229cb5c8b2cd629$var$getSuspendedThenable(), $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 4) : $e229cb5c8b2cd629$var$workInProgressSuspendedReason = thrownValue === $e229cb5c8b2cd629$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $e229cb5c8b2cd629$var$workInProgressThrownValue = thrownValue;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1, $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $e229cb5c8b2cd629$var$shouldRemainOnPreviousScreen() {
    var handler = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194048) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes ? null === $e229cb5c8b2cd629$var$shellBoundary ? !0 : !1 : ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes || 0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912) ? handler === $e229cb5c8b2cd629$var$shellBoundary : !1;
}
function $e229cb5c8b2cd629$var$pushDispatcher() {
    var prevDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.H;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = $e229cb5c8b2cd629$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $e229cb5c8b2cd629$var$ContextOnlyDispatcher : prevDispatcher;
}
function $e229cb5c8b2cd629$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $e229cb5c8b2cd629$var$ReactSharedInternals.A;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = $e229cb5c8b2cd629$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $e229cb5c8b2cd629$var$renderDidSuspendDelayIfPossible() {
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 4;
    $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings || ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 4194048) !== $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && null !== $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current || ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = !0);
    0 === ($e229cb5c8b2cd629$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($e229cb5c8b2cd629$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $e229cb5c8b2cd629$var$workInProgressRoot || $e229cb5c8b2cd629$var$markRootSuspended($e229cb5c8b2cd629$var$workInProgressRoot, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, $e229cb5c8b2cd629$var$workInProgressDeferredLane, !1);
}
function $e229cb5c8b2cd629$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    if ($e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes) $e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            var unitOfWork = $e229cb5c8b2cd629$var$workInProgress, thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason;
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $e229cb5c8b2cd629$var$workInProgressSuspendedReason, $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $e229cb5c8b2cd629$var$workLoopSync();
        exitStatus = $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $e229cb5c8b2cd629$var$workInProgress && ($e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0, $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $e229cb5c8b2cd629$var$workLoopSync() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress;)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
    $e229cb5c8b2cd629$var$executionContext |= 2;
    var prevDispatcher = $e229cb5c8b2cd629$var$pushDispatcher(), prevAsyncDispatcher = $e229cb5c8b2cd629$var$pushAsyncDispatcher();
    $e229cb5c8b2cd629$var$workInProgressRoot !== root || $e229cb5c8b2cd629$var$workInProgressRootRenderLanes !== lanes ? ($e229cb5c8b2cd629$var$workInProgressTransitions = null, $e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$prepareFreshStack(root, lanes)) : $e229cb5c8b2cd629$var$workInProgressRootIsPrerendering = $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && null !== $e229cb5c8b2cd629$var$workInProgress) {
            lanes = $e229cb5c8b2cd629$var$workInProgress;
            var thrownValue = $e229cb5c8b2cd629$var$workInProgressThrownValue;
            b: switch($e229cb5c8b2cd629$var$workInProgressSuspendedReason){
                case 1:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($e229cb5c8b2cd629$var$isThenableResolved(thrownValue)) {
                        $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                        $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                        $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason && 9 !== $e229cb5c8b2cd629$var$workInProgressSuspendedReason || $e229cb5c8b2cd629$var$workInProgressRoot !== root || ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7);
                        $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $e229cb5c8b2cd629$var$isThenableResolved(thrownValue) ? ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(lanes)) : ($e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0, $e229cb5c8b2cd629$var$workInProgressThrownValue = null, $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($e229cb5c8b2cd629$var$workInProgress.tag){
                        case 26:
                            resource = $e229cb5c8b2cd629$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $e229cb5c8b2cd629$var$workInProgress;
                            if (resource ? $e229cb5c8b2cd629$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                                $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $e229cb5c8b2cd629$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($e229cb5c8b2cd629$var$workInProgress = returnFiber, $e229cb5c8b2cd629$var$completeUnitOfWork(returnFiber)) : $e229cb5c8b2cd629$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $e229cb5c8b2cd629$var$workInProgressSuspendedReason = 0;
                    $e229cb5c8b2cd629$var$workInProgressThrownValue = null;
                    $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $e229cb5c8b2cd629$var$resetWorkInProgressStack();
                    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(462));
            }
        }
        $e229cb5c8b2cd629$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $e229cb5c8b2cd629$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$ReactSharedInternals.H = prevDispatcher;
    $e229cb5c8b2cd629$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
    if (null !== $e229cb5c8b2cd629$var$workInProgress) return 0;
    $e229cb5c8b2cd629$var$workInProgressRoot = null;
    $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0;
    $e229cb5c8b2cd629$var$finishQueueingConcurrentUpdates();
    return $e229cb5c8b2cd629$var$workInProgressRootExitStatus;
}
function $e229cb5c8b2cd629$var$workLoopConcurrentByScheduler() {
    for(; null !== $e229cb5c8b2cd629$var$workInProgress && !$e229cb5c8b2cd629$var$shouldYield();)$e229cb5c8b2cd629$var$performUnitOfWork($e229cb5c8b2cd629$var$workInProgress);
}
function $e229cb5c8b2cd629$var$performUnitOfWork(unitOfWork) {
    var next = $e229cb5c8b2cd629$var$beginWork(unitOfWork.alternate, unitOfWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $e229cb5c8b2cd629$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $e229cb5c8b2cd629$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $e229cb5c8b2cd629$var$hydrationParentFiber && ($e229cb5c8b2cd629$var$isHydrating ? ($e229cb5c8b2cd629$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($e229cb5c8b2cd629$var$nextHydratableInstance = fiber.stateNode)) : ($e229cb5c8b2cd629$var$popToNextHostParent(fiber), $e229cb5c8b2cd629$var$isHydrating = !0));
        default:
            $e229cb5c8b2cd629$var$unwindInterruptedWork(current, next), next = $e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$resetWorkInProgress(next, $e229cb5c8b2cd629$var$entangledRenderLanes), next = $e229cb5c8b2cd629$var$beginWork(current, next, $e229cb5c8b2cd629$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) : $e229cb5c8b2cd629$var$workInProgress = next;
}
function $e229cb5c8b2cd629$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $e229cb5c8b2cd629$var$lastContextDependency = $e229cb5c8b2cd629$var$currentlyRenderingFiber$1 = null;
    $e229cb5c8b2cd629$var$resetHooksOnUnwind(unitOfWork);
    $e229cb5c8b2cd629$var$thenableState$1 = null;
    $e229cb5c8b2cd629$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($e229cb5c8b2cd629$var$throwException(root, returnFiber, unitOfWork, thrownValue, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes)) {
            $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
            $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
            $e229cb5c8b2cd629$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $e229cb5c8b2cd629$var$workInProgress = returnFiber, error;
        $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 1;
        $e229cb5c8b2cd629$var$logUncaughtError(root, $e229cb5c8b2cd629$var$createCapturedValueAtFiber(thrownValue, root.current));
        $e229cb5c8b2cd629$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($e229cb5c8b2cd629$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($e229cb5c8b2cd629$var$workInProgressRootIsPrerendering || 0 !== ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $e229cb5c8b2cd629$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, root);
    } else $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork);
}
function $e229cb5c8b2cd629$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $e229cb5c8b2cd629$var$unwindUnitOfWork(completedWork, $e229cb5c8b2cd629$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $e229cb5c8b2cd629$var$completeWork(completedWork.alternate, completedWork, $e229cb5c8b2cd629$var$entangledRenderLanes);
        if (null !== next) {
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $e229cb5c8b2cd629$var$workInProgress = completedWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootExitStatus = 5);
}
function $e229cb5c8b2cd629$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $e229cb5c8b2cd629$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $e229cb5c8b2cd629$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $e229cb5c8b2cd629$var$workInProgress = unitOfWork;
            return;
        }
        $e229cb5c8b2cd629$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $e229cb5c8b2cd629$var$workInProgressRootExitStatus = 6;
    $e229cb5c8b2cd629$var$workInProgress = null;
}
function $e229cb5c8b2cd629$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $e229cb5c8b2cd629$var$flushPendingEffects();
    while (0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus);
    if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(177));
        root === $e229cb5c8b2cd629$var$workInProgressRoot && ($e229cb5c8b2cd629$var$workInProgress = $e229cb5c8b2cd629$var$workInProgressRoot = null, $e229cb5c8b2cd629$var$workInProgressRootRenderLanes = 0);
        $e229cb5c8b2cd629$var$pendingFinishedWork = finishedWork;
        $e229cb5c8b2cd629$var$pendingEffectsRoot = root;
        $e229cb5c8b2cd629$var$pendingEffectsLanes = lanes;
        $e229cb5c8b2cd629$var$pendingPassiveTransitions = transitions;
        $e229cb5c8b2cd629$var$pendingRecoverableErrors = recoverableErrors;
        $e229cb5c8b2cd629$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $e229cb5c8b2cd629$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $e229cb5c8b2cd629$var$concurrentlyUpdatedLanes;
    $e229cb5c8b2cd629$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $e229cb5c8b2cd629$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($e229cb5c8b2cd629$var$pendingTransitionTypes = $e229cb5c8b2cd629$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($e229cb5c8b2cd629$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $e229cb5c8b2cd629$var$scheduleCallback$1($e229cb5c8b2cd629$var$NormalPriority$1, function() {
        $e229cb5c8b2cd629$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $e229cb5c8b2cd629$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
        updatedLanes = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $e229cb5c8b2cd629$var$executionContext;
        $e229cb5c8b2cd629$var$executionContext |= 4;
        try {
            $e229cb5c8b2cd629$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $e229cb5c8b2cd629$var$executionContext = suspendedRetryLanes, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = updatedLanes, $e229cb5c8b2cd629$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $e229cb5c8b2cd629$var$pendingEffectsStatus = 1;
    $e229cb5c8b2cd629$var$shouldStartViewTransition ? $e229cb5c8b2cd629$var$pendingViewTransition = $e229cb5c8b2cd629$var$startViewTransition(suspendedState, root.containerInfo, $e229cb5c8b2cd629$var$pendingTransitionTypes, $e229cb5c8b2cd629$var$flushMutationEffects, $e229cb5c8b2cd629$var$flushLayoutEffects, $e229cb5c8b2cd629$var$flushAfterMutationEffects, $e229cb5c8b2cd629$var$flushSpawnedWork, $e229cb5c8b2cd629$var$flushPassiveEffects, $e229cb5c8b2cd629$var$reportViewTransitionError, null, null) : ($e229cb5c8b2cd629$var$flushMutationEffects(), $e229cb5c8b2cd629$var$flushLayoutEffects(), $e229cb5c8b2cd629$var$flushSpawnedWork());
}
function $e229cb5c8b2cd629$var$reportViewTransitionError(error) {
    if (0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        var onRecoverableError = $e229cb5c8b2cd629$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $e229cb5c8b2cd629$var$flushAfterMutationEffects() {
    3 === $e229cb5c8b2cd629$var$pendingEffectsStatus && ($e229cb5c8b2cd629$var$pendingEffectsStatus = 0, $e229cb5c8b2cd629$var$commitAfterMutationEffectsOnFiber($e229cb5c8b2cd629$var$pendingFinishedWork, $e229cb5c8b2cd629$var$pendingEffectsRoot), $e229cb5c8b2cd629$var$pendingEffectsStatus = 4);
}
function $e229cb5c8b2cd629$var$flushMutationEffects() {
    if (1 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, lanes = $e229cb5c8b2cd629$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$inUpdateViewTransition = $e229cb5c8b2cd629$var$rootViewTransitionAffected = !1;
                $e229cb5c8b2cd629$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $e229cb5c8b2cd629$var$selectionInformation;
                var curFocusedElem = $e229cb5c8b2cd629$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $e229cb5c8b2cd629$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $e229cb5c8b2cd629$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $e229cb5c8b2cd629$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $e229cb5c8b2cd629$var$_enabled = !!$e229cb5c8b2cd629$var$eventsEnabled;
                $e229cb5c8b2cd629$var$selectionInformation = $e229cb5c8b2cd629$var$eventsEnabled = null;
            } finally{
                $e229cb5c8b2cd629$var$executionContext = prevExecutionContext, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 2;
    }
}
function $e229cb5c8b2cd629$var$flushLayoutEffects() {
    if (2 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
            $e229cb5c8b2cd629$var$executionContext |= 4;
            try {
                $e229cb5c8b2cd629$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $e229cb5c8b2cd629$var$executionContext = prevExecutionContext, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 3;
    }
}
function $e229cb5c8b2cd629$var$flushSpawnedWork() {
    if (4 === $e229cb5c8b2cd629$var$pendingEffectsStatus || 3 === $e229cb5c8b2cd629$var$pendingEffectsStatus) {
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        var committedViewTransition = $e229cb5c8b2cd629$var$pendingViewTransition;
        $e229cb5c8b2cd629$var$pendingViewTransition = null;
        $e229cb5c8b2cd629$var$requestPaint();
        var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, finishedWork = $e229cb5c8b2cd629$var$pendingFinishedWork, lanes = $e229cb5c8b2cd629$var$pendingEffectsLanes, recoverableErrors = $e229cb5c8b2cd629$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $e229cb5c8b2cd629$var$pendingEffectsStatus = 5 : ($e229cb5c8b2cd629$var$pendingEffectsStatus = 0, $e229cb5c8b2cd629$var$pendingFinishedWork = $e229cb5c8b2cd629$var$pendingEffectsRoot = null, $e229cb5c8b2cd629$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $e229cb5c8b2cd629$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot) try {
            $e229cb5c8b2cd629$var$injectedHook.onCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
            passiveSubtreeMask = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
            $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2;
            $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $e229cb5c8b2cd629$var$ReactSharedInternals.T = finishedWork, $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $e229cb5c8b2cd629$var$pendingViewTransitionEvents;
        onRecoverableError = $e229cb5c8b2cd629$var$pendingTransitionTypes;
        $e229cb5c8b2cd629$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($e229cb5c8b2cd629$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($e229cb5c8b2cd629$var$pendingEffectsLanes & 3) && $e229cb5c8b2cd629$var$flushPendingEffects();
        $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $e229cb5c8b2cd629$var$rootWithNestedUpdates ? $e229cb5c8b2cd629$var$nestedUpdateCount++ : ($e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = root) : ($e229cb5c8b2cd629$var$nestedUpdateCount = 0, $e229cb5c8b2cd629$var$rootWithNestedUpdates = null);
        $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $e229cb5c8b2cd629$var$releaseCache(remainingLanes)));
}
function $e229cb5c8b2cd629$var$flushPendingEffects() {
    null !== $e229cb5c8b2cd629$var$pendingViewTransition && ($e229cb5c8b2cd629$var$pendingViewTransition.skipTransition(), $e229cb5c8b2cd629$var$pendingViewTransition = null);
    $e229cb5c8b2cd629$var$flushMutationEffects();
    $e229cb5c8b2cd629$var$flushLayoutEffects();
    $e229cb5c8b2cd629$var$flushSpawnedWork();
    return $e229cb5c8b2cd629$var$flushPassiveEffects();
}
function $e229cb5c8b2cd629$var$flushPassiveEffects() {
    if (5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus) return !1;
    var root = $e229cb5c8b2cd629$var$pendingEffectsRoot, remainingLanes = $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes;
    $e229cb5c8b2cd629$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $e229cb5c8b2cd629$var$lanesToEventPriority($e229cb5c8b2cd629$var$pendingEffectsLanes), prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T, previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
        renderPriority = $e229cb5c8b2cd629$var$pendingPassiveTransitions;
        $e229cb5c8b2cd629$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $e229cb5c8b2cd629$var$pendingEffectsRoot, lanes = $e229cb5c8b2cd629$var$pendingEffectsLanes;
        $e229cb5c8b2cd629$var$pendingEffectsStatus = 0;
        $e229cb5c8b2cd629$var$pendingFinishedWork = $e229cb5c8b2cd629$var$pendingEffectsRoot = null;
        $e229cb5c8b2cd629$var$pendingEffectsLanes = 0;
        if (0 !== ($e229cb5c8b2cd629$var$executionContext & 6)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(331));
        var prevExecutionContext = $e229cb5c8b2cd629$var$executionContext;
        $e229cb5c8b2cd629$var$executionContext |= 4;
        $e229cb5c8b2cd629$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $e229cb5c8b2cd629$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $e229cb5c8b2cd629$var$executionContext = prevExecutionContext;
        $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($e229cb5c8b2cd629$var$injectedHook && "function" === typeof $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot) try {
            $e229cb5c8b2cd629$var$injectedHook.onPostCommitFiberRoot($e229cb5c8b2cd629$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition, $e229cb5c8b2cd629$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $e229cb5c8b2cd629$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(rootFiber, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(rootFiber));
}
function $e229cb5c8b2cd629$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $e229cb5c8b2cd629$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed || !$e229cb5c8b2cd629$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $e229cb5c8b2cd629$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $e229cb5c8b2cd629$var$createClassErrorUpdate(2);
                instance = $e229cb5c8b2cd629$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($e229cb5c8b2cd629$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $e229cb5c8b2cd629$var$markRootUpdated$1(instance, 2), $e229cb5c8b2cd629$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $e229cb5c8b2cd629$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $e229cb5c8b2cd629$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($e229cb5c8b2cd629$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $e229cb5c8b2cd629$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $e229cb5c8b2cd629$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $e229cb5c8b2cd629$var$workInProgressRoot === root && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus || 3 === $e229cb5c8b2cd629$var$workInProgressRootExitStatus && ($e229cb5c8b2cd629$var$workInProgressRootRenderLanes & 62914560) === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && 300 > $e229cb5c8b2cd629$var$now() - $e229cb5c8b2cd629$var$globalMostRecentFallbackTime ? 0 === ($e229cb5c8b2cd629$var$executionContext & 2) ? $e229cb5c8b2cd629$var$prepareFreshStack(root, 0) : $e229cb5c8b2cd629$var$workInProgressRootPingedLanes |= pingedLanes : $e229cb5c8b2cd629$var$workInProgressRootPingedLanes |= pingedLanes, $e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes === $e229cb5c8b2cd629$var$workInProgressRootRenderLanes && ($e229cb5c8b2cd629$var$workInProgressSuspendedRetryLanes = 0));
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(root);
}
function $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $e229cb5c8b2cd629$var$claimNextRetryLane());
    boundaryFiber = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($e229cb5c8b2cd629$var$markRootUpdated$1(boundaryFiber, retryLane), $e229cb5c8b2cd629$var$ensureRootIsScheduled(boundaryFiber));
}
function $e229cb5c8b2cd629$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $e229cb5c8b2cd629$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $e229cb5c8b2cd629$var$scheduleCallback$1(priorityLevel, callback) {
    return $e229cb5c8b2cd629$var$scheduleCallback$3(priorityLevel, callback);
}
var $e229cb5c8b2cd629$var$firstScheduledRoot = null, $e229cb5c8b2cd629$var$lastScheduledRoot = null, $e229cb5c8b2cd629$var$didScheduleMicrotask = !1, $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !1, $e229cb5c8b2cd629$var$isFlushingWork = !1, $e229cb5c8b2cd629$var$currentEventTransitionLane = 0;
function $e229cb5c8b2cd629$var$ensureRootIsScheduled(root) {
    root !== $e229cb5c8b2cd629$var$lastScheduledRoot && null === root.next && (null === $e229cb5c8b2cd629$var$lastScheduledRoot ? $e229cb5c8b2cd629$var$firstScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot = root : $e229cb5c8b2cd629$var$lastScheduledRoot = $e229cb5c8b2cd629$var$lastScheduledRoot.next = root);
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
    $e229cb5c8b2cd629$var$didScheduleMicrotask || ($e229cb5c8b2cd629$var$didScheduleMicrotask = !0, $e229cb5c8b2cd629$var$scheduleImmediateRootScheduleTask());
}
function $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$e229cb5c8b2cd629$var$isFlushingWork && $e229cb5c8b2cd629$var$mightHavePendingSyncWork) {
        $e229cb5c8b2cd629$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $e229cb5c8b2cd629$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $e229cb5c8b2cd629$var$getNextLanes(root$190, root$190 === $e229cb5c8b2cd629$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $e229cb5c8b2cd629$var$isFlushingWork = !1;
    }
}
function $e229cb5c8b2cd629$var$processRootScheduleInImmediateTask() {
    $e229cb5c8b2cd629$var$processRootScheduleInMicrotask();
}
function $e229cb5c8b2cd629$var$processRootScheduleInMicrotask() {
    $e229cb5c8b2cd629$var$mightHavePendingSyncWork = $e229cb5c8b2cd629$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane && $e229cb5c8b2cd629$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $e229cb5c8b2cd629$var$currentEventTransitionLane);
    for(var currentTime = $e229cb5c8b2cd629$var$now(), prev = null, root = $e229cb5c8b2cd629$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $e229cb5c8b2cd629$var$firstScheduledRoot = next : prev.next = next, null === next && ($e229cb5c8b2cd629$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $e229cb5c8b2cd629$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus && 5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus || $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane && ($e229cb5c8b2cd629$var$currentEventTransitionLane = 0);
}
function $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $e229cb5c8b2cd629$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $e229cb5c8b2cd629$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $e229cb5c8b2cd629$var$workInProgressRoot;
    suspendedLanes = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    suspendedLanes = $e229cb5c8b2cd629$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason || 9 === $e229cb5c8b2cd629$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $e229cb5c8b2cd629$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
        switch($e229cb5c8b2cd629$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $e229cb5c8b2cd629$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $e229cb5c8b2cd629$var$IdlePriority;
                break;
            default:
                suspendedLanes = $e229cb5c8b2cd629$var$NormalPriority$1;
        }
        pingedLanes = $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $e229cb5c8b2cd629$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $e229cb5c8b2cd629$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $e229cb5c8b2cd629$var$pendingEffectsStatus && 5 !== $e229cb5c8b2cd629$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($e229cb5c8b2cd629$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $e229cb5c8b2cd629$var$getNextLanes(root, root === $e229cb5c8b2cd629$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $e229cb5c8b2cd629$var$scheduleTaskForRootDuringMicrotask(root, $e229cb5c8b2cd629$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $e229cb5c8b2cd629$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $e229cb5c8b2cd629$var$performSyncWorkOnRoot(root, lanes) {
    if ($e229cb5c8b2cd629$var$flushPendingEffects()) return null;
    $e229cb5c8b2cd629$var$performWorkOnRoot(root, lanes, !0);
}
function $e229cb5c8b2cd629$var$scheduleImmediateRootScheduleTask() {
    $e229cb5c8b2cd629$var$scheduleMicrotask(function() {
        0 !== ($e229cb5c8b2cd629$var$executionContext & 6) ? $e229cb5c8b2cd629$var$scheduleCallback$3($e229cb5c8b2cd629$var$ImmediatePriority, $e229cb5c8b2cd629$var$processRootScheduleInImmediateTask) : $e229cb5c8b2cd629$var$processRootScheduleInMicrotask();
    });
}
function $e229cb5c8b2cd629$var$requestTransitionLane() {
    if (0 === $e229cb5c8b2cd629$var$currentEventTransitionLane) {
        var actionScopeLane = $e229cb5c8b2cd629$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $e229cb5c8b2cd629$var$nextTransitionUpdateLane, $e229cb5c8b2cd629$var$nextTransitionUpdateLane <<= 1, 0 === ($e229cb5c8b2cd629$var$nextTransitionUpdateLane & 261888) && ($e229cb5c8b2cd629$var$nextTransitionUpdateLane = 256));
        $e229cb5c8b2cd629$var$currentEventTransitionLane = actionScopeLane;
    }
    return $e229cb5c8b2cd629$var$currentEventTransitionLane;
}
function $e229cb5c8b2cd629$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $e229cb5c8b2cd629$var$sanitizeURL(actionProp);
}
function $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $e229cb5c8b2cd629$var$coerceFormActionProp((nativeEventTarget[$e229cb5c8b2cd629$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$e229cb5c8b2cd629$var$internalPropsKey] || null) ? $e229cb5c8b2cd629$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $e229cb5c8b2cd629$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $e229cb5c8b2cd629$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $e229cb5c8b2cd629$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $e229cb5c8b2cd629$var$i$jscomp$inline_1667 = 0; $e229cb5c8b2cd629$var$i$jscomp$inline_1667 < $e229cb5c8b2cd629$var$simpleEventPluginEvents.length; $e229cb5c8b2cd629$var$i$jscomp$inline_1667++){
    var $e229cb5c8b2cd629$var$eventName$jscomp$inline_1668 = $e229cb5c8b2cd629$var$simpleEventPluginEvents[$e229cb5c8b2cd629$var$i$jscomp$inline_1667], $e229cb5c8b2cd629$var$domEventName$jscomp$inline_1669 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1668.toLowerCase(), $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1670 = $e229cb5c8b2cd629$var$eventName$jscomp$inline_1668[0].toUpperCase() + $e229cb5c8b2cd629$var$eventName$jscomp$inline_1668.slice(1);
    $e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$domEventName$jscomp$inline_1669, "on" + $e229cb5c8b2cd629$var$capitalizedEvent$jscomp$inline_1670);
}
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_END, "onAnimationEnd");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_ITERATION, "onAnimationIteration");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$ANIMATION_START, "onAnimationStart");
$e229cb5c8b2cd629$var$registerSimpleEvent("dblclick", "onDoubleClick");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusin", "onFocus");
$e229cb5c8b2cd629$var$registerSimpleEvent("focusout", "onBlur");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_RUN, "onTransitionRun");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_START, "onTransitionStart");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_CANCEL, "onTransitionCancel");
$e229cb5c8b2cd629$var$registerSimpleEvent($e229cb5c8b2cd629$var$TRANSITION_END, "onTransitionEnd");
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e229cb5c8b2cd629$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e229cb5c8b2cd629$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e229cb5c8b2cd629$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($e229cb5c8b2cd629$var$mediaEventTypes));
function $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $e229cb5c8b2cd629$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $e229cb5c8b2cd629$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$e229cb5c8b2cd629$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($e229cb5c8b2cd629$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $e229cb5c8b2cd629$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $e229cb5c8b2cd629$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $e229cb5c8b2cd629$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker]) {
        rootContainerElement[$e229cb5c8b2cd629$var$listeningMarker] = !0;
        $e229cb5c8b2cd629$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($e229cb5c8b2cd629$var$nonDelegatedEvents.has(domEventName) || $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $e229cb5c8b2cd629$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] || (ownerDocument[$e229cb5c8b2cd629$var$listeningMarker] = !0, $e229cb5c8b2cd629$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $e229cb5c8b2cd629$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($e229cb5c8b2cd629$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $e229cb5c8b2cd629$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $e229cb5c8b2cd629$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$e229cb5c8b2cd629$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $e229cb5c8b2cd629$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $e229cb5c8b2cd629$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $e229cb5c8b2cd629$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTouchEvent;
                        break;
                    case $e229cb5c8b2cd629$var$ANIMATION_END:
                    case $e229cb5c8b2cd629$var$ANIMATION_ITERATION:
                    case $e229cb5c8b2cd629$var$ANIMATION_START:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticAnimationEvent;
                        break;
                    case $e229cb5c8b2cd629$var$TRANSITION_END:
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $e229cb5c8b2cd629$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $e229cb5c8b2cd629$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($e229cb5c8b2cd629$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $e229cb5c8b2cd629$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($e229cb5c8b2cd629$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$e229cb5c8b2cd629$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $e229cb5c8b2cd629$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $e229cb5c8b2cd629$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $e229cb5c8b2cd629$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $e229cb5c8b2cd629$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $e229cb5c8b2cd629$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $e229cb5c8b2cd629$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $e229cb5c8b2cd629$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $e229cb5c8b2cd629$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $e229cb5c8b2cd629$var$getParent) : null;
                        null !== reactName && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent;
                else if ($e229cb5c8b2cd629$var$isTextInputElement(reactName)) {
                    if ($e229cb5c8b2cd629$var$isInputEventSupported) getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $e229cb5c8b2cd629$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $e229cb5c8b2cd629$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForChangeEvent) : getTargetInstFunc = $e229cb5c8b2cd629$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $e229cb5c8b2cd629$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $e229cb5c8b2cd629$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($e229cb5c8b2cd629$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $e229cb5c8b2cd629$var$activeElement = handleEventFunc, $e229cb5c8b2cd629$var$activeElementInst = targetInst, $e229cb5c8b2cd629$var$lastSelection = null;
                    break;
                case "focusout":
                    $e229cb5c8b2cd629$var$lastSelection = $e229cb5c8b2cd629$var$activeElementInst = $e229cb5c8b2cd629$var$activeElement = null;
                    break;
                case "mousedown":
                    $e229cb5c8b2cd629$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e229cb5c8b2cd629$var$mouseDown = !1;
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($e229cb5c8b2cd629$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $e229cb5c8b2cd629$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($e229cb5c8b2cd629$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $e229cb5c8b2cd629$var$isComposing ? $e229cb5c8b2cd629$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($e229cb5c8b2cd629$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($e229cb5c8b2cd629$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $e229cb5c8b2cd629$var$isComposing && (fallbackData = $e229cb5c8b2cd629$var$getData()) : ($e229cb5c8b2cd629$var$root = nativeEventTarget, $e229cb5c8b2cd629$var$startText = "value" in $e229cb5c8b2cd629$var$root ? $e229cb5c8b2cd629$var$root.value : $e229cb5c8b2cd629$var$root.textContent, $e229cb5c8b2cd629$var$isComposing = !0)), handleEventFunc = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $e229cb5c8b2cd629$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $e229cb5c8b2cd629$var$canUseTextInputEvent ? $e229cb5c8b2cd629$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $e229cb5c8b2cd629$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $e229cb5c8b2cd629$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $e229cb5c8b2cd629$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $e229cb5c8b2cd629$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $e229cb5c8b2cd629$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $e229cb5c8b2cd629$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $e229cb5c8b2cd629$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $e229cb5c8b2cd629$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $e229cb5c8b2cd629$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.unshift($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $e229cb5c8b2cd629$var$getListener(target, registrationName), null != stateNode && listeners.push($e229cb5c8b2cd629$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($e229cb5c8b2cd629$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($e229cb5c8b2cd629$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $e229cb5c8b2cd629$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(clientText);
    return $e229cb5c8b2cd629$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $e229cb5c8b2cd629$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $e229cb5c8b2cd629$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $e229cb5c8b2cd629$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $e229cb5c8b2cd629$var$setProp(domElement, tag, "name", props.name, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($e229cb5c8b2cd629$var$setProp(domElement, tag, "encType", props.encType, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "method", props.method, props, null), $e229cb5c8b2cd629$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $e229cb5c8b2cd629$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            return;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $e229cb5c8b2cd629$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $e229cb5c8b2cd629$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $e229cb5c8b2cd629$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $e229cb5c8b2cd629$var$aliases.get(key) || key, $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
}
function $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $e229cb5c8b2cd629$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $e229cb5c8b2cd629$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $e229cb5c8b2cd629$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $e229cb5c8b2cd629$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$e229cb5c8b2cd629$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$e229cb5c8b2cd629$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $e229cb5c8b2cd629$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $e229cb5c8b2cd629$var$viewTransitionMutationContext = !0;
}
function $e229cb5c8b2cd629$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $e229cb5c8b2cd629$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $e229cb5c8b2cd629$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $e229cb5c8b2cd629$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $e229cb5c8b2cd629$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("cancel", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $e229cb5c8b2cd629$var$mediaEventTypes.length; hasSrc++)$e229cb5c8b2cd629$var$listenToNonDelegatedEvent($e229cb5c8b2cd629$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement);
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("error", domElement), $e229cb5c8b2cd629$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $e229cb5c8b2cd629$var$emptyProps = {};
function $e229cb5c8b2cd629$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $e229cb5c8b2cd629$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $e229cb5c8b2cd629$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $e229cb5c8b2cd629$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, tag, !0) : $e229cb5c8b2cd629$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $e229cb5c8b2cd629$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $e229cb5c8b2cd629$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($e229cb5c8b2cd629$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $e229cb5c8b2cd629$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($e229cb5c8b2cd629$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $e229cb5c8b2cd629$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $e229cb5c8b2cd629$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $e229cb5c8b2cd629$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $e229cb5c8b2cd629$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $e229cb5c8b2cd629$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $e229cb5c8b2cd629$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $e229cb5c8b2cd629$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $e229cb5c8b2cd629$var$eventsEnabled = null, $e229cb5c8b2cd629$var$selectionInformation = null;
function $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $e229cb5c8b2cd629$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $e229cb5c8b2cd629$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $e229cb5c8b2cd629$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$e229cb5c8b2cd629$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$e229cb5c8b2cd629$var$internalPropsKey] = props;
    $e229cb5c8b2cd629$var$setInitialProperties(rootContainerInstance, type, props);
    $e229cb5c8b2cd629$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $e229cb5c8b2cd629$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
function $e229cb5c8b2cd629$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $e229cb5c8b2cd629$var$currentPopstateTransitionEvent) return !1;
        $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $e229cb5c8b2cd629$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $e229cb5c8b2cd629$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $e229cb5c8b2cd629$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $e229cb5c8b2cd629$var$localPromise = "function" === typeof Promise ? Promise : void 0, $e229cb5c8b2cd629$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $e229cb5c8b2cd629$var$scheduleTimeout, $e229cb5c8b2cd629$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e229cb5c8b2cd629$var$localPromise ? function(callback) {
    return $e229cb5c8b2cd629$var$localPromise.resolve(null).then(callback).catch($e229cb5c8b2cd629$var$handleErrorInNextTick);
} : $e229cb5c8b2cd629$var$scheduleTimeout;
function $e229cb5c8b2cd629$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $e229cb5c8b2cd629$var$isSingletonScope(type) {
    return "head" === type;
}
function $e229cb5c8b2cd629$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $e229cb5c8b2cd629$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $e229cb5c8b2cd629$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $e229cb5c8b2cd629$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$e229cb5c8b2cd629$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $e229cb5c8b2cd629$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $e229cb5c8b2cd629$var$retryIfBlockedOn(hydrationInstance);
}
function $e229cb5c8b2cd629$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $e229cb5c8b2cd629$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $e229cb5c8b2cd629$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $e229cb5c8b2cd629$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $e229cb5c8b2cd629$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $e229cb5c8b2cd629$var$createMeasurement(rect, computedStyle, instance);
}
function $e229cb5c8b2cd629$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $e229cb5c8b2cd629$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $e229cb5c8b2cd629$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $e229cb5c8b2cd629$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $e229cb5c8b2cd629$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($e229cb5c8b2cd629$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $e229cb5c8b2cd629$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $e229cb5c8b2cd629$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($e229cb5c8b2cd629$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $e229cb5c8b2cd629$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$e229cb5c8b2cd629$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $e229cb5c8b2cd629$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$e229cb5c8b2cd629$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$e229cb5c8b2cd629$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $e229cb5c8b2cd629$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $e229cb5c8b2cd629$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $e229cb5c8b2cd629$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $e229cb5c8b2cd629$var$ViewTransitionPseudoElement("old", name),
        new: new $e229cb5c8b2cd629$var$ViewTransitionPseudoElement("new", name)
    };
}
function $e229cb5c8b2cd629$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $e229cb5c8b2cd629$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $e229cb5c8b2cd629$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $e229cb5c8b2cd629$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $e229cb5c8b2cd629$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $e229cb5c8b2cd629$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $e229cb5c8b2cd629$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $e229cb5c8b2cd629$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $e229cb5c8b2cd629$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $e229cb5c8b2cd629$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $e229cb5c8b2cd629$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $e229cb5c8b2cd629$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $e229cb5c8b2cd629$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $e229cb5c8b2cd629$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$e229cb5c8b2cd629$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $e229cb5c8b2cd629$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $e229cb5c8b2cd629$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(fiber);
    return $e229cb5c8b2cd629$var$setFocusIfFocusable(fiber, focusOptions);
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $e229cb5c8b2cd629$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$e229cb5c8b2cd629$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $e229cb5c8b2cd629$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $e229cb5c8b2cd629$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$observeChild, observer, void 0, void 0);
};
function $e229cb5c8b2cd629$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $e229cb5c8b2cd629$var$pendingIntersectionUnobserves.length; i++){
            var pending = $e229cb5c8b2cd629$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $e229cb5c8b2cd629$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $e229cb5c8b2cd629$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $e229cb5c8b2cd629$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $e229cb5c8b2cd629$var$pendingIntersectionUnobserves = [], $e229cb5c8b2cd629$var$intersectionUnobserveScheduled = !1;
function $e229cb5c8b2cd629$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $e229cb5c8b2cd629$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $e229cb5c8b2cd629$var$intersectionUnobserveScheduled || ($e229cb5c8b2cd629$var$intersectionUnobserveScheduled = !0, $e229cb5c8b2cd629$var$requestPostPaintCallback(function() {
        $e229cb5c8b2cd629$var$intersectionUnobserveScheduled = !1;
        var pending = $e229cb5c8b2cd629$var$pendingIntersectionUnobserves;
        $e229cb5c8b2cd629$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $e229cb5c8b2cd629$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $e229cb5c8b2cd629$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$e229cb5c8b2cd629$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($e229cb5c8b2cd629$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $e229cb5c8b2cd629$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(children[0]);
    result = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $e229cb5c8b2cd629$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $e229cb5c8b2cd629$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $e229cb5c8b2cd629$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $e229cb5c8b2cd629$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $e229cb5c8b2cd629$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $e229cb5c8b2cd629$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $e229cb5c8b2cd629$var$searchTarget, $e229cb5c8b2cd629$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $e229cb5c8b2cd629$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $e229cb5c8b2cd629$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $e229cb5c8b2cd629$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $e229cb5c8b2cd629$var$searchTarget, $e229cb5c8b2cd629$var$searchBoundary = $e229cb5c8b2cd629$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $e229cb5c8b2cd629$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$e229cb5c8b2cd629$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(566));
    var children = [];
    $e229cb5c8b2cd629$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $e229cb5c8b2cd629$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $e229cb5c8b2cd629$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $e229cb5c8b2cd629$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(hostSiblings);
            $e229cb5c8b2cd629$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child), $e229cb5c8b2cd629$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $e229cb5c8b2cd629$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $e229cb5c8b2cd629$var$getInstanceFromHostFiber(child);
    $e229cb5c8b2cd629$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $e229cb5c8b2cd629$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $e229cb5c8b2cd629$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $e229cb5c8b2cd629$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $e229cb5c8b2cd629$var$pendingIntersectionUnobserves.length; i++){
            var pending = $e229cb5c8b2cd629$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $e229cb5c8b2cd629$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $e229cb5c8b2cd629$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $e229cb5c8b2cd629$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $e229cb5c8b2cd629$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $e229cb5c8b2cd629$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $e229cb5c8b2cd629$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $e229cb5c8b2cd629$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $e229cb5c8b2cd629$var$clearContainerSparingly(node);
                $e229cb5c8b2cd629$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $e229cb5c8b2cd629$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$e229cb5c8b2cd629$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $e229cb5c8b2cd629$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e229cb5c8b2cd629$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $e229cb5c8b2cd629$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $e229cb5c8b2cd629$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $e229cb5c8b2cd629$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $e229cb5c8b2cd629$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $e229cb5c8b2cd629$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $e229cb5c8b2cd629$var$previousHydratableOnEnteringScopedSingleton = null;
function $e229cb5c8b2cd629$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $e229cb5c8b2cd629$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $e229cb5c8b2cd629$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $e229cb5c8b2cd629$var$requestPostPaintCallback(callback) {
    $e229cb5c8b2cd629$var$localRequestAnimationFrame(function() {
        $e229cb5c8b2cd629$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $e229cb5c8b2cd629$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $e229cb5c8b2cd629$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(451));
    }
}
function $e229cb5c8b2cd629$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $e229cb5c8b2cd629$var$setProp(instance, type, propKey, null, $e229cb5c8b2cd629$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $e229cb5c8b2cd629$var$noop$1 && (instance.onclick = null);
    $e229cb5c8b2cd629$var$detachDeletedInstance(instance);
}
function $e229cb5c8b2cd629$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $e229cb5c8b2cd629$var$detachDeletedInstance(instance);
}
var $e229cb5c8b2cd629$var$preloadPropsMap = new Map(), $e229cb5c8b2cd629$var$preconnectsSet = new Set();
function $e229cb5c8b2cd629$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $e229cb5c8b2cd629$var$previousDispatcher = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.d;
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.d = {
    f: $e229cb5c8b2cd629$var$flushSyncWork,
    r: $e229cb5c8b2cd629$var$requestFormReset,
    D: $e229cb5c8b2cd629$var$prefetchDNS,
    C: $e229cb5c8b2cd629$var$preconnect,
    L: $e229cb5c8b2cd629$var$preload,
    m: $e229cb5c8b2cd629$var$preloadModule,
    X: $e229cb5c8b2cd629$var$preinitScript,
    S: $e229cb5c8b2cd629$var$preinitStyle,
    M: $e229cb5c8b2cd629$var$preinitModuleScript
};
function $e229cb5c8b2cd629$var$flushSyncWork() {
    var previousWasRendering = $e229cb5c8b2cd629$var$previousDispatcher.f(), wasRendering = $e229cb5c8b2cd629$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $e229cb5c8b2cd629$var$requestFormReset(form) {
    var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $e229cb5c8b2cd629$var$requestFormReset$1(formInst) : $e229cb5c8b2cd629$var$previousDispatcher.r(form);
}
var $e229cb5c8b2cd629$var$globalDocument = "undefined" === typeof document ? null : document;
function $e229cb5c8b2cd629$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $e229cb5c8b2cd629$var$preconnectsSet.has(limitedEscapedHref) || ($e229cb5c8b2cd629$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $e229cb5c8b2cd629$var$setInitialProperties(href, "link", rel), $e229cb5c8b2cd629$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $e229cb5c8b2cd629$var$prefetchDNS(href) {
    $e229cb5c8b2cd629$var$previousDispatcher.D(href);
    $e229cb5c8b2cd629$var$preconnectAs("dns-prefetch", href, null);
}
function $e229cb5c8b2cd629$var$preconnect(href, crossOrigin) {
    $e229cb5c8b2cd629$var$previousDispatcher.C(href, crossOrigin);
    $e229cb5c8b2cd629$var$preconnectAs("preconnect", href, crossOrigin);
}
function $e229cb5c8b2cd629$var$preload(href, as, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $e229cb5c8b2cd629$var$getStyleKey(href);
                break;
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        if (!($e229cb5c8b2cd629$var$preloadPropsMap.has(key) || (href = $e229cb5c8b2cd629$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$e229cb5c8b2cd629$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $e229cb5c8b2cd629$var$clearPendingLoadOnNode(instance);
            });
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $e229cb5c8b2cd629$var$preloadModule(href, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.m(href, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $e229cb5c8b2cd629$var$getScriptKey(href);
        }
        if (!$e229cb5c8b2cd629$var$preloadPropsMap.has(key) && (href = $e229cb5c8b2cd629$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $e229cb5c8b2cd629$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $e229cb5c8b2cd629$var$setInitialProperties(as, "link", href);
            $e229cb5c8b2cd629$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitStyle(href, precedence, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $e229cb5c8b2cd629$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $e229cb5c8b2cd629$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $e229cb5c8b2cd629$var$markNodeAsHoistable(link);
                $e229cb5c8b2cd629$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $e229cb5c8b2cd629$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $e229cb5c8b2cd629$var$preinitScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.X(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$preinitModuleScript(src, options) {
    $e229cb5c8b2cd629$var$previousDispatcher.M(src, options);
    var ownerDocument = $e229cb5c8b2cd629$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $e229cb5c8b2cd629$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $e229cb5c8b2cd629$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(key)), resource || (src = $e229cb5c8b2cd629$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $e229cb5c8b2cd629$var$markNodeAsHoistable(resource), $e229cb5c8b2cd629$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $e229cb5c8b2cd629$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $e229cb5c8b2cd629$var$rootInstanceStackCursor.current) ? $e229cb5c8b2cd629$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href), currentProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $e229cb5c8b2cd629$var$getStyleKey(pendingProps.href);
                var styles$268 = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $e229cb5c8b2cd629$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $e229cb5c8b2cd629$var$preloadPropsMap.set(type, styles$268)), $e229cb5c8b2cd629$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $e229cb5c8b2cd629$var$getScriptKey(pendingProps), currentProps = $e229cb5c8b2cd629$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(444, type));
    }
}
function $e229cb5c8b2cd629$var$getStyleKey(href) {
    return 'href="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(rawProps) {
    return $e229cb5c8b2cd629$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $e229cb5c8b2cd629$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$e229cb5c8b2cd629$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$e229cb5c8b2cd629$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $e229cb5c8b2cd629$var$clearPendingLoadOnNode.bind(null, key), $e229cb5c8b2cd629$var$setInitialProperties(key, "link", preloadProps), $e229cb5c8b2cd629$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $e229cb5c8b2cd629$var$getScriptKey(src) {
    return '[src="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $e229cb5c8b2cd629$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $e229cb5c8b2cd629$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $e229cb5c8b2cd629$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance), instance;
            var styleProps = $e229cb5c8b2cd629$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "style", styleProps);
            $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $e229cb5c8b2cd629$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(styleProps)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $e229cb5c8b2cd629$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $e229cb5c8b2cd629$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $e229cb5c8b2cd629$var$preloadPropsMap.get(instance$274)) instance = $e229cb5c8b2cd629$var$assign({}, props), $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(styleProps);
            $e229cb5c8b2cd629$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $e229cb5c8b2cd629$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $e229cb5c8b2cd629$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $e229cb5c8b2cd629$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $e229cb5c8b2cd629$var$tagCaches = null;
function $e229cb5c8b2cd629$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $e229cb5c8b2cd629$var$tagCaches) {
        var cache = new Map();
        var caches = $e229cb5c8b2cd629$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $e229cb5c8b2cd629$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$e229cb5c8b2cd629$var$internalHoistableMarker] || node[$e229cb5c8b2cd629$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $e229cb5c8b2cd629$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $e229cb5c8b2cd629$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $e229cb5c8b2cd629$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $e229cb5c8b2cd629$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $e229cb5c8b2cd629$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $e229cb5c8b2cd629$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $e229cb5c8b2cd629$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $e229cb5c8b2cd629$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $e229cb5c8b2cd629$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($e229cb5c8b2cd629$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $e229cb5c8b2cd629$var$stylesheetPropsFromRawProps(props);
            (key = $e229cb5c8b2cd629$var$preloadPropsMap.get(key)) && $e229cb5c8b2cd629$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $e229cb5c8b2cd629$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $e229cb5c8b2cd629$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $e229cb5c8b2cd629$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $e229cb5c8b2cd629$var$estimatedBytesWithinLimit = 0;
function $e229cb5c8b2cd629$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $e229cb5c8b2cd629$var$estimatedBytesWithinLimit && ($e229cb5c8b2cd629$var$estimatedBytesWithinLimit = 62500 * $e229cb5c8b2cd629$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $e229cb5c8b2cd629$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $e229cb5c8b2cd629$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $e229cb5c8b2cd629$var$onUnsuspend() {
    this.count--;
    $e229cb5c8b2cd629$var$checkIfFullyUnsuspended(this);
}
function $e229cb5c8b2cd629$var$onUnsuspendImg() {
    this.imgCount--;
    $e229cb5c8b2cd629$var$checkIfFullyUnsuspended(this);
}
var $e229cb5c8b2cd629$var$precedencesByRoot = null;
function $e229cb5c8b2cd629$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $e229cb5c8b2cd629$var$precedencesByRoot = new Map(), resources.forEach($e229cb5c8b2cd629$var$insertStylesheetIntoRoot, state), $e229cb5c8b2cd629$var$precedencesByRoot = null, $e229cb5c8b2cd629$var$onUnsuspend.call(state));
}
function $e229cb5c8b2cd629$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $e229cb5c8b2cd629$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $e229cb5c8b2cd629$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $e229cb5c8b2cd629$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $e229cb5c8b2cd629$var$HostTransitionContext = {
    $$typeof: $e229cb5c8b2cd629$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _currentValue2: $e229cb5c8b2cd629$var$sharedNotPendingObject,
    _threadCount: 0
};
function $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $e229cb5c8b2cd629$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e229cb5c8b2cd629$var$createLaneMap(0);
    this.hiddenUpdates = $e229cb5c8b2cd629$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $e229cb5c8b2cd629$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $e229cb5c8b2cd629$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $e229cb5c8b2cd629$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $e229cb5c8b2cd629$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $e229cb5c8b2cd629$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $e229cb5c8b2cd629$var$emptyContextObject;
    parentComponent = $e229cb5c8b2cd629$var$emptyContextObject;
    return parentComponent;
}
function $e229cb5c8b2cd629$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $e229cb5c8b2cd629$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $e229cb5c8b2cd629$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $e229cb5c8b2cd629$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($e229cb5c8b2cd629$var$scheduleUpdateOnFiber(element, rootFiber, lane), $e229cb5c8b2cd629$var$entangleTransitions(element, rootFiber, lane));
}
function $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $e229cb5c8b2cd629$var$markRetryLaneImpl(fiber, retryLane);
}
function $e229cb5c8b2cd629$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $e229cb5c8b2cd629$var$requestUpdateLane();
        lane = $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(lane);
        var root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, lane);
        $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $e229cb5c8b2cd629$var$_enabled = !0;
function $e229cb5c8b2cd629$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 2, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $e229cb5c8b2cd629$var$ReactSharedInternals.T;
    $e229cb5c8b2cd629$var$ReactSharedInternals.T = null;
    var previousPriority = $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p;
    try {
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = 8, $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $e229cb5c8b2cd629$var$ReactDOMSharedInternals.p = previousPriority, $e229cb5c8b2cd629$var$ReactSharedInternals.T = prevTransition;
    }
}
function $e229cb5c8b2cd629$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($e229cb5c8b2cd629$var$_enabled) {
        var blockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer), $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $e229cb5c8b2cd629$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $e229cb5c8b2cd629$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $e229cb5c8b2cd629$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $e229cb5c8b2cd629$var$ensureRootIsScheduled(fiber);
                                0 === ($e229cb5c8b2cd629$var$executionContext & 6) && ($e229cb5c8b2cd629$var$workInProgressRootRenderTargetTime = $e229cb5c8b2cd629$var$now() + 500, $e229cb5c8b2cd629$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $e229cb5c8b2cd629$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $e229cb5c8b2cd629$var$scheduleUpdateOnFiber(root, fiber, 2), $e229cb5c8b2cd629$var$flushSyncWork$1(), $e229cb5c8b2cd629$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $e229cb5c8b2cd629$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $e229cb5c8b2cd629$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $e229cb5c8b2cd629$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $e229cb5c8b2cd629$var$getEventTarget(nativeEvent);
    return $e229cb5c8b2cd629$var$findInstanceBlockingTarget(nativeEvent);
}
var $e229cb5c8b2cd629$var$return_targetInst = null;
function $e229cb5c8b2cd629$var$findInstanceBlockingTarget(targetNode) {
    $e229cb5c8b2cd629$var$return_targetInst = null;
    targetNode = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $e229cb5c8b2cd629$var$return_targetInst = targetNode;
    return null;
}
function $e229cb5c8b2cd629$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($e229cb5c8b2cd629$var$getCurrentPriorityLevel()){
                case $e229cb5c8b2cd629$var$ImmediatePriority:
                    return 2;
                case $e229cb5c8b2cd629$var$UserBlockingPriority:
                    return 8;
                case $e229cb5c8b2cd629$var$NormalPriority$1:
                case $e229cb5c8b2cd629$var$LowPriority:
                    return 32;
                case $e229cb5c8b2cd629$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1, $e229cb5c8b2cd629$var$queuedFocus = null, $e229cb5c8b2cd629$var$queuedDrag = null, $e229cb5c8b2cd629$var$queuedMouse = null, $e229cb5c8b2cd629$var$queuedPointers = new Map(), $e229cb5c8b2cd629$var$queuedPointerCaptures = new Map(), $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets = [], $e229cb5c8b2cd629$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $e229cb5c8b2cd629$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $e229cb5c8b2cd629$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $e229cb5c8b2cd629$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $e229cb5c8b2cd629$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $e229cb5c8b2cd629$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e229cb5c8b2cd629$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $e229cb5c8b2cd629$var$getInstanceFromNode(blockedOn), null !== blockedOn && $e229cb5c8b2cd629$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $e229cb5c8b2cd629$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $e229cb5c8b2cd629$var$queuedFocus = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $e229cb5c8b2cd629$var$queuedDrag = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $e229cb5c8b2cd629$var$queuedMouse = $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $e229cb5c8b2cd629$var$queuedPointers.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $e229cb5c8b2cd629$var$queuedPointerCaptures.set(pointerId, $e229cb5c8b2cd629$var$accumulateOrCreateContinuousQueuedReplayableEvent($e229cb5c8b2cd629$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $e229cb5c8b2cd629$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $e229cb5c8b2cd629$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $e229cb5c8b2cd629$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e229cb5c8b2cd629$var$runWithPriority(queuedTarget.priority, function() {
                        $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $e229cb5c8b2cd629$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $e229cb5c8b2cd629$var$runWithPriority(queuedTarget.priority, function() {
                        $e229cb5c8b2cd629$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $e229cb5c8b2cd629$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $e229cb5c8b2cd629$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $e229cb5c8b2cd629$var$currentReplayingEvent = null;
        } else return targetContainers = $e229cb5c8b2cd629$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $e229cb5c8b2cd629$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $e229cb5c8b2cd629$var$replayUnblockedEvents() {
    $e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !1;
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedFocus) && ($e229cb5c8b2cd629$var$queuedFocus = null);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedDrag) && ($e229cb5c8b2cd629$var$queuedDrag = null);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEvent($e229cb5c8b2cd629$var$queuedMouse) && ($e229cb5c8b2cd629$var$queuedMouse = null);
    $e229cb5c8b2cd629$var$queuedPointers.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach($e229cb5c8b2cd629$var$attemptReplayContinuousQueuedEventInMap);
}
function $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $e229cb5c8b2cd629$var$hasScheduledReplayAttempt || ($e229cb5c8b2cd629$var$hasScheduledReplayAttempt = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $e229cb5c8b2cd629$var$replayUnblockedEvents)));
}
var $e229cb5c8b2cd629$var$lastScheduledReplayQueue = null;
function $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $e229cb5c8b2cd629$var$lastScheduledReplayQueue !== formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = formReplayingQueue, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, function() {
        $e229cb5c8b2cd629$var$lastScheduledReplayQueue === formReplayingQueue && ($e229cb5c8b2cd629$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $e229cb5c8b2cd629$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $e229cb5c8b2cd629$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $e229cb5c8b2cd629$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $e229cb5c8b2cd629$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $e229cb5c8b2cd629$var$queuedFocus && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedFocus, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedDrag && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedDrag, unblocked);
    null !== $e229cb5c8b2cd629$var$queuedMouse && $e229cb5c8b2cd629$var$scheduleCallbackIfUnblocked($e229cb5c8b2cd629$var$queuedMouse, unblocked);
    $e229cb5c8b2cd629$var$queuedPointers.forEach(unblock);
    $e229cb5c8b2cd629$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && (i = $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$e229cb5c8b2cd629$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$e229cb5c8b2cd629$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $e229cb5c8b2cd629$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $e229cb5c8b2cd629$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $e229cb5c8b2cd629$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.render = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(409));
    var current = root.current, lane = $e229cb5c8b2cd629$var$requestUpdateLane();
    $e229cb5c8b2cd629$var$updateContainerImpl(current, lane, children, root, null, null);
};
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unmount = $e229cb5c8b2cd629$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $e229cb5c8b2cd629$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $e229cb5c8b2cd629$var$flushSyncWork$1();
        container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = null;
    }
};
function $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$e229cb5c8b2cd629$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $e229cb5c8b2cd629$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets[i].priority; i++);
        $e229cb5c8b2cd629$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $e229cb5c8b2cd629$var$attemptExplicitHydrationTarget(target);
    }
};
var $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $bh6RR.version;
if ("19.3.0" !== $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(527, $e229cb5c8b2cd629$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.0"));
$e229cb5c8b2cd629$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $e229cb5c8b2cd629$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $e229cb5c8b2cd629$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $e229cb5c8b2cd629$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $e229cb5c8b2cd629$var$ReactSharedInternals,
    reconcilerVersion: "19.3.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e229cb5c8b2cd629$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e229cb5c8b2cd629$var$hook$jscomp$inline_2587.isDisabled && $e229cb5c8b2cd629$var$hook$jscomp$inline_2587.supportsFiber) try {
        $e229cb5c8b2cd629$var$rendererID = $e229cb5c8b2cd629$var$hook$jscomp$inline_2587.inject($e229cb5c8b2cd629$var$internals$jscomp$inline_2586), $e229cb5c8b2cd629$var$injectedHook = $e229cb5c8b2cd629$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$e229cb5c8b2cd629$export$882461b6382ed46c = function(container, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = options.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(container);
    return new $e229cb5c8b2cd629$var$ReactDOMRoot(options);
};
$e229cb5c8b2cd629$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$e229cb5c8b2cd629$var$isValidContainer(container)) throw Error($e229cb5c8b2cd629$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $e229cb5c8b2cd629$var$defaultOnUncaughtError, onCaughtError = $e229cb5c8b2cd629$var$defaultOnCaughtError, onRecoverableError = $e229cb5c8b2cd629$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $e229cb5c8b2cd629$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $e229cb5c8b2cd629$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $e229cb5c8b2cd629$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $e229cb5c8b2cd629$var$requestUpdateLane();
    isStrictMode = $e229cb5c8b2cd629$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $e229cb5c8b2cd629$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $e229cb5c8b2cd629$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $e229cb5c8b2cd629$var$markRootUpdated$1(initialChildren, options);
    $e229cb5c8b2cd629$var$ensureRootIsScheduled(initialChildren);
    container[$e229cb5c8b2cd629$var$internalContainerInstanceKey] = initialChildren.current;
    $e229cb5c8b2cd629$var$listenToAllSupportedEvents(container);
    return new $e229cb5c8b2cd629$var$ReactDOMHydrationRoot(initialChildren);
};
$e229cb5c8b2cd629$export$83d89fbfd8236492 = "19.3.0";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4CW02"));

});
parcelRegister("4CW02", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $35e7b389374acc05$export$c4744153514ff05d; }, function (v) { return $35e7b389374acc05$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $35e7b389374acc05$export$3e506c1ccc9cc1a7; }, function (v) { return $35e7b389374acc05$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $35e7b389374acc05$export$e26fe2ed2fa76875; }, function (v) { return $35e7b389374acc05$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $35e7b389374acc05$export$502329bbf4b505b1; }, function (v) { return $35e7b389374acc05$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $35e7b389374acc05$export$6e3807111c4874c4; }, function (v) { return $35e7b389374acc05$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $35e7b389374acc05$export$c27134553091fb3a; }, function (v) { return $35e7b389374acc05$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $35e7b389374acc05$export$33ee1acdc04fd2a2; }, function (v) { return $35e7b389374acc05$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $35e7b389374acc05$export$b00a404bbd5edef2; }, function (v) { return $35e7b389374acc05$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $35e7b389374acc05$export$d66a1c1c77bd778b; }, function (v) { return $35e7b389374acc05$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $35e7b389374acc05$export$d3dfb8e4810cb555; }, function (v) { return $35e7b389374acc05$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $35e7b389374acc05$export$72fdf0e06517287b; }, function (v) { return $35e7b389374acc05$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $35e7b389374acc05$export$816d2913ae6b83b1; }, function (v) { return $35e7b389374acc05$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $35e7b389374acc05$export$61bcfe829111a1d0; }, function (v) { return $35e7b389374acc05$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $35e7b389374acc05$export$7ee8c9beb337bc3f; }, function (v) { return $35e7b389374acc05$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $35e7b389374acc05$export$b5836b71941fa3ed; }, function (v) { return $35e7b389374acc05$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $35e7b389374acc05$export$cf845f2c119da08a; }, function (v) { return $35e7b389374acc05$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $35e7b389374acc05$export$c4744153514ff05d;
var $35e7b389374acc05$export$3e506c1ccc9cc1a7;
var $35e7b389374acc05$export$e26fe2ed2fa76875;
var $35e7b389374acc05$export$502329bbf4b505b1;
var $35e7b389374acc05$export$6e3807111c4874c4;
var $35e7b389374acc05$export$c27134553091fb3a;
var $35e7b389374acc05$export$33ee1acdc04fd2a2;
var $35e7b389374acc05$export$b00a404bbd5edef2;
var $35e7b389374acc05$export$d66a1c1c77bd778b;
var $35e7b389374acc05$export$d3dfb8e4810cb555;
var $35e7b389374acc05$export$72fdf0e06517287b;
var $35e7b389374acc05$export$816d2913ae6b83b1;
var $35e7b389374acc05$export$61bcfe829111a1d0;
var $35e7b389374acc05$export$7ee8c9beb337bc3f;
var $35e7b389374acc05$export$b5836b71941fa3ed;
var $35e7b389374acc05$export$cf845f2c119da08a;
"use strict";
function $35e7b389374acc05$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $35e7b389374acc05$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $35e7b389374acc05$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $35e7b389374acc05$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $35e7b389374acc05$var$compare(left, last)) rightIndex < length && 0 > $35e7b389374acc05$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $35e7b389374acc05$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $35e7b389374acc05$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$35e7b389374acc05$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $35e7b389374acc05$var$localPerformance = performance;
    $35e7b389374acc05$export$c4744153514ff05d = function() {
        return $35e7b389374acc05$var$localPerformance.now();
    };
} else {
    var $35e7b389374acc05$var$localDate = Date, $35e7b389374acc05$var$initialTime = $35e7b389374acc05$var$localDate.now();
    $35e7b389374acc05$export$c4744153514ff05d = function() {
        return $35e7b389374acc05$var$localDate.now() - $35e7b389374acc05$var$initialTime;
    };
}
var $35e7b389374acc05$var$taskQueue = [], $35e7b389374acc05$var$timerQueue = [], $35e7b389374acc05$var$taskIdCounter = 1, $35e7b389374acc05$var$currentTask = null, $35e7b389374acc05$var$currentPriorityLevel = 3, $35e7b389374acc05$var$isPerformingWork = !1, $35e7b389374acc05$var$isHostCallbackScheduled = !1, $35e7b389374acc05$var$isHostTimeoutScheduled = !1, $35e7b389374acc05$var$needsPaint = !1, $35e7b389374acc05$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $35e7b389374acc05$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $35e7b389374acc05$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $35e7b389374acc05$var$advanceTimers(currentTime) {
    for(var timer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue); null !== timer;){
        if (null === timer.callback) $35e7b389374acc05$var$pop($35e7b389374acc05$var$timerQueue);
        else if (timer.startTime <= currentTime) $35e7b389374acc05$var$pop($35e7b389374acc05$var$timerQueue), timer.sortIndex = timer.expirationTime, $35e7b389374acc05$var$push($35e7b389374acc05$var$taskQueue, timer);
        else break;
        timer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
    }
}
function $35e7b389374acc05$var$handleTimeout(currentTime) {
    $35e7b389374acc05$var$isHostTimeoutScheduled = !1;
    $35e7b389374acc05$var$advanceTimers(currentTime);
    if (!$35e7b389374acc05$var$isHostCallbackScheduled) {
        if (null !== $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue)) $35e7b389374acc05$var$isHostCallbackScheduled = !0, $35e7b389374acc05$var$isMessageLoopRunning || ($35e7b389374acc05$var$isMessageLoopRunning = !0, $35e7b389374acc05$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
            null !== firstTimer && $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $35e7b389374acc05$var$isMessageLoopRunning = !1, $35e7b389374acc05$var$taskTimeoutID = -1, $35e7b389374acc05$var$frameInterval = 5, $35e7b389374acc05$var$startTime = -1;
function $35e7b389374acc05$var$shouldYieldToHost() {
    return $35e7b389374acc05$var$needsPaint ? !0 : $35e7b389374acc05$export$c4744153514ff05d() - $35e7b389374acc05$var$startTime < $35e7b389374acc05$var$frameInterval ? !1 : !0;
}
function $35e7b389374acc05$var$performWorkUntilDeadline() {
    $35e7b389374acc05$var$needsPaint = !1;
    if ($35e7b389374acc05$var$isMessageLoopRunning) {
        var currentTime = $35e7b389374acc05$export$c4744153514ff05d();
        $35e7b389374acc05$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $35e7b389374acc05$var$isHostCallbackScheduled = !1;
                $35e7b389374acc05$var$isHostTimeoutScheduled && ($35e7b389374acc05$var$isHostTimeoutScheduled = !1, $35e7b389374acc05$var$localClearTimeout($35e7b389374acc05$var$taskTimeoutID), $35e7b389374acc05$var$taskTimeoutID = -1);
                $35e7b389374acc05$var$isPerformingWork = !0;
                var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
                try {
                    b: {
                        $35e7b389374acc05$var$advanceTimers(currentTime);
                        for($35e7b389374acc05$var$currentTask = $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue); null !== $35e7b389374acc05$var$currentTask && !($35e7b389374acc05$var$currentTask.expirationTime > currentTime && $35e7b389374acc05$var$shouldYieldToHost());){
                            var callback = $35e7b389374acc05$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $35e7b389374acc05$var$currentTask.callback = null;
                                $35e7b389374acc05$var$currentPriorityLevel = $35e7b389374acc05$var$currentTask.priorityLevel;
                                var continuationCallback = callback($35e7b389374acc05$var$currentTask.expirationTime <= currentTime);
                                currentTime = $35e7b389374acc05$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $35e7b389374acc05$var$currentTask.callback = continuationCallback;
                                    $35e7b389374acc05$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $35e7b389374acc05$var$currentTask === $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue) && $35e7b389374acc05$var$pop($35e7b389374acc05$var$taskQueue);
                                $35e7b389374acc05$var$advanceTimers(currentTime);
                            } else $35e7b389374acc05$var$pop($35e7b389374acc05$var$taskQueue);
                            $35e7b389374acc05$var$currentTask = $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue);
                        }
                        if (null !== $35e7b389374acc05$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue);
                            null !== firstTimer && $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $35e7b389374acc05$var$currentTask = null, $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel, $35e7b389374acc05$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $35e7b389374acc05$var$schedulePerformWorkUntilDeadline() : $35e7b389374acc05$var$isMessageLoopRunning = !1;
        }
    }
}
var $35e7b389374acc05$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $35e7b389374acc05$var$localSetImmediate) $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
    $35e7b389374acc05$var$localSetImmediate($35e7b389374acc05$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $35e7b389374acc05$var$channel = new MessageChannel(), $35e7b389374acc05$var$port = $35e7b389374acc05$var$channel.port2;
    $35e7b389374acc05$var$channel.port1.onmessage = $35e7b389374acc05$var$performWorkUntilDeadline;
    $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
        $35e7b389374acc05$var$port.postMessage(null);
    };
} else $35e7b389374acc05$var$schedulePerformWorkUntilDeadline = function() {
    $35e7b389374acc05$var$localSetTimeout($35e7b389374acc05$var$performWorkUntilDeadline, 0);
};
function $35e7b389374acc05$var$requestHostTimeout(callback, ms) {
    $35e7b389374acc05$var$taskTimeoutID = $35e7b389374acc05$var$localSetTimeout(function() {
        callback($35e7b389374acc05$export$c4744153514ff05d());
    }, ms);
}
$35e7b389374acc05$export$3e506c1ccc9cc1a7 = 5;
$35e7b389374acc05$export$e26fe2ed2fa76875 = 1;
$35e7b389374acc05$export$502329bbf4b505b1 = 4;
$35e7b389374acc05$export$6e3807111c4874c4 = 3;
$35e7b389374acc05$export$c27134553091fb3a = null;
$35e7b389374acc05$export$33ee1acdc04fd2a2 = 2;
$35e7b389374acc05$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$35e7b389374acc05$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $35e7b389374acc05$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$35e7b389374acc05$export$d3dfb8e4810cb555 = function() {
    return $35e7b389374acc05$var$currentPriorityLevel;
};
$35e7b389374acc05$export$72fdf0e06517287b = function(eventHandler) {
    switch($35e7b389374acc05$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    $35e7b389374acc05$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$35e7b389374acc05$export$816d2913ae6b83b1 = function() {
    $35e7b389374acc05$var$needsPaint = !0;
};
$35e7b389374acc05$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    $35e7b389374acc05$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$35e7b389374acc05$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $35e7b389374acc05$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $35e7b389374acc05$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $35e7b389374acc05$var$push($35e7b389374acc05$var$timerQueue, priorityLevel), null === $35e7b389374acc05$var$peek($35e7b389374acc05$var$taskQueue) && priorityLevel === $35e7b389374acc05$var$peek($35e7b389374acc05$var$timerQueue) && ($35e7b389374acc05$var$isHostTimeoutScheduled ? ($35e7b389374acc05$var$localClearTimeout($35e7b389374acc05$var$taskTimeoutID), $35e7b389374acc05$var$taskTimeoutID = -1) : $35e7b389374acc05$var$isHostTimeoutScheduled = !0, $35e7b389374acc05$var$requestHostTimeout($35e7b389374acc05$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $35e7b389374acc05$var$push($35e7b389374acc05$var$taskQueue, priorityLevel), $35e7b389374acc05$var$isHostCallbackScheduled || $35e7b389374acc05$var$isPerformingWork || ($35e7b389374acc05$var$isHostCallbackScheduled = !0, $35e7b389374acc05$var$isMessageLoopRunning || ($35e7b389374acc05$var$isMessageLoopRunning = !0, $35e7b389374acc05$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$35e7b389374acc05$export$b5836b71941fa3ed = $35e7b389374acc05$var$shouldYieldToHost;
$35e7b389374acc05$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $35e7b389374acc05$var$currentPriorityLevel;
        $35e7b389374acc05$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $35e7b389374acc05$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("6afFj", function(module, exports) {
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("41dBC"));

});
parcelRegister("41dBC", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0; }, function (v) { return $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $2ed1cf3ec43ffc9d$export$3f2684e5d7cb1006; }, function (v) { return $2ed1cf3ec43ffc9d$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389; }, function (v) { return $2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4; }, function (v) { return $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be; }, function (v) { return $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3; }, function (v) { return $2ed1cf3ec43ffc9d$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86; }, function (v) { return $2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $2ed1cf3ec43ffc9d$export$314cfea32580671c; }, function (v) { return $2ed1cf3ec43ffc9d$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039; }, function (v) { return $2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a; }, function (v) { return $2ed1cf3ec43ffc9d$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0; }, function (v) { return $2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1; }, function (v) { return $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6; }, function (v) { return $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e; }, function (v) { return $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492; }, function (v) { return $2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0;
var $2ed1cf3ec43ffc9d$export$3f2684e5d7cb1006;
var $2ed1cf3ec43ffc9d$export$d39a5bbd09211389;
var $2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4;
var $2ed1cf3ec43ffc9d$export$a0816fa17a9e79be;
var $2ed1cf3ec43ffc9d$export$7292efcadded39f3;
var $2ed1cf3ec43ffc9d$export$da407abadb9b8f86;
var $2ed1cf3ec43ffc9d$export$314cfea32580671c;
var $2ed1cf3ec43ffc9d$export$513ccb98c53b8039;
var $2ed1cf3ec43ffc9d$export$dbca993bc2d264a;
var $2ed1cf3ec43ffc9d$export$4797a8006f0655d0;
var $2ed1cf3ec43ffc9d$export$c78a37762a8d58e1;
var $2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6;
var $2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e;
var $2ed1cf3ec43ffc9d$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $2ed1cf3ec43ffc9d$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2ed1cf3ec43ffc9d$var$noop() {}
var $2ed1cf3ec43ffc9d$var$Internals = {
    d: {
        f: $2ed1cf3ec43ffc9d$var$noop,
        r: function() {
            throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(522));
        },
        D: $2ed1cf3ec43ffc9d$var$noop,
        C: $2ed1cf3ec43ffc9d$var$noop,
        L: $2ed1cf3ec43ffc9d$var$noop,
        m: $2ed1cf3ec43ffc9d$var$noop,
        X: $2ed1cf3ec43ffc9d$var$noop,
        S: $2ed1cf3ec43ffc9d$var$noop,
        M: $2ed1cf3ec43ffc9d$var$noop
    },
    p: 0,
    findDOMNode: null
}, $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2ed1cf3ec43ffc9d$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $2ed1cf3ec43ffc9d$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $2ed1cf3ec43ffc9d$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $2ed1cf3ec43ffc9d$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $2ed1cf3ec43ffc9d$var$REACT_OPTIMISTIC_KEY ? $2ed1cf3ec43ffc9d$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $2ed1cf3ec43ffc9d$var$ReactSharedInternals = $bh6RR.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$2ed1cf3ec43ffc9d$export$69ce8ef3fe5cead0 = $2ed1cf3ec43ffc9d$var$Internals;
$2ed1cf3ec43ffc9d$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $2ed1cf3ec43ffc9d$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$2ed1cf3ec43ffc9d$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($2ed1cf3ec43ffc9d$var$formatProdErrorMessage(299));
    return $2ed1cf3ec43ffc9d$var$createPortal$1(children, container, null, key);
};
$2ed1cf3ec43ffc9d$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T, previousUpdatePriority = $2ed1cf3ec43ffc9d$var$Internals.p;
    try {
        if ($2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = null, $2ed1cf3ec43ffc9d$var$Internals.p = 2, fn) return fn();
    } finally{
        $2ed1cf3ec43ffc9d$var$ReactSharedInternals.T = previousTransition, $2ed1cf3ec43ffc9d$var$Internals.p = previousUpdatePriority, $2ed1cf3ec43ffc9d$var$Internals.d.f();
    }
};
$2ed1cf3ec43ffc9d$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $2ed1cf3ec43ffc9d$var$Internals.d.C(href, options));
};
$2ed1cf3ec43ffc9d$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $2ed1cf3ec43ffc9d$var$Internals.d.D(href);
};
$2ed1cf3ec43ffc9d$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $2ed1cf3ec43ffc9d$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $2ed1cf3ec43ffc9d$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $2ed1cf3ec43ffc9d$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $2ed1cf3ec43ffc9d$var$Internals.d.M(href);
    }
};
$2ed1cf3ec43ffc9d$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(as, options.crossOrigin);
        $2ed1cf3ec43ffc9d$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$2ed1cf3ec43ffc9d$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $2ed1cf3ec43ffc9d$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $2ed1cf3ec43ffc9d$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $2ed1cf3ec43ffc9d$var$Internals.d.m(href);
    }
};
$2ed1cf3ec43ffc9d$export$4797a8006f0655d0 = function(form) {
    $2ed1cf3ec43ffc9d$var$Internals.d.r(form);
};
$2ed1cf3ec43ffc9d$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$2ed1cf3ec43ffc9d$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$2ed1cf3ec43ffc9d$export$f7e8a0bf92324b1e = function() {
    return $2ed1cf3ec43ffc9d$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$2ed1cf3ec43ffc9d$export$83d89fbfd8236492 = "19.3.0";

});



parcelRegister("gggdZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("5E0NG")).default; });

var $5E0NG = parcelRequire("5E0NG");

});
parcelRegister("5E0NG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63b1d0acf055f536$export$2e2bcd8739ae039; });

var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");

var $11hmc = parcelRequire("11hmc");
const $63b1d0acf055f536$var$Spinner = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        "data-testid": "spinner",
        className: $11hmc.spinner
    });
};
var $63b1d0acf055f536$export$2e2bcd8739ae039 = $63b1d0acf055f536$var$Spinner;

});
parcelRegister("11hmc", function(module, exports) {

$parcel$export(module.exports, "load", function () { return $0be3592ebfc9324a$export$11e63f7b0f3d9900; }, function (v) { return $0be3592ebfc9324a$export$11e63f7b0f3d9900 = v; });
$parcel$export(module.exports, "spinner", function () { return $0be3592ebfc9324a$export$641374ffb95bc399; }, function (v) { return $0be3592ebfc9324a$export$641374ffb95bc399 = v; });
var $0be3592ebfc9324a$export$11e63f7b0f3d9900;
var $0be3592ebfc9324a$export$641374ffb95bc399;
$0be3592ebfc9324a$export$11e63f7b0f3d9900 = `ZLzsgq_load`;
$0be3592ebfc9324a$export$11e63f7b0f3d9900;
$0be3592ebfc9324a$export$641374ffb95bc399 = `ZLzsgq_spinner`;

});



parcelRegister("bC0hQ", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("lA1BH")),
    $parcel$import("3Mnm8")
]).then(()=>parcelRequire('hVJg2'));

});
parcelRegister("7jkLd", function(module, exports) {
"use strict";

var $boLNp = parcelRequire("boLNp");
module.exports = $boLNp(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("boLNp", function(module, exports) {
"use strict";
var $84c702df89f2997b$var$cachedBundles = {};
var $84c702df89f2997b$var$cachedPreloads = {};
var $84c702df89f2997b$var$cachedPrefetches = {};
function $84c702df89f2997b$var$getCache(type) {
    switch(type){
        case 'preload':
            return $84c702df89f2997b$var$cachedPreloads;
        case 'prefetch':
            return $84c702df89f2997b$var$cachedPrefetches;
        default:
            return $84c702df89f2997b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $84c702df89f2997b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $c6b69ec680bd2ca4$exports = {};
$parcel$extendImportMap({
    "3Mnm8": "Resume.f56597b7.js",
    "lA1BH": "Resume.475ed377.css"
});


var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
var $6fc264ec92100d3a$exports = {};
'use strict';
function $6fc264ec92100d3a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6fc264ec92100d3a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6fc264ec92100d3a$var$checkDCE();

$6fc264ec92100d3a$exports = (parcelRequire("jpRqs"));



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $0708bf9e8ef239fb$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $0708bf9e8ef239fb$export$825a82322d91916e = /^[\\/]{2}/;
function $0708bf9e8ef239fb$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $07c07e885d25f310$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $07c07e885d25f310$var$PopStateEventType = "popstate";
function $07c07e885d25f310$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $07c07e885d25f310$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $07c07e885d25f310$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $07c07e885d25f310$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $07c07e885d25f310$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $07c07e885d25f310$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $07c07e885d25f310$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $07c07e885d25f310$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $07c07e885d25f310$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $07c07e885d25f310$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $07c07e885d25f310$export$fe53371bee54353d(to);
    }
    return $07c07e885d25f310$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $07c07e885d25f310$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $07c07e885d25f310$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $07c07e885d25f310$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $07c07e885d25f310$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $07c07e885d25f310$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $07c07e885d25f310$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $07c07e885d25f310$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $07c07e885d25f310$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
function $07c07e885d25f310$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $07c07e885d25f310$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $07c07e885d25f310$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $07c07e885d25f310$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $07c07e885d25f310$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $07c07e885d25f310$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $07c07e885d25f310$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $07c07e885d25f310$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $07c07e885d25f310$var$isLocation(to) ? to : $07c07e885d25f310$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $07c07e885d25f310$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $07c07e885d25f310$var$isLocation(to) ? to : $07c07e885d25f310$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $07c07e885d25f310$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $07c07e885d25f310$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($07c07e885d25f310$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($07c07e885d25f310$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $07c07e885d25f310$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $07c07e885d25f310$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $07c07e885d25f310$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $0708bf9e8ef239fb$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $bh6RR = parcelRequire("bh6RR");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $32f955841b0fe350$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $32f955841b0fe350$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
const $32f955841b0fe350$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $32f955841b0fe350$export$3e22299e33adeed1(key) {
    return $32f955841b0fe350$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $32f955841b0fe350$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $32f955841b0fe350$export$a89d811eaa209e85(key) {
    return $32f955841b0fe350$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $32f955841b0fe350$var$isIndexRoute(route) {
    return route.index === true;
}
function $32f955841b0fe350$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $bh6RR.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $bh6RR.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $32f955841b0fe350$export$87cb1a9238dc3fba(routes, mapRouteProperties = $32f955841b0fe350$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $07c07e885d25f310$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $07c07e885d25f310$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($32f955841b0fe350$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $32f955841b0fe350$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $32f955841b0fe350$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $32f955841b0fe350$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $32f955841b0fe350$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $32f955841b0fe350$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $32f955841b0fe350$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $32f955841b0fe350$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $32f955841b0fe350$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $32f955841b0fe350$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $32f955841b0fe350$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $32f955841b0fe350$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $32f955841b0fe350$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $32f955841b0fe350$export$e486c0390e42ccf6(routes) {
    let branches = $32f955841b0fe350$var$flattenRoutes(routes);
    $32f955841b0fe350$var$rankRouteBranches(branches);
    return branches;
}
function $32f955841b0fe350$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $07c07e885d25f310$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $32f955841b0fe350$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $07c07e885d25f310$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $32f955841b0fe350$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $32f955841b0fe350$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $32f955841b0fe350$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $32f955841b0fe350$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $32f955841b0fe350$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $32f955841b0fe350$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $32f955841b0fe350$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $32f955841b0fe350$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $32f955841b0fe350$var$paramRe = /^:[\w-]+$/;
const $32f955841b0fe350$var$partialParamRe = /^:[\w-]+/;
const $32f955841b0fe350$var$partialDynamicSegmentValue = 3.5;
const $32f955841b0fe350$var$dynamicSegmentValue = 3;
const $32f955841b0fe350$var$indexRouteValue = 2;
const $32f955841b0fe350$var$emptySegmentValue = 1;
const $32f955841b0fe350$var$staticSegmentValue = 10;
const $32f955841b0fe350$var$splatPenalty = -2;
const $32f955841b0fe350$var$isSplat = (s)=>s === "*";
function $32f955841b0fe350$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($32f955841b0fe350$var$isSplat)) initialScore += $32f955841b0fe350$var$splatPenalty;
    if (index) initialScore += $32f955841b0fe350$var$indexRouteValue;
    return segments.filter((s)=>!$32f955841b0fe350$var$isSplat(s)).reduce((score, segment)=>score + ($32f955841b0fe350$var$paramRe.test(segment) ? $32f955841b0fe350$var$dynamicSegmentValue : $32f955841b0fe350$var$partialParamRe.test(segment) ? $32f955841b0fe350$var$partialDynamicSegmentValue : segment === "" ? $32f955841b0fe350$var$emptySegmentValue : $32f955841b0fe350$var$staticSegmentValue), initialScore);
}
function $32f955841b0fe350$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $32f955841b0fe350$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $32f955841b0fe350$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $32f955841b0fe350$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $32f955841b0fe350$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $32f955841b0fe350$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $32f955841b0fe350$var$normalizePathname($32f955841b0fe350$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $32f955841b0fe350$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $32f955841b0fe350$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $32f955841b0fe350$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$32f955841b0fe350$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $32f955841b0fe350$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $07c07e885d25f310$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $07c07e885d25f310$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $32f955841b0fe350$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $32f955841b0fe350$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $32f955841b0fe350$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $32f955841b0fe350$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $32f955841b0fe350$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $32f955841b0fe350$export$b6d465111d914331(matchedPathname, 1);
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = $32f955841b0fe350$export$b6d465111d914331(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $32f955841b0fe350$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $07c07e885d25f310$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $32f955841b0fe350$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $07c07e885d25f310$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $32f955841b0fe350$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $32f955841b0fe350$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $32f955841b0fe350$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $32f955841b0fe350$export$a1cbf2de32a9fd1 = (url)=>(0, $0708bf9e8ef239fb$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $32f955841b0fe350$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $32f955841b0fe350$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $32f955841b0fe350$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $32f955841b0fe350$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $32f955841b0fe350$var$normalizeSearch(search),
        hash: $32f955841b0fe350$var$normalizeHash(hash)
    };
}
function $32f955841b0fe350$var$resolvePathname(relativePath, fromPathname) {
    let segments = $32f955841b0fe350$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $32f955841b0fe350$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $32f955841b0fe350$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $32f955841b0fe350$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $32f955841b0fe350$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $32f955841b0fe350$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $07c07e885d25f310$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $32f955841b0fe350$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $07c07e885d25f310$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $32f955841b0fe350$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $07c07e885d25f310$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $32f955841b0fe350$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $32f955841b0fe350$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $32f955841b0fe350$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $32f955841b0fe350$export$86d9a7913e44197e = (paths)=>$32f955841b0fe350$export$f857a07c5bd323b8(paths.join("/"));
function $32f955841b0fe350$export$b6d465111d914331(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
const $32f955841b0fe350$var$normalizePathname = (pathname)=>$32f955841b0fe350$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $32f955841b0fe350$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $32f955841b0fe350$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $32f955841b0fe350$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $32f955841b0fe350$export$4051a07651545597(data, init) {
    return new $32f955841b0fe350$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $32f955841b0fe350$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $32f955841b0fe350$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $32f955841b0fe350$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $32f955841b0fe350$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $32f955841b0fe350$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $32f955841b0fe350$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $32f955841b0fe350$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $32f955841b0fe350$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $32f955841b0fe350$export$d738435097971c09(matches) {
    return $32f955841b0fe350$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $32f955841b0fe350$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $32f955841b0fe350$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $32f955841b0fe350$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $0708bf9e8ef239fb$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($32f955841b0fe350$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $0708bf9e8ef239fb$export$825a82322d91916e).test(to) ? new URL((0, $0708bf9e8ef239fb$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $32f955841b0fe350$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch  {
        (0, $07c07e885d25f310$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region lib/router/instrumentation.ts
const $cff0a80e53639d64$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $cff0a80e53639d64$export$b1aab28b8e9d7d25 = (0, $32f955841b0fe350$export$fd42f52fd3ae1109)();
let $cff0a80e53639d64$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $cff0a80e53639d64$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $cff0a80e53639d64$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $cff0a80e53639d64$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $cff0a80e53639d64$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $cff0a80e53639d64$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $cff0a80e53639d64$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated.loader, $cff0a80e53639d64$var$getHandlerInfo(args[0]), ()=>original(...args), $cff0a80e53639d64$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $cff0a80e53639d64$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $cff0a80e53639d64$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated.action, $cff0a80e53639d64$var$getHandlerInfo(args[0]), ()=>original(...args), $cff0a80e53639d64$var$getInstrumentationInnerResult));
        };
        $cff0a80e53639d64$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $cff0a80e53639d64$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated.middleware, $cff0a80e53639d64$var$getHandlerInfo(args[0]), ()=>original(...args), $cff0a80e53639d64$var$getInstrumentationInnerResult));
        };
        $cff0a80e53639d64$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $cff0a80e53639d64$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $cff0a80e53639d64$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $07c07e885d25f310$export$fe53371bee54353d)(to) : ".",
                ...$cff0a80e53639d64$var$getRouterInfo(router, opts ?? {})
            };
            return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $cff0a80e53639d64$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$cff0a80e53639d64$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $cff0a80e53639d64$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $cff0a80e53639d64$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$cff0a80e53639d64$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $cff0a80e53639d64$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$cff0a80e53639d64$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $cff0a80e53639d64$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $cff0a80e53639d64$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $32f955841b0fe350$export$b8d3e69d4b3eff04)();
        return $cff0a80e53639d64$var$throwOrReturnResult(await $cff0a80e53639d64$var$recurseRight(aggregated.request, {
            request: $cff0a80e53639d64$var$getReadonlyRequest(request),
            context: $cff0a80e53639d64$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($cff0a80e53639d64$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $07c07e885d25f310$export$f5708dca728d7177)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$cff0a80e53639d64$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $cff0a80e53639d64$var$getUninstrumentedHandler(handler) {
    return handler[$cff0a80e53639d64$var$UninstrumentedSymbol] ?? handler;
}
function $cff0a80e53639d64$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$cff0a80e53639d64$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $cff0a80e53639d64$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $cff0a80e53639d64$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($cff0a80e53639d64$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $cff0a80e53639d64$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $cff0a80e53639d64$export$5579798e35f5560e(router) {
    let receiver = $cff0a80e53639d64$var$instrumentationClientResultMetaReceivers.get(router);
    $cff0a80e53639d64$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $cff0a80e53639d64$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $cff0a80e53639d64$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $cff0a80e53639d64$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $07c07e885d25f310$export$f5708dca728d7177)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $cff0a80e53639d64$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $cff0a80e53639d64$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $cff0a80e53639d64$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $cff0a80e53639d64$var$getReadonlyContext(context)
    };
}
function $cff0a80e53639d64$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $07c07e885d25f310$export$fe53371bee54353d)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $cff0a80e53639d64$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $cff0a80e53639d64$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
const $fe0e33ca47261b38$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $fe0e33ca47261b38$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $fe0e33ca47261b38$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $fe0e33ca47261b38$var$DEFAULT_NAVIGATION_URL;
    }
}
function $fe0e33ca47261b38$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $fe0e33ca47261b38$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $fe0e33ca47261b38$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$fe0e33ca47261b38$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$fe0e33ca47261b38$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$fe0e33ca47261b38$var$isExplicitUrl(original, originalUrl) || !$fe0e33ca47261b38$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}


//#region lib/router/router.ts
const $f7ec0efaa1916726$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $f7ec0efaa1916726$var$validMutationMethods = new Set($f7ec0efaa1916726$var$validMutationMethodsArr);
const $f7ec0efaa1916726$var$validRequestMethodsArr = [
    "GET",
    ...$f7ec0efaa1916726$var$validMutationMethodsArr
];
const $f7ec0efaa1916726$var$validRequestMethods = new Set($f7ec0efaa1916726$var$validRequestMethodsArr);
const $f7ec0efaa1916726$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f7ec0efaa1916726$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f7ec0efaa1916726$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $f7ec0efaa1916726$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $f7ec0efaa1916726$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $f7ec0efaa1916726$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $f7ec0efaa1916726$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $f7ec0efaa1916726$var$DataRoutes = class {
    #routes;
    #branches;
    #hmrRoutes;
    #hmrBranches;
    constructor(routes){
        this.#routes = routes;
        this.#branches = (0, $32f955841b0fe350$export$e486c0390e42ccf6)(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    /** Pre-computed branches */ get branches() {
        return this.#hmrBranches ?? this.#branches;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        this.#branches = (0, $32f955841b0fe350$export$e486c0390e42ccf6)(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#hmrBranches = (0, $32f955841b0fe350$export$e486c0390e42ccf6)(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#branches = this.#hmrBranches;
            this.#hmrRoutes = void 0;
            this.#hmrBranches = void 0;
        }
    }
};
/**
* Create a router and listen to history POP navigations
*/ function $f7ec0efaa1916726$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $07c07e885d25f310$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $cff0a80e53639d64$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $f7ec0efaa1916726$var$DataRoutes((0, $32f955841b0fe350$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $f7ec0efaa1916726$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $f7ec0efaa1916726$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f7ec0efaa1916726$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$f7ec0efaa1916726$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $f7ec0efaa1916726$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $f7ec0efaa1916726$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $07c07e885d25f310$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f7ec0efaa1916726$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $f7ec0efaa1916726$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f7ec0efaa1916726$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f7ec0efaa1916726$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $f7ec0efaa1916726$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f7ec0efaa1916726$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f7ec0efaa1916726$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP") {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $f7ec0efaa1916726$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $f7ec0efaa1916726$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $cff0a80e53639d64$export$5579798e35f5560e)(router);
        let { path: path, submission: submission, error: error } = $f7ec0efaa1916726$var$normalizeNavigateOptions(false, $f7ec0efaa1916726$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ((0, $0708bf9e8ef239fb$export$825a82322d91916e).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            (0, $fe0e33ca47261b38$export$6c8e41f66e7aa990)(typeof opts.mask === "string" ? opts.mask : (0, $07c07e885d25f310$export$fe53371bee54353d)(opts.mask), (0, $07c07e885d25f310$export$fe53371bee54353d)(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = (0, $07c07e885d25f310$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        (0, $fe0e33ca47261b38$export$6c8e41f66e7aa990)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $07c07e885d25f310$export$fe53371bee54353d)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $f7ec0efaa1916726$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f7ec0efaa1916726$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $f7ec0efaa1916726$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : (0, $32f955841b0fe350$export$5c7b09132f833c25)(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $f7ec0efaa1916726$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f7ec0efaa1916726$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $f7ec0efaa1916726$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $f7ec0efaa1916726$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new (0, $32f955841b0fe350$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $f7ec0efaa1916726$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f7ec0efaa1916726$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f7ec0efaa1916726$var$isErrorResult(result) && (0, $32f955841b0fe350$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f7ec0efaa1916726$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $f7ec0efaa1916726$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$f7ec0efaa1916726$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        updateState({
            navigation: $f7ec0efaa1916726$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $f7ec0efaa1916726$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $f7ec0efaa1916726$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $f7ec0efaa1916726$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $f7ec0efaa1916726$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f7ec0efaa1916726$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $f7ec0efaa1916726$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f7ec0efaa1916726$var$isErrorResult(result)) {
            let boundaryMatch = $f7ec0efaa1916726$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $f7ec0efaa1916726$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $f7ec0efaa1916726$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $f7ec0efaa1916726$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $f7ec0efaa1916726$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $f7ec0efaa1916726$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$f7ec0efaa1916726$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect = $f7ec0efaa1916726$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $f7ec0efaa1916726$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $f7ec0efaa1916726$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $f7ec0efaa1916726$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $cff0a80e53639d64$export$5579798e35f5560e)(router);
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $f7ec0efaa1916726$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($f7ec0efaa1916726$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $f7ec0efaa1916726$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f7ec0efaa1916726$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $32f955841b0fe350$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f7ec0efaa1916726$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        updateFetcherState(key, $f7ec0efaa1916726$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f7ec0efaa1916726$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f7ec0efaa1916726$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $f7ec0efaa1916726$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $f7ec0efaa1916726$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($f7ec0efaa1916726$var$isRedirectResult(actionResult) || $f7ec0efaa1916726$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f7ec0efaa1916726$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($f7ec0efaa1916726$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $f7ec0efaa1916726$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f7ec0efaa1916726$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($f7ec0efaa1916726$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f7ec0efaa1916726$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? (0, $32f955841b0fe350$export$5c7b09132f833c25)(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        (0, $07c07e885d25f310$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $f7ec0efaa1916726$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $f7ec0efaa1916726$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $f7ec0efaa1916726$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) {
            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
            return;
        }
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $f7ec0efaa1916726$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $f7ec0efaa1916726$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $f7ec0efaa1916726$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $f7ec0efaa1916726$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $f7ec0efaa1916726$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $07c07e885d25f310$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $f7ec0efaa1916726$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f7ec0efaa1916726$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f7ec0efaa1916726$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f7ec0efaa1916726$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $f7ec0efaa1916726$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $f7ec0efaa1916726$var$getDoneFetcher(void 0));
            return;
        }
        if ($f7ec0efaa1916726$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $f7ec0efaa1916726$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($f7ec0efaa1916726$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $f7ec0efaa1916726$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $07c07e885d25f310$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $f7ec0efaa1916726$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        (0, $fe0e33ca47261b38$export$6c8e41f66e7aa990)(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = (0, $07c07e885d25f310$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $32f955841b0fe350$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $07c07e885d25f310$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $32f955841b0fe350$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f7ec0efaa1916726$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($f7ec0efaa1916726$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $f7ec0efaa1916726$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $f7ec0efaa1916726$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $f7ec0efaa1916726$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$f7ec0efaa1916726$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($f7ec0efaa1916726$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $f7ec0efaa1916726$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $f7ec0efaa1916726$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $f7ec0efaa1916726$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $f7ec0efaa1916726$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $f7ec0efaa1916726$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $f7ec0efaa1916726$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $07c07e885d25f310$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $f7ec0efaa1916726$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $07c07e885d25f310$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $07c07e885d25f310$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f7ec0efaa1916726$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f7ec0efaa1916726$export$386d57f03f0b2883;
        (0, $07c07e885d25f310$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $07c07e885d25f310$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f7ec0efaa1916726$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $f7ec0efaa1916726$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $f7ec0efaa1916726$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $32f955841b0fe350$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) return {
                active: true,
                matches: (0, $32f955841b0fe350$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: (0, $32f955841b0fe350$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $f7ec0efaa1916726$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $32f955841b0fe350$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $f7ec0efaa1916726$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $cff0a80e53639d64$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $f7ec0efaa1916726$export$3336b097a6fbc59a(routes, opts) {
    (0, $07c07e885d25f310$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    ({
        ...opts?.future
    });
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $cff0a80e53639d64$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $32f955841b0fe350$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    let routeBranches = (0, $32f955841b0fe350$export$e486c0390e42ccf6)(dataRoutes);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $f7ec0efaa1916726$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $07c07e885d25f310$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $32f955841b0fe350$export$b8d3e69d4b3eff04)();
        if (!$f7ec0efaa1916726$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f7ec0efaa1916726$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f7ec0efaa1916726$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $f7ec0efaa1916726$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f7ec0efaa1916726$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $07c07e885d25f310$export$f5708dca728d7177)(requestContext instanceof (0, $32f955841b0fe350$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $f7ec0efaa1916726$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $f7ec0efaa1916726$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $32f955841b0fe350$export$141d98e45b4b08e4)(request, location),
                    pattern: (0, $32f955841b0fe350$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($f7ec0efaa1916726$export$6e80290866a84dd4(error)) return error;
                    if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $32f955841b0fe350$export$f2680fa305b734ca)(error.status, error.statusText, await $f7ec0efaa1916726$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($f7ec0efaa1916726$export$e0163cfdf7bc9cfa(error)) error = $f7ec0efaa1916726$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $f7ec0efaa1916726$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $f7ec0efaa1916726$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $f7ec0efaa1916726$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $32f955841b0fe350$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $07c07e885d25f310$export$f5708dca728d7177)($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $f7ec0efaa1916726$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $07c07e885d25f310$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $32f955841b0fe350$export$b8d3e69d4b3eff04)();
        if (!$f7ec0efaa1916726$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f7ec0efaa1916726$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f7ec0efaa1916726$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f7ec0efaa1916726$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f7ec0efaa1916726$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $f7ec0efaa1916726$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $07c07e885d25f310$export$f5708dca728d7177)(requestContext instanceof (0, $32f955841b0fe350$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $f7ec0efaa1916726$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $f7ec0efaa1916726$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $32f955841b0fe350$export$141d98e45b4b08e4)(request, location),
                pattern: (0, $32f955841b0fe350$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $f7ec0efaa1916726$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($f7ec0efaa1916726$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($f7ec0efaa1916726$var$dataWithResponseInitToResponse(error));
                if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $07c07e885d25f310$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f7ec0efaa1916726$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $f7ec0efaa1916726$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($f7ec0efaa1916726$var$isDataStrategyResult(e) && $f7ec0efaa1916726$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($f7ec0efaa1916726$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f7ec0efaa1916726$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $f7ec0efaa1916726$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($f7ec0efaa1916726$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($f7ec0efaa1916726$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($f7ec0efaa1916726$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f7ec0efaa1916726$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $32f955841b0fe350$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f7ec0efaa1916726$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $f7ec0efaa1916726$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $32f955841b0fe350$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $f7ec0efaa1916726$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $32f955841b0fe350$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $f7ec0efaa1916726$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $f7ec0efaa1916726$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $f7ec0efaa1916726$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$f7ec0efaa1916726$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $f7ec0efaa1916726$var$callDataStrategyImpl(dataStrategy || $f7ec0efaa1916726$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($f7ec0efaa1916726$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $f7ec0efaa1916726$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($f7ec0efaa1916726$export$e0163cfdf7bc9cfa(result.result)) throw $f7ec0efaa1916726$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $f7ec0efaa1916726$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $f7ec0efaa1916726$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $32f955841b0fe350$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $f7ec0efaa1916726$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $f7ec0efaa1916726$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $f7ec0efaa1916726$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $f7ec0efaa1916726$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $32f955841b0fe350$export$cae722b0cc860f13)(to ? to : ".", (0, $32f955841b0fe350$export$fe6dbc5de95f53ab)(contextualMatches), (0, $32f955841b0fe350$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $f7ec0efaa1916726$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $32f955841b0fe350$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $07c07e885d25f310$export$fe53371bee54353d)(path);
}
function $f7ec0efaa1916726$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$f7ec0efaa1916726$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f7ec0efaa1916726$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f7ec0efaa1916726$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f7ec0efaa1916726$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $f7ec0efaa1916726$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$f7ec0efaa1916726$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$f7ec0efaa1916726$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch  {
                return getInvalidBodyError();
            }
        }
    }
    (0, $07c07e885d25f310$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f7ec0efaa1916726$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f7ec0efaa1916726$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f7ec0efaa1916726$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f7ec0efaa1916726$var$convertSearchParamsToFormData(searchParams);
    } catch  {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($f7ec0efaa1916726$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $f7ec0efaa1916726$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $07c07e885d25f310$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $f7ec0efaa1916726$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $32f955841b0fe350$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$f7ec0efaa1916726$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $f7ec0efaa1916726$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($f7ec0efaa1916726$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $f7ec0efaa1916726$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($f7ec0efaa1916726$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $f7ec0efaa1916726$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $f7ec0efaa1916726$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $f7ec0efaa1916726$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $f7ec0efaa1916726$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($f7ec0efaa1916726$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $f7ec0efaa1916726$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $f7ec0efaa1916726$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$f7ec0efaa1916726$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $f7ec0efaa1916726$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $f7ec0efaa1916726$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $f7ec0efaa1916726$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $f7ec0efaa1916726$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $07c07e885d25f310$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$f7ec0efaa1916726$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $32f955841b0fe350$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $32f955841b0fe350$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $f7ec0efaa1916726$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$f7ec0efaa1916726$var$isSameRoute(aChild, bChild))) ?? false;
}
const $f7ec0efaa1916726$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $f7ec0efaa1916726$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $07c07e885d25f310$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $f7ec0efaa1916726$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $f7ec0efaa1916726$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $32f955841b0fe350$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $07c07e885d25f310$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $07c07e885d25f310$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
const $f7ec0efaa1916726$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $f7ec0efaa1916726$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $07c07e885d25f310$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $f7ec0efaa1916726$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $07c07e885d25f310$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $32f955841b0fe350$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $07c07e885d25f310$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $07c07e885d25f310$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $f7ec0efaa1916726$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $f7ec0efaa1916726$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $f7ec0efaa1916726$var$isNonNullable(value) {
    return value !== void 0;
}
function $f7ec0efaa1916726$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $f7ec0efaa1916726$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($f7ec0efaa1916726$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $f7ec0efaa1916726$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $f7ec0efaa1916726$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $f7ec0efaa1916726$var$defaultDataStrategy(args);
    return $f7ec0efaa1916726$var$runClientMiddlewarePipeline(args, ()=>$f7ec0efaa1916726$var$defaultDataStrategy(args));
}
function $f7ec0efaa1916726$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $f7ec0efaa1916726$var$runMiddlewarePipeline(args, handler, processResult, $f7ec0efaa1916726$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $f7ec0efaa1916726$export$e0163cfdf7bc9cfa(result) ? $f7ec0efaa1916726$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $f7ec0efaa1916726$var$runClientMiddlewarePipeline(args, handler) {
    return $f7ec0efaa1916726$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($f7ec0efaa1916726$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $f7ec0efaa1916726$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$f7ec0efaa1916726$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $f7ec0efaa1916726$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $f7ec0efaa1916726$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $f7ec0efaa1916726$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $f7ec0efaa1916726$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $f7ec0efaa1916726$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $f7ec0efaa1916726$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $f7ec0efaa1916726$var$loadLazyRoute(match.route, $f7ec0efaa1916726$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $f7ec0efaa1916726$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $f7ec0efaa1916726$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $f7ec0efaa1916726$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $f7ec0efaa1916726$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $f7ec0efaa1916726$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$f7ec0efaa1916726$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($f7ec0efaa1916726$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $f7ec0efaa1916726$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $f7ec0efaa1916726$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $f7ec0efaa1916726$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $f7ec0efaa1916726$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $32f955841b0fe350$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $f7ec0efaa1916726$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $32f955841b0fe350$export$141d98e45b4b08e4)(request, path),
        pattern: (0, $32f955841b0fe350$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $f7ec0efaa1916726$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch  {}
    return results;
}
async function $f7ec0efaa1916726$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $f7ec0efaa1916726$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $32f955841b0fe350$export$141d98e45b4b08e4)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f7ec0efaa1916726$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data",
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $f7ec0efaa1916726$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f7ec0efaa1916726$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $f7ec0efaa1916726$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $f7ec0efaa1916726$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $32f955841b0fe350$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($f7ec0efaa1916726$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $f7ec0efaa1916726$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $32f955841b0fe350$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $32f955841b0fe350$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($f7ec0efaa1916726$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $f7ec0efaa1916726$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $07c07e885d25f310$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $32f955841b0fe350$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f7ec0efaa1916726$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $f7ec0efaa1916726$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $f7ec0efaa1916726$export$961a3ef7a4da3a39(location) {
    try {
        return $f7ec0efaa1916726$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $f7ec0efaa1916726$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $32f955841b0fe350$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $0708bf9e8ef239fb$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $0708bf9e8ef239fb$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($f7ec0efaa1916726$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $32f955841b0fe350$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $32f955841b0fe350$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($f7ec0efaa1916726$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch  {}
    return location;
}
function $f7ec0efaa1916726$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f7ec0efaa1916726$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f7ec0efaa1916726$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $f7ec0efaa1916726$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f7ec0efaa1916726$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f7ec0efaa1916726$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f7ec0efaa1916726$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $07c07e885d25f310$export$f5708dca728d7177)(!$f7ec0efaa1916726$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f7ec0efaa1916726$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $f7ec0efaa1916726$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $f7ec0efaa1916726$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $32f955841b0fe350$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f7ec0efaa1916726$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $f7ec0efaa1916726$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $07c07e885d25f310$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($f7ec0efaa1916726$var$isErrorResult(result)) {
            let boundaryMatch = $f7ec0efaa1916726$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($f7ec0efaa1916726$var$isRedirectResult(result)) (0, $07c07e885d25f310$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $f7ec0efaa1916726$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f7ec0efaa1916726$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $f7ec0efaa1916726$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f7ec0efaa1916726$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f7ec0efaa1916726$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $f7ec0efaa1916726$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $f7ec0efaa1916726$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f7ec0efaa1916726$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $32f955841b0fe350$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $f7ec0efaa1916726$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($f7ec0efaa1916726$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $f7ec0efaa1916726$var$stripHashFromPath(path) {
    return (0, $07c07e885d25f310$export$fe53371bee54353d)({
        ...typeof path === "string" ? (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(path) : path,
        hash: ""
    });
}
function $f7ec0efaa1916726$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $f7ec0efaa1916726$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $f7ec0efaa1916726$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $32f955841b0fe350$export$f2680fa305b734ca)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $f7ec0efaa1916726$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $f7ec0efaa1916726$var$isDataStrategyResult(value));
}
function $f7ec0efaa1916726$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $f7ec0efaa1916726$var$isRedirectDataStrategyResult(result) {
    return $f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result.result) && $f7ec0efaa1916726$var$redirectStatusCodes.has(result.result.status);
}
function $f7ec0efaa1916726$var$isErrorResult(result) {
    return result.type === "error";
}
function $f7ec0efaa1916726$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $f7ec0efaa1916726$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $f7ec0efaa1916726$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f7ec0efaa1916726$export$794b2760043cf8cd(statusCode) {
    return $f7ec0efaa1916726$var$redirectStatusCodes.has(statusCode);
}
function $f7ec0efaa1916726$export$6e80290866a84dd4(result) {
    return $f7ec0efaa1916726$export$3f1eb41d9a6a6a27(result) && $f7ec0efaa1916726$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $f7ec0efaa1916726$var$isValidMethod(method) {
    return $f7ec0efaa1916726$var$validRequestMethods.has(method.toUpperCase());
}
function $f7ec0efaa1916726$export$cbae47800eb95bc3(method) {
    return $f7ec0efaa1916726$var$validMutationMethods.has(method.toUpperCase());
}
function $f7ec0efaa1916726$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f7ec0efaa1916726$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f7ec0efaa1916726$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $32f955841b0fe350$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f7ec0efaa1916726$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $32f955841b0fe350$export$141d98e45b4b08e4)(history.createURL(location), location),
        pattern: matches ? (0, $32f955841b0fe350$export$d738435097971c09)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $f7ec0efaa1916726$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $f7ec0efaa1916726$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $f7ec0efaa1916726$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $f7ec0efaa1916726$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $f7ec0efaa1916726$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $f7ec0efaa1916726$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $f7ec0efaa1916726$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f7ec0efaa1916726$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch  {}
}
function $f7ec0efaa1916726$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f7ec0efaa1916726$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $07c07e885d25f310$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $f7ec0efaa1916726$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");
//#region lib/context.ts
const $789cee98db7f5cca$export$2eeee58951ff3c1c = $bh6RR.createContext(null);
$789cee98db7f5cca$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $789cee98db7f5cca$export$315e3ffb01f217 = $bh6RR.createContext(null);
$789cee98db7f5cca$export$315e3ffb01f217.displayName = "DataRouterState";
const $789cee98db7f5cca$export$717f757c655223f1 = $bh6RR.createContext(false);
function $789cee98db7f5cca$export$6e1eeb090b3ec35b() {
    return $bh6RR.useContext($789cee98db7f5cca$export$717f757c655223f1);
}
const $789cee98db7f5cca$export$3681f408decb40d1 = $bh6RR.createContext({
    isTransitioning: false
});
$789cee98db7f5cca$export$3681f408decb40d1.displayName = "ViewTransition";
const $789cee98db7f5cca$export$cb3f1df1bef00a39 = $bh6RR.createContext(/* @__PURE__ */ new Map());
$789cee98db7f5cca$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $789cee98db7f5cca$export$804c460aade54ac8 = $bh6RR.createContext(null);
$789cee98db7f5cca$export$804c460aade54ac8.displayName = "Await";
const $789cee98db7f5cca$export$2666c20e15407622 = (props)=>$bh6RR.createElement($789cee98db7f5cca$export$804c460aade54ac8.Provider, props);
const $789cee98db7f5cca$export$3044ab7fdabeaee6 = $bh6RR.createContext(null);
$789cee98db7f5cca$export$3044ab7fdabeaee6.displayName = "Navigation";
const $789cee98db7f5cca$export$e6a44b110a0c44d3 = $bh6RR.createContext(null);
$789cee98db7f5cca$export$e6a44b110a0c44d3.displayName = "Location";
const $789cee98db7f5cca$export$aac280ed165a4397 = $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$789cee98db7f5cca$export$aac280ed165a4397.displayName = "Route";
const $789cee98db7f5cca$export$af8bd2647fea9c11 = $bh6RR.createContext(null);
$789cee98db7f5cca$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $ddbba5b896cadb9e$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $ddbba5b896cadb9e$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $ddbba5b896cadb9e$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $ddbba5b896cadb9e$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$ddbba5b896cadb9e$var$ERROR_DIGEST_BASE}:${$ddbba5b896cadb9e$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $ddbba5b896cadb9e$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$ddbba5b896cadb9e$var$ERROR_DIGEST_BASE}:${$ddbba5b896cadb9e$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $32f955841b0fe350$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}



var $bh6RR = parcelRequire("bh6RR");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $f52ca532ac8e956a$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $07c07e885d25f310$export$f5708dca728d7177)($f52ca532ac8e956a$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $f52ca532ac8e956a$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $32f955841b0fe350$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $f52ca532ac8e956a$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext((0, $789cee98db7f5cca$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $f52ca532ac8e956a$export$45d76561a5302f2b() {
    (0, $07c07e885d25f310$export$f5708dca728d7177)($f52ca532ac8e956a$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $bh6RR.useContext((0, $789cee98db7f5cca$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $f52ca532ac8e956a$export$1b3f31771c5d07c() {
    return $bh6RR.useContext((0, $789cee98db7f5cca$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $f52ca532ac8e956a$export$6c330e8992e8a295(pattern) {
    (0, $07c07e885d25f310$export$f5708dca728d7177)($f52ca532ac8e956a$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $f52ca532ac8e956a$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $32f955841b0fe350$export$81336c211d5ff295)(pattern, (0, $32f955841b0fe350$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $f52ca532ac8e956a$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $f52ca532ac8e956a$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    return isDataRoute ? $f52ca532ac8e956a$var$useNavigateStable() : $f52ca532ac8e956a$var$useNavigateUnstable();
}
function $f52ca532ac8e956a$var$useNavigateUnstable() {
    (0, $07c07e885d25f310$export$f5708dca728d7177)($f52ca532ac8e956a$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $bh6RR.useContext((0, $789cee98db7f5cca$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let { matches: matches } = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    let { pathname: locationPathname } = $f52ca532ac8e956a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $32f955841b0fe350$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $bh6RR.useRef(false);
    $bh6RR.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $bh6RR.useCallback((to, options = {})=>{
        (0, $07c07e885d25f310$export$491112666e282270)(activeRef.current, $f52ca532ac8e956a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $32f955841b0fe350$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $32f955841b0fe350$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (0, $fe0e33ca47261b38$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $07c07e885d25f310$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $fe0e33ca47261b38$export$1da545bc000055cf)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $f52ca532ac8e956a$var$OutletContext = $bh6RR.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $f52ca532ac8e956a$export$4138103a3ae699cc() {
    return $bh6RR.useContext($f52ca532ac8e956a$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $f52ca532ac8e956a$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397)).outlet;
    return $bh6RR.useMemo(()=>outlet && /* @__PURE__ */ $bh6RR.createElement($f52ca532ac8e956a$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $f52ca532ac8e956a$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $f52ca532ac8e956a$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    let { pathname: locationPathname } = $f52ca532ac8e956a$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $32f955841b0fe350$export$fe6dbc5de95f53ab)(matches));
    return $bh6RR.useMemo(()=>(0, $32f955841b0fe350$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $f52ca532ac8e956a$export$5d3fca4a98652595(routes, locationArg) {
    return $f52ca532ac8e956a$export$f7ce0646a48561fb(routes, locationArg);
}
function $f52ca532ac8e956a$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $07c07e885d25f310$export$f5708dca728d7177)($f52ca532ac8e956a$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $f52ca532ac8e956a$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $07c07e885d25f310$export$f5708dca728d7177)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : (0, $32f955841b0fe350$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $f52ca532ac8e956a$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $32f955841b0fe350$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $32f955841b0fe350$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f52ca532ac8e956a$var$DefaultErrorComponent() {
    let error = $f52ca532ac8e956a$export$ed527bf60f6e05f2();
    let message = (0, $32f955841b0fe350$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $bh6RR.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $f52ca532ac8e956a$var$defaultErrorElement = /* @__PURE__ */ $bh6RR.createElement($f52ca532ac8e956a$var$DefaultErrorComponent, null);
var $f52ca532ac8e956a$var$RenderErrorBoundary = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $789cee98db7f5cca$export$717f757c655223f1);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $ddbba5b896cadb9e$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $bh6RR.createElement($f52ca532ac8e956a$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $f52ca532ac8e956a$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $f52ca532ac8e956a$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $ddbba5b896cadb9e$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $f52ca532ac8e956a$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $32f955841b0fe350$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            (0, $fe0e33ca47261b38$export$6c8e41f66e7aa990)(redirect.location, target, (0, $fe0e33ca47261b38$export$1da545bc000055cf)(navigator), "allow-explicit");
            if ((0, $f7ec0efaa1916726$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $32f955841b0fe350$export$4e09c449d6c407f7) && !$f52ca532ac8e956a$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $f52ca532ac8e956a$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $bh6RR.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $f52ca532ac8e956a$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $bh6RR.useContext((0, $789cee98db7f5cca$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, children);
}
function $f52ca532ac8e956a$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $07c07e885d25f310$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $32f955841b0fe350$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $f52ca532ac8e956a$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f52ca532ac8e956a$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $bh6RR.createElement($f52ca532ac8e956a$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $bh6RR.createElement($f52ca532ac8e956a$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $f52ca532ac8e956a$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $f52ca532ac8e956a$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $789cee98db7f5cca$export$2eeee58951ff3c1c));
    (0, $07c07e885d25f310$export$f5708dca728d7177)(ctx, $f52ca532ac8e956a$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $f52ca532ac8e956a$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $789cee98db7f5cca$export$315e3ffb01f217));
    (0, $07c07e885d25f310$export$f5708dca728d7177)(state, $f52ca532ac8e956a$var$getDataRouterConsoleError(hookName));
    return state;
}
function $f52ca532ac8e956a$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    (0, $07c07e885d25f310$export$f5708dca728d7177)(route, $f52ca532ac8e956a$var$getDataRouterConsoleError(hookName));
    return route;
}
function $f52ca532ac8e956a$var$useCurrentRouteId(hookName) {
    let route = $f52ca532ac8e956a$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    (0, $07c07e885d25f310$export$f5708dca728d7177)(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
/**
* Returns the ID for the nearest contextual route
*
* @category Hooks
* @returns The ID of the nearest contextual route
*/ function $f52ca532ac8e956a$export$4200b254756b08af() {
    return $f52ca532ac8e956a$var$useCurrentRouteId("useRouteId");
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $f52ca532ac8e956a$export$d0fd4b7106de2769() {
    let state = $f52ca532ac8e956a$var$useDataRouterState("useNavigation");
    return $bh6RR.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $f52ca532ac8e956a$export$600dc272ed516c15() {
    let dataRouterContext = $f52ca532ac8e956a$var$useDataRouterContext("useRevalidator");
    let state = $f52ca532ac8e956a$var$useDataRouterState("useRevalidator");
    let revalidate = $bh6RR.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $bh6RR.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $f52ca532ac8e956a$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f52ca532ac8e956a$var$useDataRouterState("useMatches");
    return $bh6RR.useMemo(()=>matches.map((m)=>(0, $32f955841b0fe350$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $f52ca532ac8e956a$export$1448a5050d252c4d() {
    let state = $f52ca532ac8e956a$var$useDataRouterState("useLoaderData");
    let routeId = $f52ca532ac8e956a$var$useCurrentRouteId("useLoaderData");
    return state.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $f52ca532ac8e956a$export$fd5d37484eab868d(routeId) {
    return $f52ca532ac8e956a$var$useDataRouterState("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $f52ca532ac8e956a$export$fdc00f3f26066d5e() {
    let state = $f52ca532ac8e956a$var$useDataRouterState("useActionData");
    let routeId = $f52ca532ac8e956a$var$useCurrentRouteId("useLoaderData");
    return state.actionData ? state.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $f52ca532ac8e956a$export$ed527bf60f6e05f2() {
    let error = $bh6RR.useContext((0, $789cee98db7f5cca$export$af8bd2647fea9c11));
    let state = $f52ca532ac8e956a$var$useDataRouterState("useRouteError");
    let routeId = $f52ca532ac8e956a$var$useCurrentRouteId("useRouteError");
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $f52ca532ac8e956a$export$78a72ddb39bdd145() {
    return $bh6RR.useContext((0, $789cee98db7f5cca$export$804c460aade54ac8))?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $f52ca532ac8e956a$export$17f53340677d5831() {
    return $bh6RR.useContext((0, $789cee98db7f5cca$export$804c460aade54ac8))?._error;
}
let $f52ca532ac8e956a$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $f52ca532ac8e956a$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f52ca532ac8e956a$var$useDataRouterContext("useBlocker");
    let state = $f52ca532ac8e956a$var$useDataRouterState("useBlocker");
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $32f955841b0fe350$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $32f955841b0fe350$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $bh6RR.useEffect(()=>{
        let key = String(++$f52ca532ac8e956a$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f7ec0efaa1916726$export$386d57f03f0b2883);
}
function $f52ca532ac8e956a$var$useNavigateStable() {
    let { router: router } = $f52ca532ac8e956a$var$useDataRouterContext("useNavigate");
    let id = $f52ca532ac8e956a$var$useCurrentRouteId("useNavigate");
    let activeRef = $bh6RR.useRef(false);
    $bh6RR.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $bh6RR.useCallback(async (to, options = {})=>{
        (0, $07c07e885d25f310$export$491112666e282270)(activeRef.current, $f52ca532ac8e956a$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $f52ca532ac8e956a$var$alreadyWarned = {};
function $f52ca532ac8e956a$var$warningOnce(key, cond, message) {
    if (!cond && !$f52ca532ac8e956a$var$alreadyWarned[key]) {
        $f52ca532ac8e956a$var$alreadyWarned[key] = true;
        (0, $07c07e885d25f310$export$491112666e282270)(false, message);
    }
}
function $f52ca532ac8e956a$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $f52ca532ac8e956a$var$useCurrentRouteId("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $f52ca532ac8e956a$var$useDataRouterState("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $f52ca532ac8e956a$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $f52ca532ac8e956a$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $f52ca532ac8e956a$var$useDataRouterState("unstable_useRouterState");
    let active = $bh6RR.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$f52ca532ac8e956a$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $bh6RR.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$f52ca532ac8e956a$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $bh6RR.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 





/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $2bbdd21f534e700e$var$alreadyWarned = {};
function $2bbdd21f534e700e$export$5b28268982f175ba(condition, message) {
    if (!condition && !$2bbdd21f534e700e$var$alreadyWarned[message]) {
        $2bbdd21f534e700e$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $bh6RR = parcelRequire("bh6RR");
//#region lib/components.tsx
const $1447dc01ee3ce886$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $1447dc01ee3ce886$export$f30f7e456d254e83(routes, opts) {
    return (0, $f7ec0efaa1916726$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $07c07e885d25f310$export$2b76ad033c6e6d08)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $32f955841b0fe350$export$6bc17138063be773),
        hydrationRouteProperties: $1447dc01ee3ce886$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $1447dc01ee3ce886$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $1447dc01ee3ce886$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $789cee98db7f5cca$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $bh6RR.useState(router.state);
    let [state, setOptimisticState] = (0, $bh6RR.useOptimistic)(_state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(/* @__PURE__ */ new Map());
    let setState = $bh6RR.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $32f955841b0fe350$export$d738435097971c09)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $2bbdd21f534e700e$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $2bbdd21f534e700e$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $bh6RR.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$1447dc01ee3ce886$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $1447dc01ee3ce886$var$Deferred());
    }, [
        vtContext
    ]);
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $bh6RR.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$1447dc01ee3ce886$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$315e3ffb01f217).Provider, {
        value: state
    }, /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$cb3f1df1bef00a39).Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $bh6RR.createElement($1447dc01ee3ce886$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $bh6RR.createElement($1447dc01ee3ce886$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $1447dc01ee3ce886$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $1447dc01ee3ce886$var$MemoizedDataRoutes = $bh6RR.memo($1447dc01ee3ce886$export$699f06c8afb533c9);
function $1447dc01ee3ce886$export$699f06c8afb533c9({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return (0, $f52ca532ac8e956a$export$f7ce0646a48561fb)(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $1447dc01ee3ce886$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $bh6RR.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $07c07e885d25f310$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($1447dc01ee3ce886$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $1447dc01ee3ce886$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $07c07e885d25f310$export$f5708dca728d7177)((0, $f52ca532ac8e956a$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    (0, $07c07e885d25f310$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let navigate = (0, $f52ca532ac8e956a$export$9770f232ac06a008)();
    let path = (0, $32f955841b0fe350$export$cae722b0cc860f13)(to, (0, $32f955841b0fe350$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    (0, $fe0e33ca47261b38$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $07c07e885d25f310$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $fe0e33ca47261b38$export$1da545bc000055cf)(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $1447dc01ee3ce886$export$910ae8079b2c2852(props) {
    return (0, $f52ca532ac8e956a$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $1447dc01ee3ce886$export$e7b0ac011bb776c6(props) {
    (0, $07c07e885d25f310$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $1447dc01ee3ce886$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $07c07e885d25f310$export$f5708dca728d7177)(!(0, $f52ca532ac8e956a$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $07c07e885d25f310$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $32f955841b0fe350$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $07c07e885d25f310$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $1447dc01ee3ce886$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $f52ca532ac8e956a$export$5d3fca4a98652595)($1447dc01ee3ce886$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $1447dc01ee3ce886$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $bh6RR.useContext((0, $789cee98db7f5cca$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $bh6RR.useContext((0, $789cee98db7f5cca$export$315e3ffb01f217));
    let onError = $bh6RR.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $32f955841b0fe350$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($1447dc01ee3ce886$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $bh6RR.createElement($1447dc01ee3ce886$var$ResolveAwait, null, children));
}
var $1447dc01ee3ce886$var$AwaitErrorBoundary = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $bh6RR.createElement((0, $789cee98db7f5cca$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $1447dc01ee3ce886$var$ResolveAwait({ children: children }) {
    let data = (0, $f52ca532ac8e956a$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $1447dc01ee3ce886$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!$bh6RR.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            routes.push.apply(routes, $1447dc01ee3ce886$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $07c07e885d25f310$export$f5708dca728d7177)(element.type === $1447dc01ee3ce886$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $07c07e885d25f310$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $1447dc01ee3ce886$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $1447dc01ee3ce886$export$9b5b6d122dea0c88 = $1447dc01ee3ce886$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $1447dc01ee3ce886$export$daf73786167a7f72(matches) {
    return (0, $f52ca532ac8e956a$export$569816e95a012c39)(matches);
}
function $1447dc01ee3ce886$var$useRouteComponentProps() {
    return {
        params: (0, $f52ca532ac8e956a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $f52ca532ac8e956a$export$1448a5050d252c4d)(),
        actionData: (0, $f52ca532ac8e956a$export$fdc00f3f26066d5e)(),
        matches: (0, $f52ca532ac8e956a$export$2378eb7f5ff86053)()
    };
}
function $1447dc01ee3ce886$export$6c4f3826290c37af({ children: children }) {
    const props = $1447dc01ee3ce886$var$useRouteComponentProps();
    return $bh6RR.cloneElement(children, props);
}
function $1447dc01ee3ce886$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $1447dc01ee3ce886$var$useRouteComponentProps();
        return $bh6RR.createElement(Component, props);
    };
}
function $1447dc01ee3ce886$var$useHydrateFallbackProps() {
    return {
        params: (0, $f52ca532ac8e956a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $f52ca532ac8e956a$export$1448a5050d252c4d)(),
        actionData: (0, $f52ca532ac8e956a$export$fdc00f3f26066d5e)()
    };
}
function $1447dc01ee3ce886$export$f8cff34f39c1932a({ children: children }) {
    const props = $1447dc01ee3ce886$var$useHydrateFallbackProps();
    return $bh6RR.cloneElement(children, props);
}
function $1447dc01ee3ce886$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $1447dc01ee3ce886$var$useHydrateFallbackProps();
        return $bh6RR.createElement(HydrateFallback, props);
    };
}
function $1447dc01ee3ce886$var$useErrorBoundaryProps() {
    return {
        params: (0, $f52ca532ac8e956a$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $f52ca532ac8e956a$export$1448a5050d252c4d)(),
        actionData: (0, $f52ca532ac8e956a$export$fdc00f3f26066d5e)(),
        error: (0, $f52ca532ac8e956a$export$ed527bf60f6e05f2)()
    };
}
function $1447dc01ee3ce886$export$e5afde5c4b6d747b({ children: children }) {
    const props = $1447dc01ee3ce886$var$useErrorBoundaryProps();
    return $bh6RR.cloneElement(children, props);
}
function $1447dc01ee3ce886$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $1447dc01ee3ce886$var$useErrorBoundaryProps();
        return $bh6RR.createElement(ErrorBoundary, props);
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $c313b94c0cc4dd82$var$defaultEncType = "application/x-www-form-urlencoded";
function $c313b94c0cc4dd82$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $c313b94c0cc4dd82$var$isButtonElement(object) {
    return $c313b94c0cc4dd82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c313b94c0cc4dd82$var$isFormElement(object) {
    return $c313b94c0cc4dd82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c313b94c0cc4dd82$var$isInputElement(object) {
    return $c313b94c0cc4dd82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c313b94c0cc4dd82$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c313b94c0cc4dd82$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$c313b94c0cc4dd82$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $c313b94c0cc4dd82$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c313b94c0cc4dd82$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $c313b94c0cc4dd82$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $c313b94c0cc4dd82$var$_formDataSupportsSubmitter = null;
function $c313b94c0cc4dd82$var$isFormDataSubmitterSupported() {
    if ($c313b94c0cc4dd82$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $c313b94c0cc4dd82$var$_formDataSupportsSubmitter = false;
    } catch  {
        $c313b94c0cc4dd82$var$_formDataSupportsSubmitter = true;
    }
    return $c313b94c0cc4dd82$var$_formDataSupportsSubmitter;
}
const $c313b94c0cc4dd82$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c313b94c0cc4dd82$var$getFormEncType(encType) {
    if (encType != null && !$c313b94c0cc4dd82$var$supportedFormEncTypes.has(encType)) {
        (0, $07c07e885d25f310$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$c313b94c0cc4dd82$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $c313b94c0cc4dd82$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c313b94c0cc4dd82$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $32f955841b0fe350$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $c313b94c0cc4dd82$var$getFormEncType(target.getAttribute("enctype")) || $c313b94c0cc4dd82$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c313b94c0cc4dd82$var$isButtonElement(target) || $c313b94c0cc4dd82$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $32f955841b0fe350$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $c313b94c0cc4dd82$var$getFormEncType(target.getAttribute("formenctype")) || $c313b94c0cc4dd82$var$getFormEncType(form.getAttribute("enctype")) || $c313b94c0cc4dd82$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$c313b94c0cc4dd82$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c313b94c0cc4dd82$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $c313b94c0cc4dd82$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $fd0f34fca69ce5d5$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $fd0f34fca69ce5d5$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $fd0f34fca69ce5d5$export$4cf11838cdc2a8a8(html) {
    return html.replace($fd0f34fca69ce5d5$var$ESCAPE_REGEX, (match)=>$fd0f34fca69ce5d5$var$ESCAPE_LOOKUP[match]);
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $f7955202df1b4a17$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $6ddbda2091fdc030$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $6ddbda2091fdc030$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $6ddbda2091fdc030$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $74e31477314b1d8c$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $74e31477314b1d8c$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $74e31477314b1d8c$export$442b9e023f41af00(matches, manifest));
}
function $74e31477314b1d8c$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $74e31477314b1d8c$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $74e31477314b1d8c$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($74e31477314b1d8c$var$prefetchStyleLink));
}
async function $74e31477314b1d8c$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$74e31477314b1d8c$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$74e31477314b1d8c$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$74e31477314b1d8c$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($74e31477314b1d8c$var$prefetchStyleLink));
}
async function $74e31477314b1d8c$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $74e31477314b1d8c$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $74e31477314b1d8c$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $74e31477314b1d8c$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $74e31477314b1d8c$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $6ddbda2091fdc030$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($74e31477314b1d8c$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $74e31477314b1d8c$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $74e31477314b1d8c$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $74e31477314b1d8c$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $74e31477314b1d8c$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $74e31477314b1d8c$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $74e31477314b1d8c$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$74e31477314b1d8c$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($74e31477314b1d8c$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $74e31477314b1d8c$var$_isPreloadSupported;
function $74e31477314b1d8c$var$isPreloadSupported() {
    if ($74e31477314b1d8c$var$_isPreloadSupported !== void 0) return $74e31477314b1d8c$var$_isPreloadSupported;
    let el = document.createElement("link");
    $74e31477314b1d8c$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $74e31477314b1d8c$var$_isPreloadSupported;
}



/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $ebdbdd3324c40ea4$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $ebdbdd3324c40ea4$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $f6fbf387323a44c3$var$TIME_LIMIT_MS = 1;
const $f6fbf387323a44c3$var$getNow = ()=>Date.now();
const $f6fbf387323a44c3$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $f6fbf387323a44c3$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $f6fbf387323a44c3$var$stringify.call(this, stack);
    return index;
}
async function $f6fbf387323a44c3$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $f6fbf387323a44c3$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $f6fbf387323a44c3$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $f6fbf387323a44c3$var$TIME_LIMIT_MS) {
            await $f6fbf387323a44c3$var$yieldToMain();
            lastYieldTime = $f6fbf387323a44c3$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($f6fbf387323a44c3$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $f6fbf387323a44c3$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $f6fbf387323a44c3$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $f6fbf387323a44c3$var$objectProtoNames;
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $b7affff1c5d0ae22$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $b7affff1c5d0ae22$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $b7affff1c5d0ae22$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $b7affff1c5d0ae22$var$hydrate.call(this, startIndex);
}
function $b7affff1c5d0ae22$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $ebdbdd3324c40ea4$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $b7affff1c5d0ae22$var$globalObj && (0, $32f955841b0fe350$export$1a235bd2b33434e5).includes(errorType) && errorType in $b7affff1c5d0ae22$var$globalObj && typeof $b7affff1c5d0ae22$var$globalObj[errorType] === "function" ? new $b7affff1c5d0ae22$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $b532e8aea9266ebd$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $ebdbdd3324c40ea4$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $ebdbdd3324c40ea4$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $b532e8aea9266ebd$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $b532e8aea9266ebd$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $b532e8aea9266ebd$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch  {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $b7affff1c5d0ae22$export$4315a2af848d75d7).call(this, line)
    };
}
async function $b532e8aea9266ebd$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $b7affff1c5d0ae22$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $b7affff1c5d0ae22$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $b532e8aea9266ebd$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $f6fbf387323a44c3$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $f6fbf387323a44c3$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $f6fbf387323a44c3$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $3a1b713edf321592$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $bh6RR = parcelRequire("bh6RR");
//#region lib/dom/ssr/single-fetch.tsx
const $2e61da39772d1c70$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $2e61da39772d1c70$var$SingleFetchNoResultError = class extends Error {
};
const $2e61da39772d1c70$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $2e61da39772d1c70$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $bh6RR.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $fd0f34fca69ce5d5$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, scriptTag, /* @__PURE__ */ $bh6RR.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, scriptTag, /* @__PURE__ */ $bh6RR.createElement($bh6RR.Suspense, null, /* @__PURE__ */ $bh6RR.createElement($2e61da39772d1c70$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $2e61da39772d1c70$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    let dataStrategy = $2e61da39772d1c70$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $2e61da39772d1c70$var$fetchAndDecodeViaTurboStream, ssr);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $2e61da39772d1c70$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $2e61da39772d1c70$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $2e61da39772d1c70$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $2e61da39772d1c70$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $2e61da39772d1c70$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut);
    };
}
async function $2e61da39772d1c70$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $2e61da39772d1c70$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $f7ec0efaa1916726$export$3f1eb41d9a6a6a27)(result.result) || (0, $32f955841b0fe350$export$972111febbeef05b)(result.result) || (0, $f7ec0efaa1916726$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $32f955841b0fe350$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $2e61da39772d1c70$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data } = await fetchAndDecode(args, [
                        routeId
                    ]);
                    return $2e61da39772d1c70$var$unwrapSingleFetchResult(data, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $2e61da39772d1c70$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$2e61da39772d1c70$var$createDeferred());
    let singleFetchDfd = $2e61da39772d1c70$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $2e61da39772d1c70$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $2e61da39772d1c70$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $2e61da39772d1c70$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $2e61da39772d1c70$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $2e61da39772d1c70$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch  {}
}
async function $2e61da39772d1c70$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $2e61da39772d1c70$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $2e61da39772d1c70$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $2e61da39772d1c70$export$7b977381851b2c(reqUrl, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
async function $2e61da39772d1c70$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    let { request: request } = args;
    let url = $2e61da39772d1c70$export$7b977381851b2c(request.url, "data");
    if (request.method === "GET") {
        url = $2e61da39772d1c70$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await (0, $3a1b713edf321592$export$a30aa2a0fce6c468)(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $32f955841b0fe350$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: 202,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($2e61da39772d1c70$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(res.body, "No response body to decode");
    try {
        let decoded = await $2e61da39772d1c70$export$4023ad4ecd4126a2(res.body, window);
        let data;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($2e61da39772d1c70$export$60644022b8b46aaa in typed) data = {
                redirect: typed[$2e61da39772d1c70$export$60644022b8b46aaa]
            };
            else data = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data = {
                redirect: typed
            };
            else data = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data
        };
    } catch  {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $2e61da39772d1c70$export$4023ad4ecd4126a2(body, global) {
    return (0, $b532e8aea9266ebd$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $32f955841b0fe350$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $32f955841b0fe350$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$2e61da39772d1c70$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $2e61da39772d1c70$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $32f955841b0fe350$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $2e61da39772d1c70$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $2e61da39772d1c70$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $bh6RR = parcelRequire("bh6RR");
//#region lib/dom/ssr/errorBoundaries.tsx
var $b84b3622fb011d7c$export$32e57f52df4b6e34 = class extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $bh6RR.createElement($b84b3622fb011d7c$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $b84b3622fb011d7c$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $cd0a1d2f9536e3fa$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $bh6RR.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $32f955841b0fe350$export$972111febbeef05b)(error)) return /* @__PURE__ */ $bh6RR.createElement($b84b3622fb011d7c$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $bh6RR.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $bh6RR.createElement($b84b3622fb011d7c$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $bh6RR.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $bh6RR.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $b84b3622fb011d7c$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $cd0a1d2f9536e3fa$export$17134ff624fc6bc2)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $bh6RR.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $bh6RR.createElement("head", null, /* @__PURE__ */ $bh6RR.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $bh6RR.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $bh6RR.createElement("title", null, title)), /* @__PURE__ */ $bh6RR.createElement("body", null, /* @__PURE__ */ $bh6RR.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $bh6RR.createElement((0, $cd0a1d2f9536e3fa$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $bh6RR = parcelRequire("bh6RR");
//#region lib/dom/ssr/fallback.tsx
function $cfecd2c433b75d17$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $cd0a1d2f9536e3fa$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $bh6RR.createElement((0, $b84b3622fb011d7c$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $bh6RR = parcelRequire("bh6RR");
//#region lib/dom/ssr/routes.tsx
function $20ea7a402899db6d$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $20ea7a402899db6d$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $20ea7a402899db6d$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $cfecd2c433b75d17$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $bh6RR.createElement((0, $b84b3622fb011d7c$export$20b33acd14692c9), {
            error: (0, $f52ca532ac8e956a$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $bh6RR.createElement(routeModule.Layout, null, /* @__PURE__ */ $bh6RR.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $20ea7a402899db6d$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $20ea7a402899db6d$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$20ea7a402899db6d$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $20ea7a402899db6d$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $20ea7a402899db6d$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $20ea7a402899db6d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $20ea7a402899db6d$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $20ea7a402899db6d$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $32f955841b0fe350$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $20ea7a402899db6d$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $32f955841b0fe350$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $20ea7a402899db6d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $20ea7a402899db6d$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $20ea7a402899db6d$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $74e31477314b1d8c$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$20ea7a402899db6d$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $20ea7a402899db6d$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $20ea7a402899db6d$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $20ea7a402899db6d$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $20ea7a402899db6d$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $20ea7a402899db6d$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $20ea7a402899db6d$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $20ea7a402899db6d$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $20ea7a402899db6d$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $20ea7a402899db6d$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $20ea7a402899db6d$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $20ea7a402899db6d$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $20ea7a402899db6d$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $20ea7a402899db6d$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $32f955841b0fe350$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $20ea7a402899db6d$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $20ea7a402899db6d$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $6ddbda2091fdc030$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $74e31477314b1d8c$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $74e31477314b1d8c$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $20ea7a402899db6d$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $20ea7a402899db6d$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $20ea7a402899db6d$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $bh6RR = parcelRequire("bh6RR");
//#region lib/dom/ssr/fog-of-war.ts
const $f00093fdbfdcbdd0$var$nextPaths = /* @__PURE__ */ new Set();
const $f00093fdbfdcbdd0$var$discoveredPathsMaxSize = 1e3;
const $f00093fdbfdcbdd0$var$discoveredPaths = /* @__PURE__ */ new Set();
const $f00093fdbfdcbdd0$export$b5915cf27fa06b9f = 7680;
function $f00093fdbfdcbdd0$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $f00093fdbfdcbdd0$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $f00093fdbfdcbdd0$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = (0, $32f955841b0fe350$export$5c7b09132f833c25)(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $f00093fdbfdcbdd0$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$f00093fdbfdcbdd0$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($f00093fdbfdcbdd0$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $f00093fdbfdcbdd0$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $07c07e885d25f310$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $f00093fdbfdcbdd0$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $bh6RR.useEffect(()=>{
        if (!$f00093fdbfdcbdd0$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$f00093fdbfdcbdd0$var$discoveredPaths.has(pathname)) $f00093fdbfdcbdd0$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($f00093fdbfdcbdd0$var$nextPaths.keys()).filter((path)=>{
                if ($f00093fdbfdcbdd0$var$discoveredPaths.has(path)) {
                    $f00093fdbfdcbdd0$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $f00093fdbfdcbdd0$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $f00093fdbfdcbdd0$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $f00093fdbfdcbdd0$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $32f955841b0fe350$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $f00093fdbfdcbdd0$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $f00093fdbfdcbdd0$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if (!needsReload) {
        try {
            sessionStorage.removeItem($f00093fdbfdcbdd0$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    try {
        if (sessionStorage.getItem($f00093fdbfdcbdd0$var$MANIFEST_VERSION_STORAGE_KEY) === version) {
            console.error("Unable to discover routes due to manifest version mismatch.");
            return true;
        }
        sessionStorage.setItem($f00093fdbfdcbdd0$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    window.location.href = errorReloadPath;
    console.warn("Detected manifest version mismatch, reloading...");
    await new Promise(()=>{});
    return true;
}
async function $f00093fdbfdcbdd0$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $f00093fdbfdcbdd0$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($f00093fdbfdcbdd0$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $f00093fdbfdcbdd0$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $f00093fdbfdcbdd0$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    if (signal?.aborted) return;
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$f00093fdbfdcbdd0$var$addToFifoQueue(p, $f00093fdbfdcbdd0$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $20ea7a402899db6d$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $f00093fdbfdcbdd0$var$addToFifoQueue(path, queue) {
    if (queue.size >= $f00093fdbfdcbdd0$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $f00093fdbfdcbdd0$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $bh6RR = parcelRequire("bh6RR");
//#region lib/dom/ssr/components.tsx
function $cd0a1d2f9536e3fa$var$useDataRouterContext() {
    let context = $bh6RR.useContext((0, $789cee98db7f5cca$export$2eeee58951ff3c1c));
    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $cd0a1d2f9536e3fa$var$useDataRouterStateContext() {
    let context = $bh6RR.useContext((0, $789cee98db7f5cca$export$315e3ffb01f217));
    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
const $cd0a1d2f9536e3fa$export$208d6a3bc3aa62bd = $bh6RR.createContext(void 0);
$cd0a1d2f9536e3fa$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $cd0a1d2f9536e3fa$export$17134ff624fc6bc2() {
    let context = $bh6RR.useContext($cd0a1d2f9536e3fa$export$208d6a3bc3aa62bd);
    (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $cd0a1d2f9536e3fa$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $bh6RR.useContext($cd0a1d2f9536e3fa$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $bh6RR.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $bh6RR.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $bh6RR.useRef(null);
    $bh6RR.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $bh6RR.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $cd0a1d2f9536e3fa$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $cd0a1d2f9536e3fa$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $cd0a1d2f9536e3fa$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $cd0a1d2f9536e3fa$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $cd0a1d2f9536e3fa$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $cd0a1d2f9536e3fa$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $cd0a1d2f9536e3fa$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$cd0a1d2f9536e3fa$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $cd0a1d2f9536e3fa$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $cd0a1d2f9536e3fa$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $cd0a1d2f9536e3fa$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches } = $cd0a1d2f9536e3fa$var$useDataRouterStateContext();
    let matches = $cd0a1d2f9536e3fa$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $bh6RR.useMemo(()=>(0, $74e31477314b1d8c$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $bh6RR.createElement("style", {
        [$cd0a1d2f9536e3fa$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $bh6RR.createElement("link", {
        [$cd0a1d2f9536e3fa$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $74e31477314b1d8c$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $bh6RR.createElement($cd0a1d2f9536e3fa$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $bh6RR.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $cd0a1d2f9536e3fa$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $789cee98db7f5cca$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $cd0a1d2f9536e3fa$export$17134ff624fc6bc2();
    let { router: router } = $cd0a1d2f9536e3fa$var$useDataRouterContext();
    let matches = $bh6RR.useMemo(()=>(0, $32f955841b0fe350$export$2708184779ceb39d)(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $bh6RR.createElement($cd0a1d2f9536e3fa$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $bh6RR.createElement($cd0a1d2f9536e3fa$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $cd0a1d2f9536e3fa$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $cd0a1d2f9536e3fa$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $bh6RR.useState([]);
    $bh6RR.useEffect(()=>{
        let interrupted = false;
        (0, $74e31477314b1d8c$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $cd0a1d2f9536e3fa$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let dataHrefs = $bh6RR.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $2e61da39772d1c70$export$7b977381851b2c)(page, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $cd0a1d2f9536e3fa$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules } = $cd0a1d2f9536e3fa$export$17134ff624fc6bc2();
    let { loaderData: loaderData, matches: matches } = $cd0a1d2f9536e3fa$var$useDataRouterStateContext();
    let newMatchesForData = $bh6RR.useMemo(()=>(0, $74e31477314b1d8c$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $bh6RR.useMemo(()=>(0, $74e31477314b1d8c$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $bh6RR.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $2e61da39772d1c70$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $bh6RR.useMemo(()=>(0, $74e31477314b1d8c$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $cd0a1d2f9536e3fa$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $cd0a1d2f9536e3fa$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $cd0a1d2f9536e3fa$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $cd0a1d2f9536e3fa$var$useDataRouterStateContext();
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let _matches = $cd0a1d2f9536e3fa$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$cd0a1d2f9536e3fa$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $bh6RR.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $bh6RR.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $bh6RR.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $bh6RR.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $fd0f34fca69ce5d5$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch  {
            return null;
        }
        return /* @__PURE__ */ $bh6RR.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $cd0a1d2f9536e3fa$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $cd0a1d2f9536e3fa$var$isHydrated = false;
function $cd0a1d2f9536e3fa$export$3be068dde909e563() {
    $cd0a1d2f9536e3fa$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $cd0a1d2f9536e3fa$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $cd0a1d2f9536e3fa$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = $cd0a1d2f9536e3fa$var$useDataRouterContext();
    let { matches: routerMatches } = $cd0a1d2f9536e3fa$var$useDataRouterStateContext();
    let isRSCRouterContext = (0, $789cee98db7f5cca$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $f00093fdbfdcbdd0$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $cd0a1d2f9536e3fa$var$getActiveMatches(routerMatches, null, isSpaMode);
    $bh6RR.useEffect(()=>{
        $cd0a1d2f9536e3fa$export$3be068dde909e563();
    }, []);
    let initialScripts = $bh6RR.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $f7955202df1b4a17$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $f00093fdbfdcbdd0$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, /* @__PURE__ */ $bh6RR.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $bh6RR.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $cd0a1d2f9536e3fa$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $74e31477314b1d8c$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $2bbdd21f534e700e$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $cd0a1d2f9536e3fa$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $bh6RR.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $bh6RR.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $bh6RR.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $bh6RR.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $cd0a1d2f9536e3fa$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $bh6RR = parcelRequire("bh6RR");
//#region lib/dom/lib.tsx
const $6110e6c0b53a684b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($6110e6c0b53a684b$var$isBrowser) window.__reactRouterVersion = "8";
} catch  {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $6110e6c0b53a684b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f7ec0efaa1916726$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $07c07e885d25f310$export$719fc203c4e16dee)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $6110e6c0b53a684b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $32f955841b0fe350$export$6bc17138063be773),
        hydrationRouteProperties: $1447dc01ee3ce886$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $6110e6c0b53a684b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f7ec0efaa1916726$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $07c07e885d25f310$export$b71fdd3798280242)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $6110e6c0b53a684b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $32f955841b0fe350$export$6bc17138063be773),
        hydrationRouteProperties: $1447dc01ee3ce886$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $6110e6c0b53a684b$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $6110e6c0b53a684b$var$deserializeErrors(state.errors)
    };
    return state;
}
function $6110e6c0b53a684b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $32f955841b0fe350$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $32f955841b0fe350$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch  {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $6110e6c0b53a684b$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $bh6RR.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $07c07e885d25f310$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement((0, $1447dc01ee3ce886$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $6110e6c0b53a684b$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $bh6RR.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $07c07e885d25f310$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement((0, $1447dc01ee3ce886$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $6110e6c0b53a684b$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let setState = $bh6RR.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $bh6RR.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $bh6RR.createElement((0, $1447dc01ee3ce886$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$6110e6c0b53a684b$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $6110e6c0b53a684b$export$a6c7ac8248d6e38a = $bh6RR.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $0708bf9e8ef239fb$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $32f955841b0fe350$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $f52ca532ac8e956a$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $32f955841b0fe350$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $32f955841b0fe350$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $cd0a1d2f9536e3fa$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $6110e6c0b53a684b$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $bh6RR.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $cd0a1d2f9536e3fa$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $bh6RR.createElement($bh6RR.Fragment, null, link, /* @__PURE__ */ $bh6RR.createElement((0, $cd0a1d2f9536e3fa$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$6110e6c0b53a684b$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $6110e6c0b53a684b$export$b0d92dbee9b5b60d = $bh6RR.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $f52ca532ac8e956a$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let routerState = $bh6RR.useContext((0, $789cee98db7f5cca$export$315e3ffb01f217));
    let { navigator: navigator, basename: basename } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let isTransitioning = routerState != null && $6110e6c0b53a684b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $32f955841b0fe350$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $bh6RR.createElement($6110e6c0b53a684b$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$6110e6c0b53a684b$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $6110e6c0b53a684b$export$a7fed597f4b8afd8 = $bh6RR.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let submit = $6110e6c0b53a684b$export$47c85c6e3a081d3();
    let formAction = $6110e6c0b53a684b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $0708bf9e8ef239fb$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $bh6RR.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $bh6RR.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$6110e6c0b53a684b$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $6110e6c0b53a684b$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $bh6RR.useContext((0, $cd0a1d2f9536e3fa$export$208d6a3bc3aa62bd));
    let { basename: basename } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let matches = (0, $f52ca532ac8e956a$export$2378eb7f5ff86053)();
    $6110e6c0b53a684b$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $bh6RR.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $6110e6c0b53a684b$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $bh6RR.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $fd0f34fca69ce5d5$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $6110e6c0b53a684b$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $fd0f34fca69ce5d5$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    });
}
$6110e6c0b53a684b$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $6110e6c0b53a684b$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $6110e6c0b53a684b$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $789cee98db7f5cca$export$2eeee58951ff3c1c));
    (0, $07c07e885d25f310$export$f5708dca728d7177)(ctx, $6110e6c0b53a684b$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $6110e6c0b53a684b$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $789cee98db7f5cca$export$315e3ffb01f217));
    (0, $07c07e885d25f310$export$f5708dca728d7177)(state, $6110e6c0b53a684b$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $6110e6c0b53a684b$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $f52ca532ac8e956a$export$9770f232ac06a008)();
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let path = (0, $f52ca532ac8e956a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ((0, $c313b94c0cc4dd82$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $07c07e885d25f310$export$fe53371bee54353d)(location) === (0, $07c07e885d25f310$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $bh6RR.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $6110e6c0b53a684b$export$f1a78c17382fe22a(defaultInit) {
    (0, $07c07e885d25f310$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $bh6RR.useRef((0, $c313b94c0cc4dd82$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let searchParams = $bh6RR.useMemo(()=>(0, $c313b94c0cc4dd82$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $f52ca532ac8e956a$export$9770f232ac06a008)();
    return [
        searchParams,
        $bh6RR.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $c313b94c0cc4dd82$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $6110e6c0b53a684b$var$fetcherId = 0;
let $6110e6c0b53a684b$var$getUniqueFetcherId = ()=>`__${String(++$6110e6c0b53a684b$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $6110e6c0b53a684b$export$47c85c6e3a081d3() {
    let { router: router } = $6110e6c0b53a684b$var$useDataRouterContext("useSubmit");
    let { basename: basename } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $f52ca532ac8e956a$export$4200b254756b08af)();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $bh6RR.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $c313b94c0cc4dd82$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $6110e6c0b53a684b$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $6110e6c0b53a684b$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let routeContext = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    (0, $07c07e885d25f310$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $f52ca532ac8e956a$export$e75d2a2d1b3c245b)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $32f955841b0fe350$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $07c07e885d25f310$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $6110e6c0b53a684b$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $6110e6c0b53a684b$var$useDataRouterContext("useFetcher");
    let state = $6110e6c0b53a684b$var$useDataRouterState("useFetcher");
    let fetcherData = $bh6RR.useContext((0, $789cee98db7f5cca$export$cb3f1df1bef00a39));
    let route = $bh6RR.useContext((0, $789cee98db7f5cca$export$aac280ed165a4397));
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    (0, $07c07e885d25f310$export$f5708dca728d7177)(fetcherData, `useFetcher must be used inside a FetchersContext`);
    (0, $07c07e885d25f310$export$f5708dca728d7177)(route, `useFetcher must be used inside a RouteContext`);
    (0, $07c07e885d25f310$export$f5708dca728d7177)(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $bh6RR.useId();
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $bh6RR.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $bh6RR.useCallback(async (href, opts)=>{
        (0, $07c07e885d25f310$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $6110e6c0b53a684b$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $bh6RR.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm = $bh6RR.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $bh6RR.createElement($6110e6c0b53a684b$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || (0, $f7ec0efaa1916726$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    return $bh6RR.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $6110e6c0b53a684b$export$fa996778a3a31087() {
    let state = $6110e6c0b53a684b$var$useDataRouterState("useFetchers");
    return $bh6RR.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
const $6110e6c0b53a684b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $6110e6c0b53a684b$var$savedScrollPositions = {};
function $6110e6c0b53a684b$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $32f955841b0fe350$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $6110e6c0b53a684b$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $6110e6c0b53a684b$var$useDataRouterContext("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $6110e6c0b53a684b$var$useDataRouterState("useScrollRestoration");
    let { basename: basename } = $bh6RR.useContext((0, $789cee98db7f5cca$export$3044ab7fdabeaee6));
    let location = (0, $f52ca532ac8e956a$export$45d76561a5302f2b)();
    let matches = (0, $f52ca532ac8e956a$export$2378eb7f5ff86053)();
    let navigation = (0, $f52ca532ac8e956a$export$d0fd4b7106de2769)();
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $6110e6c0b53a684b$var$usePageShow($bh6RR.useCallback((event)=>{
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $6110e6c0b53a684b$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $6110e6c0b53a684b$var$getScrollRestorationKey(location, matches, basename, getKey);
            $6110e6c0b53a684b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $6110e6c0b53a684b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($6110e6c0b53a684b$var$savedScrollPositions));
        } catch (error) {
            (0, $07c07e885d25f310$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $6110e6c0b53a684b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $6110e6c0b53a684b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch  {}
        }, [
            storageKey
        ]);
        $bh6RR.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($6110e6c0b53a684b$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$6110e6c0b53a684b$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $bh6RR.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $07c07e885d25f310$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $6110e6c0b53a684b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $6110e6c0b53a684b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $6110e6c0b53a684b$var$usePageShow(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return ()=>{
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $6110e6c0b53a684b$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $f52ca532ac8e956a$export$b273b3273281a049)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $6110e6c0b53a684b$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $bh6RR.useContext((0, $789cee98db7f5cca$export$3681f408decb40d1));
    (0, $07c07e885d25f310$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $6110e6c0b53a684b$var$useDataRouterContext("useViewTransitionState");
    let path = (0, $f52ca532ac8e956a$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $32f955841b0fe350$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $32f955841b0fe350$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $32f955841b0fe350$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $32f955841b0fe350$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
const $f6271c11b4093765$var$Header = (props)=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        "data-testid": "header",
        style: {
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)("h1", {
            children: props.children
        })
    });
};
var $f6271c11b4093765$export$2e2bcd8739ae039 = $f6271c11b4093765$var$Header;





var $ih19M = parcelRequire("ih19M");
parcelRequire("bh6RR");
var $9f5a7d73bb2a9c50$export$adb608be33961c98;
$9f5a7d73bb2a9c50$export$adb608be33961c98 = `_7lECra_footer`;


const $1fa184cd0ea1168a$var$Footer = (props)=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        "data-testid": "footer",
        className: $9f5a7d73bb2a9c50$export$adb608be33961c98,
        children: props.children
    });
};
var $1fa184cd0ea1168a$export$2e2bcd8739ae039 = $1fa184cd0ea1168a$var$Footer;




parcelRequire("gggdZ");
var $5E0NG = parcelRequire("5E0NG");

const $36fdfd15ce5f504a$var$Resume = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).lazy(()=>(parcelRequire("bC0hQ")));
const $36fdfd15ce5f504a$var$router = (0, $6110e6c0b53a684b$export$1f3f55432a00e06d)([
    {
        path: '/',
        element: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $f6271c11b4093765$export$2e2bcd8739ae039), {
                    children: "justin-shepard.net"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $6110e6c0b53a684b$export$a6c7ac8248d6e38a), {
                    to: "resume",
                    children: "Resume"
                })
            ]
        })
    },
    {
        path: '/resume',
        element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $ih19M.jsx)((0, $5E0NG.default), {}),
            children: /*#__PURE__*/ (0, $ih19M.jsx)($36fdfd15ce5f504a$var$Resume, {})
        })
    }
]);
const $36fdfd15ce5f504a$var$App = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1447dc01ee3ce886$export$323e4fc2fa4753fb), {
                router: $36fdfd15ce5f504a$var$router
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1fa184cd0ea1168a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                    href: "https://github.com/gyrfalcon/justin-shepard.net",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "GitHub"
                })
            })
        ]
    });
};
var $36fdfd15ce5f504a$export$2e2bcd8739ae039 = $36fdfd15ce5f504a$var$App;




const $343c6f933afb1bf3$var$rootElement = document.getElementById('root');
if ($343c6f933afb1bf3$var$rootElement) (0, $6fc264ec92100d3a$exports.createRoot)($343c6f933afb1bf3$var$rootElement).render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $36fdfd15ce5f504a$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=justin-shepard.net.982fd936.js.map
